import { Geometry } from '@tcc/shared-data-lib/dist/types/src/types/GeoJson';
import { GraphQLClient, RequestOptions } from 'graphql-request';
import { GraphQLError } from 'graphql'
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CountryCode: { input: string; output: string; }
  Currency: { input: string; output: string; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Decimal: { input: number; output: number; }
  Email: { input: string; output: string; }
  GeoJSONGeometry: { input: Geometry; output: Geometry; }
  JSON: { input: unknown; output: unknown; }
  Money: { input: number; output: number; }
  URL: { input: string; output: string; }
};

/** Input type for updating a planned crop on FieldPlan. */
export type UapiAddTagOnFieldPlanInput = {
  fieldPlanId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};

/** Additional settings Advisors have */
export type UapiAdvisorSettings = {
  __typename?: 'AdvisorSettings';
  seedBrandAffiliations: Array<UapiSeedBrand>;
};

/** The status of any correction done to the aggregated event. Applying a correction is an asynchronous process; the status encodes the possible 3 states in which a correction can exist. */
export enum UapiAggregatedEventCorrectionStatus {
  /** There might be one correction taking place, aggregate values are subject to change in the future. */
  CORRECTION_IN_PROGRESS = 'CORRECTION_IN_PROGRESS',
  /** A correction was attempted but was not successful after some time, user could retry making the correction. */
  CORRECTION_TIMED_OUT = 'CORRECTION_TIMED_OUT',
  /** There are no corrections applied to this aggregated event, or all of the previous corrections have been successfully computed. */
  NO_CORRECTION_PENDING = 'NO_CORRECTION_PENDING'
}

/** Represents an Agreement Template used for terms and conditions. */
export type UapiAgreementTemplate = UapiNode & {
  __typename?: 'AgreementTemplate';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Possible agronomic activities. */
export enum UapiAgronomicActivityType {
  HARVESTING = 'HARVESTING',
  PLANTING = 'PLANTING',
  PROTECTING = 'PROTECTING'
}

/** Possible notification types */
export enum UapiAlertType {
  /** Data Inbox notification type */
  DATA_INBOX = 'DATA_INBOX',
  /** Hail notification type */
  HAIL_ALERT = 'HAIL_ALERT',
  /** Imagery notification type */
  IMAGERY = 'IMAGERY',
  /** Non-Satellite Imagery notification type */
  NON_SAT_IMAGERY = 'NON_SAT_IMAGERY',
  /** Non-Sat Imagery Requires Attention notification type */
  NON_SAT_IMAGERY_REQUIRES_ATTENTION = 'NON_SAT_IMAGERY_REQUIRES_ATTENTION',
  /** Precipitation notification type */
  PRECIP = 'PRECIP',
  /** Soil Import Failure notification type */
  SOIL_FAILURE = 'SOIL_FAILURE',
  /** Soil Import Grower notification type */
  SOIL_GROWER = 'SOIL_GROWER',
  /** Soil Uploader notification type */
  SOIL_UPLOADER = 'SOIL_UPLOADER'
}

/**
 * A single application of chemicals for a specific crop, season, and year.  The application may span several days and
 * involve multiple passes with different machines and tank mixes.
 */
export type UapiApplicationEvent = {
  __typename?: 'ApplicationEvent';
  /** the area over which chemical products are applied */
  area: UapiMeasure;
  /** the rate at which the tank mixes (including water) are distributed on the field */
  averageApplicationRate?: Maybe<UapiMeasure>;
  averageMachineSpeed?: Maybe<UapiMeasure>;
  /** chemical products included in one or more tank mixes */
  chemicalProductsApplied?: Maybe<Array<UapiChemicalProductApplied>>;
  crop: UapiCrop;
  firstApplicationDateTime?: Maybe<Scalars['DateTime']['output']>;
  lastApplicationDateTime?: Maybe<Scalars['DateTime']['output']>;
  /**
   * optional, temporary legacySeasonTag to be used by Web and Mobile
   *   Web and Mobile front ends currently rely on the legacySeasonTag for processing and display
   *   We are including the legacySeasonTag for a period of time while the transition to SeasonName/SeasonYear is being performed
   *   Once the Web and Mobile code bases have been update to use SeasonName/SeasonYear the legacySeasonTag functionalty
   *   will be removed.
   * @deprecated Please use seasonName and seasonYear
   */
  legacySeasonTag?: Maybe<Scalars['String']['output']>;
  /** grower-specified name for the application event */
  name: Scalars['String']['output'];
  seasonName: UapiSeasonName;
  seasonYear: Scalars['Int']['output'];
  /**
   * total amount of the tank mixtures applied
   *
   *   Note that totalAmountApplied is null if different units (for liquid and solid) were used in the events.
   */
  totalAmountApplied?: Maybe<UapiMeasure>;
};

/**
 * Chemical application data aggregated for a single field.  This type is designed to be a sub-entity of the "Field" entity,
 * so that attributes supplied by other subgraphs, such as the field name and area, can be returned in a single call.
 */
export type UapiApplicationEventAggregates = {
  __typename?: 'ApplicationEventAggregates';
  averageApplicationRate?: Maybe<UapiMeasure>;
  averageMachineSpeed?: Maybe<UapiMeasure>;
  /** application events over which the data was aggregated */
  events: Array<UapiApplicationEvent>;
  /** the datetimes are undefined if there were no applications for the field */
  firstApplicationDateTime?: Maybe<Scalars['DateTime']['output']>;
  lastApplicationDateTime?: Maybe<Scalars['DateTime']['output']>;
  /**
   * total amount of the tank mixtures applied
   *
   *   Note that totalAmountApplied is null if different units (for liquid and solid) were used in the events.
   */
  totalAmountApplied?: Maybe<UapiMeasure>;
  totalApplicationsArea: UapiMeasure;
};

/**
 * Chemical application stats aggregated over a set of fields in a single operation.  Note that the first and last application
 * dates are probably only useful if the caller specified a single season and year in the query.
 */
export type UapiApplicationStatsForFieldSet = {
  __typename?: 'ApplicationStatsForFieldSet';
  /** fields for which the data was aggregated */
  fields: Array<UapiField>;
  /** the datetimes are undefined if there were no applications for the field set */
  firstApplicationDateTime?: Maybe<Scalars['DateTime']['output']>;
  lastApplicationDateTime?: Maybe<Scalars['DateTime']['output']>;
  numApplicationEvents: Scalars['Int']['output'];
  numChemicalProductsApplied: Scalars['Int']['output'];
  numFieldsWithApplicationEvents: Scalars['Int']['output'];
  totalApplicationsArea: UapiMeasure;
};

/**
 * Zone attributes for Prescription type: Application
 * https://gitlab.tcc.li/climate/cfvrec/saam/projects/prescription-manager/-/blob/main/prescription_manager/model/prescriptions/schema.py?ref_type=heads#L40-49
 *
 * ** @deprecated: Please use CropProtectionZone instead **
 */
export type UapiApplicationZone = UapiZone & {
  __typename?: 'ApplicationZone';
  area: UapiMeasure;
  geometry: Scalars['GeoJSONGeometry']['output'];
  id: Scalars['ID']['output'];
  isCheckStrip: Scalars['Boolean']['output'];
};

/**
 * The applied product represents a seed treatment, fertilizer, or other product applied.
 * ### Example
 * ```
 * {
 * "id": "537e024e-0000-0000-0000-105757f45a24",
 * "name": "NITRASEC PLUS",
 * "regulatorNumber": "32521",
 * "manufacturerName": "NITRASOIL",
 * "appliedTypes": [
 * "COMMERCIAL FERTILIZER",
 * "SEED TREATMENT",
 * "FUNGICIDE"
 * ],
 * "substances": [
 * {
 * substance: {
 * "id": "8becb008-510c-40e8-b2a4-1c1283289022",
 * "name": "THIOPHANATE-M"
 * },
 * "concentration": "15.0"
 * },
 * {
 * substance: {
 * "id": "8becb008-510c-40e8-b2a4-1c1283289023",
 * "name": "NITROGEN"
 * },
 * "concentration": "20.5"
 * },
 * {
 * substance: {
 * "id": "8becb008-510c-40e8-b2a4-1c1283289024",
 * "name": "POTASSIUM"
 * },
 * "concentration": "52.1"
 * }
 * ],
 * "itemStatus": "ACTIVE",
 * "dataLegitimacy": "LEGITIMATE"
 * }
 * ....
 */
export type UapiAppliedProduct = {
  __typename?: 'AppliedProduct';
  country: Scalars['CountryCode']['output'];
  dataLegitimacy: UapiDataLegitimacy;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  /** Signifies the company that manufactured company of the applied product. This can be null for products that are not regulated. */
  manufacturerName?: Maybe<Scalars['String']['output']>;
  /** Signifies the matter state of the applied product like LIQUID or SOLID. This can null which we don't have matter state information. */
  matterState?: Maybe<UapiMatterState>;
  name: Scalars['String']['output'];
  /** Signifies the regulator assigned number for the applied product. This can be null for products that are not regulated. */
  regulatorNumber?: Maybe<Scalars['String']['output']>;
  /** When a partial  search is done on applied products, this field signifies how relevant the result is to the search query. The value is between 0 and 1, where 1 means highly relevant and 0 means not relevant at all. This field is null when the result is not from a search query. */
  relevance?: Maybe<Scalars['Float']['output']>;
  /** Signifies the active substances in the applied product along with their concentration. This can empty which we don't have substance information. */
  substances: Array<UapiAppliedSubstance>;
  tenant: UapiOperation;
  /** Signifies the type of the applied product like COMMERCIAL FERTILIZER or INSECTICIDE. This can empty which we don't have type information. */
  types: Array<UapiAppliedType>;
};

/** The connection type for AppliedProduct result. */
export type UapiAppliedProductConnection = {
  __typename?: 'AppliedProductConnection';
  edges: Array<UapiAppliedProductEdge>;
  pageInfo: UapiPageInfo;
};

/** An edge in a connection. */
export type UapiAppliedProductEdge = {
  __typename?: 'AppliedProductEdge';
  cursor: Scalars['String']['output'];
  node: UapiAppliedProduct;
};

/** Filters available for retrieving applied products. */
export type UapiAppliedProductFilter = {
  appliedTypesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryCodes?: InputMaybe<Array<Scalars['CountryCode']['input']>>;
  /** A partial search on applied product name. The search is not case sensitive. */
  search?: InputMaybe<Scalars['String']['input']>;
  substanceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input specification for ordering applied products query results. */
export type UapiAppliedProductOrderByInput = {
  direction?: InputMaybe<UapiOrderByDirection>;
  key: UapiAppliedProductOrderByKey;
};

/** Fields by which results can be sorted. */
export enum UapiAppliedProductOrderByKey {
  APPLIED_PRODUCT_NAME = 'APPLIED_PRODUCT_NAME',
  RELEVANCE = 'RELEVANCE'
}

/** Right now this just holds the applied product, more extensible structure for later use cases. */
export type UapiAppliedProductPlan = {
  __typename?: 'AppliedProductPlan';
  appliedProduct?: Maybe<UapiAppliedProduct>;
};

/**
 * Substance used on the product along with its concentration
 * ### Example
 * ```
 * {
 * "substance": {
 * "id": "8becb008-510c-40e8-b2a4-1c1283289023",
 * "name":"NITROGEN"
 * },
 * "concentration": 20.5
 * }
 */
export type UapiAppliedSubstance = {
  __typename?: 'AppliedSubstance';
  /** Concentration of the substance in the applied product. The unit of concentration is percentage. This can be null if we don't have concentration information. */
  concentration?: Maybe<Scalars['Float']['output']>;
  substance: UapiSubstance;
};

/**
 * Applied type like  COMMERCIAL FERTILIZER or INSECTICIDE
 * ### Example
 * ```
 * {
 * "id": "8becb008-510c-40e8-b2a4-1c1283289022",
 * "name":"COMMERCIAL FERTILIZER"
 * }
 * Applied types query will be exposed in future PI's
 * ```
 */
export type UapiAppliedType = {
  __typename?: 'AppliedType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Represents audit data for an entity. */
export type UapiAuditMetadata = {
  __typename?: 'AuditMetadata';
  createdAt: Scalars['DateTime']['output'];
  createdBy: UapiParty;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: UapiParty;
};

/** The data source to be used. */
export enum UapiBackendMachineDataSource {
  /** Data from both machine data db and legacy will be used with machine data selected for common entries */
  COMBINED = 'COMBINED',
  /** Data from the machine data db will be used (This is the future state) */
  DEFAULT = 'DEFAULT',
  /** Data from legacy datasources will be used (i.e. Rogue) */
  LEGACY = 'LEGACY'
}

/** A coordinate reference system (CRS) is a framework used to precisely measure locations on the surface of Earth as coordinates. */
export enum UapiCrs {
  EPSG_3857 = 'EPSG_3857'
}

/** Input type to calculate and save ROI results for a Seed Density Trial. */
export type UapiCalculateSeedDensityTrialRoiInput = {
  fieldPlanId: Scalars['ID']['input'];
};

/** Represents an individual item in a categorical geospatial asset legend, specifying its label and color. */
export type UapiCategoricalGeospatialAssetLegendItem = UapiGeospatialAssetLegendItem & {
  __typename?: 'CategoricalGeospatialAssetLegendItem';
  color: UapiRgba;
  label: Scalars['String']['output'];
};

/** Chemical Product */
export type UapiChemicalProduct = {
  __typename?: 'ChemicalProduct';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Data related to a single chemical product that is included in one or more tank mixes for an application event */
export type UapiChemicalProductApplied = {
  __typename?: 'ChemicalProductApplied';
  /** the amount included in one or more tank mixes */
  amountApplied: UapiMeasure;
  /** the area over which this particular product was applied in the application event */
  area?: Maybe<UapiMeasure>;
  chemicalProduct: UapiChemicalProduct;
  /** user-specified unit, which may be non-standard */
  growerAmountUnit?: Maybe<Scalars['String']['output']>;
  /** the rate at which this specific product was distributed on the field */
  rate?: Maybe<UapiMeasure>;
};

/** Input type for creating a new agreement URL. */
export type UapiClickwrapAgreementInput = {
  agreementTemplateId: Scalars['ID']['input'];
  dataLegitimacy?: UapiDataLegitimacy;
  userId: Scalars['ID']['input'];
};

/** Represents a DocuSign Clickwrap Agreement to show in the modal for signing. */
export type UapiClipwrapAgreement = {
  __typename?: 'ClipwrapAgreement';
  agreementUrl: Scalars['URL']['output'];
  clickwrapAgreementId: Scalars['ID']['output'];
};

/** Input type for duplicating a crop plan. */
export type UapiCloneCropPlanInput = {
  cropPlanId: Scalars['ID']['input'];
  dataLegitimacy?: UapiDataLegitimacy;
  description?: InputMaybe<Scalars['String']['input']>;
  designer: UapiPlanDesignerInput;
  name: Scalars['String']['input'];
  /** Change the plan type after cloning. Only supporting FIELD_LEVEL to OPERATION at this time. */
  outputPlanType?: UapiCropPlanType;
  seasonName: UapiSeasonName;
  status: UapiCropPlanStatus;
  year: Scalars['Int']['input'];
};

/** Input type to clone a Trial. */
export type UapiCloneTrialInput = {
  dataLegitimacy?: UapiDataLegitimacy;
  /** The trialId to be cloned. */
  trialId: Scalars['ID']['input'];
};

/**
 * Represents an individual item in a numerical geospatial asset legend, specifying its min/max and color.
 * When min is omitted, the min is unbounded in the negative direction.
 * When min is omitted, the max is unbounded in the positive direction.
 */
export type UapiContinuousGeospatialAssetLegendItem = UapiGeospatialAssetLegendItem & {
  __typename?: 'ContinuousGeospatialAssetLegendItem';
  color: UapiRgba;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** Input type for creating a crop plan crop favorite. */
export type UapiCreateCropPlanCropFavoriteInput = {
  cropId: Scalars['ID']['input'];
  dataLegitimacy?: UapiDataLegitimacy;
  userId: Scalars['ID']['input'];
};

/** Input type for creating a crop plan. */
export type UapiCreateCropPlanInput = {
  dataLegitimacy?: UapiDataLegitimacy;
  description?: InputMaybe<Scalars['String']['input']>;
  designer: UapiPlanDesignerInput;
  growerId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  seasonName: UapiSeasonName;
  status: UapiCropPlanStatus;
  type: UapiCropPlanType;
  year: Scalars['Int']['input'];
};

/** Input type for creating a discount favorite. */
export type UapiCreateDiscountFavoriteInput = {
  dataLegitimacy?: UapiDataLegitimacy;
  name: Scalars['String']['input'];
  type: UapiDiscountFavoriteType;
  userId: Scalars['ID']['input'];
};

/** Input type for evaluation method. */
export type UapiCreateEvaluationMethodInput = {
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input type for creating a field harvesting task. */
export type UapiCreateFieldHarvestingTaskInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fieldPlanId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<UapiTaskState>;
};

/** Input type for creating a field plan. */
export type UapiCreateFieldPlanInput = {
  cropPlanId: Scalars['ID']['input'];
  designer: UapiPlanDesignerInput;
  fieldId: Scalars['ID']['input'];
  plannedCropId?: InputMaybe<Scalars['ID']['input']>;
  previousCropId?: InputMaybe<Scalars['ID']['input']>;
  tags: Array<Scalars['String']['input']>;
  targetYield?: InputMaybe<UapiMeasureInput>;
};

/** Input type for creating a field planting task. */
export type UapiCreateFieldPlantingTaskInput = {
  alternateProducts: Array<UapiSeedProductPlanInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fieldPlanId: Scalars['ID']['input'];
  method?: InputMaybe<UapiCreateEvaluationMethodInput>;
  plantingMethod?: InputMaybe<UapiPlantingMethod>;
  prescriptionContext?: InputMaybe<UapiCreatePrescriptionContextInput>;
  products: Array<UapiSeedProductPlanInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<UapiTaskState>;
  targetPlantingDate?: InputMaybe<Scalars['Date']['input']>;
};

/** Properties that can be supplied when creating a growth state observation. */
export type UapiCreateGrowthStageObservationInput = {
  cropMonitoringFieldExtendId: Scalars['ID']['input'];
  growthStageId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  observedOn: Scalars['Date']['input'];
};

/** The growth state observations that were created. */
export type UapiCreateGrowthStageObservationResponse = {
  __typename?: 'CreateGrowthStageObservationResponse';
  growthStateObservations?: Maybe<Array<UapiGrowthStageObservation>>;
};

/** Input type for the harvesting evaluation result. */
export type UapiCreateHarvestingEvaluationResultInput = {
  evaluationOffer?: InputMaybe<UapiProgramOfferType>;
  fieldHarvestingTaskId: Scalars['ID']['input'];
  harvestingArtifact?: InputMaybe<UapiEvaluationResultHarvestingArtifactInput>;
  manualRuleResults: Array<UapiManualRuleResultInput>;
  ruleResults: Array<UapiRuleResultInput>;
  status: UapiEvaluationStatus;
  statusReasons: Array<Scalars['String']['input']>;
};

/** Input type for create Note. */
export type UapiCreateNoteInput = {
  content: Scalars['String']['input'];
  dataLegitimacy?: UapiDataLegitimacy;
  subjectId: Scalars['ID']['input'];
  subjectType: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

/** Input type for Paid Seed Product Price. */
export type UapiCreatePaidSeedProductPriceInput = {
  dataLegitimacy?: UapiDataLegitimacy;
  /** Field for which the Paid Seed Product Price is being provided. */
  fieldId: Scalars['ID']['input'];
  /** True if an invoice was presented for the paid product price. */
  invoice?: InputMaybe<Scalars['Boolean']['input']>;
  price: UapiUnitPriceInput;
  /** Season for which the Paid Seed Product Price is being provided. */
  seasonName: UapiSeasonName;
  seedProductId: Scalars['ID']['input'];
  /** Year for which the Paid Seed Product Price is being provided. */
  year: Scalars['Int']['input'];
};

/** Input type for creating a PDF. */
export type UapiCreatePdfInput = {
  data: Scalars['JSON']['input'];
  /**
   * Optional filename given by the client matching the regex: [a-zA-Z0-9_-]+
   *   If null then templateId will be used as filename.
   */
  filename?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};

/** Input type for creating a group entry that represents a free from product. */
export type UapiCreatePlanAdditionalProductSummaryInput = {
  name: Scalars['String']['input'];
  productGroupId: Scalars['ID']['input'];
  unitPrice?: InputMaybe<UapiPriceInput>;
  units?: InputMaybe<UapiMeasureInput>;
};

/**
 * Input type for creating a discount.
 *
 * Note: Requires one and only one of percentage, price or pricePerUnit to be set.
 */
export type UapiCreatePlanDiscountInput = {
  name: Scalars['String']['input'];
  percentage?: InputMaybe<UapiMeasureInput>;
  price?: InputMaybe<UapiPriceInput>;
  pricePerUnit?: InputMaybe<UapiPricePerUnitInput>;
  productGroupId: Scalars['ID']['input'];
};

/** Input type for creating a product group. */
export type UapiCreatePlanProductGroupInput = {
  cropPlanId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Input type for creating a group entry that represents a seed product. */
export type UapiCreatePlanSeedProductSummaryInput = {
  area?: InputMaybe<UapiMeasureInput>;
  productGroupId: Scalars['ID']['input'];
  seedProductId: Scalars['ID']['input'];
  seedingRate?: InputMaybe<UapiMeasureInput>;
  unitPrice?: InputMaybe<UapiPriceInput>;
  units?: InputMaybe<UapiMeasureInput>;
};

/** Input type for the planting evaluation result. */
export type UapiCreatePlantingEvaluationResultInput = {
  evaluationOffer?: InputMaybe<UapiProgramOfferType>;
  fieldPlantingTaskId: Scalars['ID']['input'];
  manualRuleResults: Array<UapiManualRuleResultInput>;
  plantingArtifact?: InputMaybe<UapiEvaluationResultPlantingArtifactInput>;
  ruleResults: Array<UapiRuleResultInput>;
  status: UapiEvaluationStatus;
  statusReasons: Array<Scalars['String']['input']>;
};

/** Input type for creating a prescription context as part of field planting task creation. */
export type UapiCreatePrescriptionContextInput = {
  historicalCrops: Array<UapiHistoricalCropYearInput>;
};

/** Input type for creating a new Program. */
export type UapiCreateProgramInput = {
  countryCodes: Array<Scalars['CountryCode']['input']>;
  dataLegitimacy: UapiDataLegitimacy;
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  iconUrl?: InputMaybe<Scalars['URL']['input']>;
  name: Scalars['String']['input'];
};

/** Input type for creating a new occurrence of a Program. */
export type UapiCreateProgramInstanceInput = {
  challengerSeedBrandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  championSeedBrandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryCode: Scalars['CountryCode']['input'];
  cropIds: Array<Scalars['ID']['input']>;
  dataLegitimacy: UapiDataLegitimacy;
  displayName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
  temporalPeriod: UapiProgramTemporalPeriodInput;
  timeInterval: UapiTimeIntervalInput;
};

/** Input type for creating a new program instance. */
export type UapiCreateProgramInstanceStageInput = {
  dataLegitimacy?: UapiDataLegitimacy;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  itemStatus?: UapiItemStatus;
  programInstanceId: Scalars['ID']['input'];
  stageType: UapiProgramInstanceStageEnum;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input type for creating a program payment. */
export type UapiCreateProgramPaymentInput = {
  growerProgramEnrollmentId: Scalars['ID']['input'];
  paymentAmount: UapiMonetaryAmountInput;
};

/** Input type for creating a new protocol associated with a program instance. */
export type UapiCreateProtocolInput = {
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  programInstanceId: Scalars['ID']['input'];
};

/** Input type for associating a ruleset with a protocol. */
export type UapiCreateProtocolRulesetInput = {
  protocolId: Scalars['ID']['input'];
  rulesetId: Scalars['ID']['input'];
  rulesetType: UapiRulesetType;
};

/** Input type for creating a seed product favorite. */
export type UapiCreateSeedProductFavoriteInput = {
  dataLegitimacy?: UapiDataLegitimacy;
  seedProductId: Scalars['ID']['input'];
  seedingRate?: InputMaybe<UapiMeasureInput>;
  unitPrice?: InputMaybe<UapiPriceInput>;
  userId: Scalars['ID']['input'];
};

/** Input type for create SeedProductRecommendationsPreference. */
export type UapiCreateSeedProductRecommendationsPreferenceInput = {
  cropId: Scalars['ID']['input'];
  dataLegitimacy?: UapiDataLegitimacy;
  enabled: Scalars['Boolean']['input'];
  excludedProductIds: Array<Scalars['ID']['input']>;
  productIds: Array<Scalars['ID']['input']>;
  relativeMaturityHigh: UapiMeasureInput;
  relativeMaturityLow: UapiMeasureInput;
  seasonName: UapiSeasonName;
  traitStackSelection: Array<UapiTraitStackSelectionInput>;
  userId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

/** Input to create a TrialBlock. */
export type UapiCreateTrialBlockInput = {
  designer: UapiTrialDesignerInput;
  status: UapiTrialBlockStatus;
  statusReasons: Array<Scalars['String']['input']>;
  trialId: Scalars['ID']['input'];
  trialUnits: Array<UapiCreateTrialUnitInput>;
  type: UapiTrialBlockType;
};

/** Input type to create a Trial. */
export type UapiCreateTrialInput = {
  cropId: Scalars['ID']['input'];
  dataLegitimacy?: UapiDataLegitimacy;
  designer: UapiTrialDesignerInput;
  fieldId: Scalars['ID']['input'];
  seasonName: UapiSeasonName;
  status: UapiTrialStatus;
  statusReasons: Array<Scalars['String']['input']>;
  type: UapiTrialType;
  year: Scalars['Int']['input'];
};

/** Input to create a TrialUnit. */
export type UapiCreateTrialUnitInput = {
  area: UapiMeasureInput;
  centroid: Scalars['GeoJSONGeometry']['input'];
  geometry: Scalars['GeoJSONGeometry']['input'];
  role: UapiTrialUnitRole;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * A cultivated plant that is grown as food, especially a grain, fruit, or vegetable.
 * ### Example
 * ```
 * {
 * "id": "537e024e-0000-0000-0000-105757f45a24",
 * "name": "Clover, Yellow",
 * "stages": [
 * {
 * "id": "8becb008-510c-40e8-b2a4-1c1283289022",
 * "scale": "IOWA",
 * "developmentalPhase": "VEGETATIVE",
 * "stage": "VE",
 * "itemStatus": "ACTIVE",
 * "dataLegitimacy": "LEGITIMATE"
 * },
 * {
 * "id": "99fa5eb7-aeb4-485d-a4dd-9aa5dbe029d1",
 * "scale": "IOWA",
 * "developmentalPhase": "VEGETATIVE",
 * "stage": "V1",
 * "itemStatus": "ACTIVE",
 * "dataLegitimacy": "LEGITIMATE"
 * }
 * ],
 * "measurements": {
 * "country": "US",
 * "nominalWeight": { "u": "pounds/bushel", "v": 60.0 },
 * "nominalMoisture": { "u": "percent", "v": 13.5 },
 * "shrinkFactor": { "u": "percent", "v": 1.2 },
 * "turnout": { "u": "percent", "v": 10.0 },
 * "sales": { "u": "seeds", "v": 80000.0 },
 * "seedingRateUnit": "lbs/ac",
 * "yieldUnit": "tons"
 * },
 * "itemStatus": "ACTIVE",
 * "dataLegitimacy": "LEGITIMATE"
 * }
 * ```
 */
export type UapiCrop = {
  __typename?: 'Crop';
  dataLegitimacy: UapiDataLegitimacy;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  measurements?: Maybe<UapiCropMeasurements>;
  name: Scalars['String']['output'];
  stages: Array<UapiCropGrowthStage>;
};


/**
 * A cultivated plant that is grown as food, especially a grain, fruit, or vegetable.
 * ### Example
 * ```
 * {
 * "id": "537e024e-0000-0000-0000-105757f45a24",
 * "name": "Clover, Yellow",
 * "stages": [
 * {
 * "id": "8becb008-510c-40e8-b2a4-1c1283289022",
 * "scale": "IOWA",
 * "developmentalPhase": "VEGETATIVE",
 * "stage": "VE",
 * "itemStatus": "ACTIVE",
 * "dataLegitimacy": "LEGITIMATE"
 * },
 * {
 * "id": "99fa5eb7-aeb4-485d-a4dd-9aa5dbe029d1",
 * "scale": "IOWA",
 * "developmentalPhase": "VEGETATIVE",
 * "stage": "V1",
 * "itemStatus": "ACTIVE",
 * "dataLegitimacy": "LEGITIMATE"
 * }
 * ],
 * "measurements": {
 * "country": "US",
 * "nominalWeight": { "u": "pounds/bushel", "v": 60.0 },
 * "nominalMoisture": { "u": "percent", "v": 13.5 },
 * "shrinkFactor": { "u": "percent", "v": 1.2 },
 * "turnout": { "u": "percent", "v": 10.0 },
 * "sales": { "u": "seeds", "v": 80000.0 },
 * "seedingRateUnit": "lbs/ac",
 * "yieldUnit": "tons"
 * },
 * "itemStatus": "ACTIVE",
 * "dataLegitimacy": "LEGITIMATE"
 * }
 * ```
 */
export type UapiCropMeasurementsArgs = {
  countryCode: Scalars['CountryCode']['input'];
};

/** Input type for an optional Crop correction, all SeedProducts belong to the same Crop. */
export type UapiCropAndSeedProductCorrectionInput = {
  /** omit if there it is not a correction for Crop */
  correctedCropId?: InputMaybe<Scalars['ID']['input']>;
  correctedSeedProducts: Array<UapiSeedProductCorrectionInput>;
};

/** Holds an average measurement for a certain crop. */
export type UapiCropAverage = {
  __typename?: 'CropAverage';
  average?: Maybe<UapiMeasure>;
  crop?: Maybe<UapiCrop>;
};

/** The connection type for Crop result. */
export type UapiCropConnection = {
  __typename?: 'CropConnection';
  edges: Array<UapiCropEdge>;
  pageInfo: UapiPageInfo;
};

/** An edge in a connection. */
export type UapiCropEdge = {
  __typename?: 'CropEdge';
  cursor: Scalars['String']['output'];
  node: UapiCrop;
};

/** Filters available for retrieving crops. */
export type UapiCropFilter = {
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  /**
   * If true, only 'display' crops will be returned.
   *   If false, only the 'non-display' deprecated crops will be returned.
   *   If not specified, only 'display' crops will be returned.
   */
  displayCrop?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Distinct phase in a plant's lifecycle.
 * ### Example
 * ```
 * {
 * "id": "8becb008-510c-40e8-b2a4-1c1283289022",
 * "scale": "IOWA",
 * "developmentalPhase": "VEGETATIVE",
 * "stage": "VE",
 * "itemStatus": "ACTIVE",
 * "dataLegitimacy": "LEGITIMATE"
 * }
 * ```
 */
export type UapiCropGrowthStage = {
  __typename?: 'CropGrowthStage';
  dataLegitimacy: UapiDataLegitimacy;
  developmentalPhase: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  scale: Scalars['String']['output'];
  stage: Scalars['String']['output'];
};

/**
 * Crop measurements by location
 * ### Example
 * ```
 * {
 * "country": "US",
 * "nominalWeight": { "u": "pounds/bushel", "v": 60.0 },
 * "nominalMoisture": { "u": "percent", "v": 13.5 },
 * "shrinkFactor": { "u": "percent", "v": 1.2 },
 * "turnout": { "u": "percent", "v": 10.0 },
 * "sales": { "u": "seeds", "v": 80000.0 },
 * "seedingRateUnit": "lbs/ac",
 * "yieldUnit": "tons"
 * }
 * ```
 */
export type UapiCropMeasurements = {
  __typename?: 'CropMeasurements';
  country: Scalars['CountryCode']['output'];
  nominalMoisture?: Maybe<UapiMeasure>;
  nominalWeight?: Maybe<UapiMeasure>;
  sales?: Maybe<UapiMeasure>;
  seedingRateUnit?: Maybe<Scalars['String']['output']>;
  shrinkFactor?: Maybe<UapiMeasure>;
  turnout?: Maybe<UapiMeasure>;
  yieldUnit?: Maybe<Scalars['String']['output']>;
};

/**
 * Sub-field crop monitoring conditions.
 * Conditions may vary within a field based on things like
 * different crop, seed product, activity dates, etc.
 */
export type UapiCropMonitoringFieldExtent = {
  __typename?: 'CropMonitoringFieldExtent';
  averagePlantingPopulation?: Maybe<UapiMeasure>;
  dataLegitimacy: UapiDataLegitimacy;
  growingDegreeDaysSincePlanting?: Maybe<UapiMeasure>;
  growthStageObservations?: Maybe<Array<UapiGrowthStageObservation>>;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  /** A crop phenology sequence for this extent, each with non-overlapping date ranges. */
  phenology?: Maybe<Array<UapiCropPhenology>>;
  plantingArea: UapiMeasure;
  plantingDate: Scalars['Date']['output'];
  rainfallCumulativeSincePlanting?: Maybe<UapiMeasure>;
  rainfallLast3Days?: Maybe<UapiMeasure>;
  seedProduct: UapiSeedProduct;
};

/** Crop monitoring conditions for a given field. */
export type UapiCropMonitoringFieldRecord = {
  __typename?: 'CropMonitoringFieldRecord';
  dataLegitimacy: UapiDataLegitimacy;
  extents?: Maybe<Array<UapiCropMonitoringFieldExtent>>;
  farmId: Scalars['ID']['output'];
  farmName: Scalars['String']['output'];
  fieldArea: UapiMeasure;
  fieldCentroid: Scalars['GeoJSONGeometry']['output'];
  fieldGeometry: Scalars['GeoJSONGeometry']['output'];
  fieldId: Scalars['ID']['output'];
  fieldName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  operationId: Scalars['ID']['output'];
  operationName: Scalars['String']['output'];
  operationOwnerFirstName: Scalars['String']['output'];
  operationOwnerId: Scalars['ID']['output'];
  operationOwnerLastName: Scalars['String']['output'];
};

/** A connection of crop monitoring field records for pagination. */
export type UapiCropMonitoringFieldRecordConnection = {
  __typename?: 'CropMonitoringFieldRecordConnection';
  edges: Array<UapiCropMonitoringFieldRecordEdge>;
  /**
   * The number of distinct fields across all records in this connection,
   *   filtered by the applied extent and phenology criteria.
   */
  fieldCountFiltered: Scalars['Int']['output'];
  /**
   * The number of distinct operations across all records in this connection,
   *   filtered by the applied extent and phenology criteria.
   */
  operationCountFiltered: Scalars['Int']['output'];
  pageInfo: UapiPageInfo;
  /**
   * The total area across all records in this connection,
   *   filtered by the applied extent and phenology criteria.
   */
  totalAreaFiltered: UapiMeasure;
  /**
   * Use fieldCountFiltered instead. This field returns the total record count
   *   (unfiltered by extent/phenology) and will be removed in a future release.
   * @deprecated Use fieldCountFiltered instead.
   */
  totalCount: Scalars['Int']['output'];
};

/** An edge containing a crop monitoring field record for pagination. */
export type UapiCropMonitoringFieldRecordEdge = {
  __typename?: 'CropMonitoringFieldRecordEdge';
  cursor: Scalars['String']['output'];
  node: UapiCropMonitoringFieldRecord;
};

/** Criteria that can be used to filter crop monitoring field records. */
export type UapiCropMonitoringFieldRecordFilter = {
  /** A list of crop ids. */
  cropIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The data legitimacy. */
  dataLegitimacy?: InputMaybe<UapiDataLegitimacyQuery>;
  /** A list of field ids. */
  fieldIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A partial string contained with the field or farm name. */
  fieldOrFarmNameLike?: InputMaybe<Scalars['String']['input']>;
  /** A range of cumulative growing degree days since planting. */
  growingDegreeDaysSincePlanting?: InputMaybe<UapiMeasureRangeInput>;
  /**
   * A growth stage prediction date range filter.
   *   Allows filtering by predictions that occur within or overlap a date range.
   */
  growthStageDateRange?: InputMaybe<UapiGrowthStageDateRangeFilter>;
  /**
   * A list of growth stage ids.
   *   @deprecated(reason: "Use growthStageDateRange instead")
   */
  growthStageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The item status of the crop monitoring field record. */
  itemStatuses?: InputMaybe<Array<UapiItemStatus>>;
  /** A list of operation ids. */
  operationIds: Array<Scalars['ID']['input']>;
  /** A range of dates in which planting occurred. */
  plantingDate?: InputMaybe<UapiDateRangeInput>;
  /** A range of planting population. */
  plantingPopulation?: InputMaybe<UapiMeasureRangeInput>;
  /** A range of cumulative rainfall in mm since planting. */
  rainfallCumulativeSincePlanting?: InputMaybe<UapiMeasureRangeInput>;
  /** A range of rainfall in mm over the last 3 days. */
  rainfallLast3Days?: InputMaybe<UapiMeasureRangeInput>;
  seasonName: UapiSeasonName;
  seasonYear: Scalars['Int']['input'];
  /** A list of seed product brand ids. */
  seedBrandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A list of seed product ids. */
  seedProductIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A range of seed product relative maturities. */
  seedProductRelativeMaturity?: InputMaybe<UapiFloatRangeInput>;
  /**
   * When true, narrows the phenology array on each extent to only the growth stage
   *   whose predicted date range contains the current date. Also filters out extents
   *   (and their parent records) that have no current growth stage prediction.
   */
  selectCurrentGrowthStage?: InputMaybe<Scalars['Boolean']['input']>;
  /** The time at which a specific growth stage is achieved. */
  timeToGrowthStage?: InputMaybe<UapiTimeToGrowthStageFilter>;
};

/** The properties on which crop monitoring field records can be ordered. */
export enum UapiCropMonitoringFieldRecordOrderBy {
  FIELD_NAME = 'FIELD_NAME',
  OPERATION_NAME = 'OPERATION_NAME'
}

/** The ordering specification for crop monitoring field records. */
export type UapiCropMonitoringFieldRecordOrdering = {
  by: UapiCropMonitoringFieldRecordOrderBy;
  direction?: InputMaybe<UapiOrderByDirection>;
};

/**
 * Statistics around crop monitoring field records.  Can be used
 * to support dynamic/constrained filter ranges or other aggregation purposes.
 */
export type UapiCropMonitoringFieldRecordStats = {
  __typename?: 'CropMonitoringFieldRecordStats';
  distinctBrands?: Maybe<Array<UapiSeedBrand>>;
  distinctGrowthStages?: Maybe<Array<UapiCropGrowthStage>>;
  distinctSeedProducts?: Maybe<Array<UapiSeedProduct>>;
  fieldCount: Scalars['Int']['output'];
  operationCount: Scalars['Int']['output'];
  totalArea: UapiMeasure;
};

/** Crop phenology information for a given data range. */
export type UapiCropPhenology = {
  __typename?: 'CropPhenology';
  datesInStage: UapiDateRange;
  growthStageId: Scalars['ID']['output'];
  growthStageName: Scalars['ID']['output'];
};

/** A collection of field plans for a crop during a temporal period. */
export type UapiCropPlan = UapiNode & {
  __typename?: 'CropPlan';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  description?: Maybe<Scalars['String']['output']>;
  designer?: Maybe<UapiPlanDesigner>;
  fieldPlans: UapiFieldPlanConnection;
  grower?: Maybe<UapiUser>;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  name: Scalars['String']['output'];
  productGroups: Array<UapiPlanProductGroup>;
  seasonName: UapiSeasonName;
  /** When sharing a crop plan with an individual, was pricing included in drafting the plan */
  sentWithPricing?: Maybe<Scalars['Boolean']['output']>;
  status: UapiCropPlanStatus;
  /** The last time the Crop Plan status was changed. */
  statusUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  type: UapiCropPlanType;
  year: Scalars['Int']['output'];
};


/** A collection of field plans for a crop during a temporal period. */
export type UapiCropPlanFieldPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: UapiCropPlanFieldPlansFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Possible types of alerts for a crop plan. */
export enum UapiCropPlanAlertType {
  /** The crop rotation is corn on corn and the product placed does not have certain traits. */
  CORN_ON_CORN_TRAIT = 'CORN_ON_CORN_TRAIT',
  /** The crop of the seed product on the field does not match the planned crop. */
  CROP_MISMATCH = 'CROP_MISMATCH',
  /** The product is more than a certain RM away from the average historical RM for that field. */
  RELATIVE_MATURITY_DEVIATION = 'RELATIVE_MATURITY_DEVIATION',
  /** The seeding rate is more than a certain percentage away from the average historical seeding rate for that field. */
  SEEDING_RATE_DEVIATION = 'SEEDING_RATE_DEVIATION'
}

/** The connection type for CropPlan. */
export type UapiCropPlanConnection = {
  __typename?: 'CropPlanConnection';
  edges: Array<UapiCropPlanEdge>;
  pageInfo: UapiPageInfo;
};

/** A crop favorite for a user in the context of crop planning. */
export type UapiCropPlanCropFavorite = UapiNode & {
  __typename?: 'CropPlanCropFavorite';
  auditMetadata: UapiAuditMetadata;
  crop?: Maybe<UapiCrop>;
  dataLegitimacy: UapiDataLegitimacy;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  user?: Maybe<UapiUser>;
};

/** Filters available for retrieving crop plan crop favorites. */
export type UapiCropPlanCropFavoritesFilter = {
  dataLegitimacy?: UapiDataLegitimacyQuery;
  itemStatuses?: InputMaybe<Array<UapiItemStatusQuery>>;
};

/** An edge in a connection. */
export type UapiCropPlanEdge = {
  __typename?: 'CropPlanEdge';
  cursor: Scalars['String']['output'];
  node: UapiCropPlan;
};

/** Filters available for retrieving field plans on a crop plan. */
export type UapiCropPlanFieldPlansFilter = {
  itemStatuses?: InputMaybe<Array<UapiItemStatusQuery>>;
};

/** Crop plan preferences for a user. */
export type UapiCropPlanPreferences = {
  __typename?: 'CropPlanPreferences';
  cropFavorites: Array<UapiCropPlanCropFavorite>;
  /** The crop plan discount favorites linked to the user. Ordered by ascending priority. */
  discountFavorites: Array<UapiDiscountFavorite>;
};


/** Crop plan preferences for a user. */
export type UapiCropPlanPreferencesCropFavoritesArgs = {
  filter?: UapiCropPlanCropFavoritesFilter;
};


/** Crop plan preferences for a user. */
export type UapiCropPlanPreferencesDiscountFavoritesArgs = {
  filter?: UapiDiscountFavoritesFilter;
};

/** Possible statuses of a crop plan. */
export enum UapiCropPlanStatus {
  ACCEPTED = 'ACCEPTED',
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  READ = 'READ',
  SENT = 'SENT'
}

/** Possible types of a crop plan. */
export enum UapiCropPlanType {
  COMPLIANCE = 'COMPLIANCE',
  FIELD_LEVEL = 'FIELD_LEVEL',
  OPERATION = 'OPERATION'
}

/** Filters available for retrieving cropPlans. */
export type UapiCropPlansFilter = {
  cropPlanTypes?: InputMaybe<Array<UapiCropPlanType>>;
  dataLegitimacy?: UapiDataLegitimacyQuery;
  designerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  growerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemStatuses?: InputMaybe<Array<UapiItemStatusQuery>>;
  seasonNames?: InputMaybe<Array<UapiSeasonName>>;
  statuses?: InputMaybe<Array<UapiCropPlanStatus>>;
  updatedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  updatedSince?: InputMaybe<Scalars['DateTime']['input']>;
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Columns available for sorting crop plans. */
export enum UapiCropPlansOrderBy {
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT',
  YEAR = 'YEAR'
}

/** Ordering parameters for crop plans. */
export type UapiCropPlansOrdering = {
  by?: UapiCropPlansOrderBy;
  direction?: UapiOrderByDirection;
};

/**
 * Zone attributes for Prescription type: Crop Protection
 * https://gitlab.tcc.li/climate/cfvrec/saam/projects/prescription-manager/-/blob/main/prescription_manager/model/prescriptions/schema.py?ref_type=heads#L40-49
 */
export type UapiCropProtectionZone = UapiZone & {
  __typename?: 'CropProtectionZone';
  area: UapiMeasure;
  geometry: Scalars['GeoJSONGeometry']['output'];
  id: Scalars['ID']['output'];
  isCheckStrip: Scalars['Boolean']['output'];
  product: Array<UapiChemicalProduct>;
  rate?: Maybe<UapiMeasure>;
};

/** Crop Protection Zone Metadata */
export type UapiCropProtectionZoneMetadata = UapiZoneMetadata & {
  __typename?: 'CropProtectionZoneMetadata';
  /**
   * Average of all zone's application rate if it is set.
   *   Returns null if application rate is not set for any zones.
   */
  applicationRateAvgAllZones?: Maybe<UapiMeasure>;
  /**
   * List of unique chemicals that are used for crop protection prescription.
   *   For Crop Protection, when growers use Tank Mix, multiple chemical products will be returned.
   *   Returns null if chemical products are not set.
   */
  chemicalProducts?: Maybe<Array<UapiChemicalProduct>>;
  /** The summation of each zone's area. */
  totalArea: UapiMeasure;
  /** The summation of each zone's area excluding zones that are marked as check strips. */
  totalAreaNoCheckStrip: UapiMeasure;
  /** Number of zones */
  totalNumZones: Scalars['Int']['output'];
};

/** Data Inbox Notification Data */
export type UapiDataInboxNotificationData = {
  __typename?: 'DataInboxNotificationData';
  newItems: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

/** A classification of data as legitimate or artificial. */
export enum UapiDataLegitimacy {
  /** Fake, simulated, synthesized test, or duplicated data. */
  ARTIFICIAL = 'ARTIFICIAL',
  /** Presumed to represent genuine real-world objects and events. */
  LEGITIMATE = 'LEGITIMATE'
}

/** Possible values when querying for data legitimacy. */
export enum UapiDataLegitimacyQuery {
  ALL = 'ALL',
  ARTIFICIAL = 'ARTIFICIAL',
  LEGITIMATE = 'LEGITIMATE'
}

/** A range of dates. */
export type UapiDateRange = {
  __typename?: 'DateRange';
  maxValue?: Maybe<Scalars['Date']['output']>;
  maxValueInclusive?: Maybe<Scalars['Boolean']['output']>;
  minValue?: Maybe<Scalars['Date']['output']>;
  minValueInclusive?: Maybe<Scalars['Boolean']['output']>;
};

/** A range of dates for input purposes. */
export type UapiDateRangeInput = {
  maxValue?: InputMaybe<Scalars['Date']['input']>;
  maxValueInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  minValue?: InputMaybe<Scalars['Date']['input']>;
  minValueInclusive?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Field enrollment configuration for Dekalb Integrado program. */
export type UapiDekalbIntegradoFieldEnrollmentConfiguration = {
  __typename?: 'DekalbIntegradoFieldEnrollmentConfiguration';
  existingPrescription: Scalars['Boolean']['output'];
  includeTrial: Scalars['Boolean']['output'];
  nitrogenPrescription: Scalars['Boolean']['output'];
};

/** Input parameters when enrolling a field in the Dekalb Integrado program. */
export type UapiDekalbIntegradoFieldEnrollmentDetailsInput = {
  /** Whether a prescription was already created. A prescription will still be generated, this is information only. */
  existingPrescription: Scalars['Boolean']['input'];
  /** The crop planted in previous years. */
  historicalCrops: Array<UapiHistoricalCropYearInput>;
  /** Whether a trial block should be generated for the field. */
  includeTrial: Scalars['Boolean']['input'];
  /** Whether a nitrogen prescription should be generated for the field. */
  nitrogenPrescription: Scalars['Boolean']['input'];
  /**
   * Prescription product for the nitrogen prescription.
   *   Must be not null if nitrogenPrescription is True else null.
   */
  nitrogenProduct?: InputMaybe<Scalars['ID']['input']>;
  /** The hybrid seed product that will be planted. */
  seedProductId: Scalars['ID']['input'];
  /** The planned seed density (in seed/hectare). */
  seedingRate: UapiMeasureInput;
  /** The target planting date. */
  targetPlantingDate: Scalars['Date']['input'];
  /** The field historical yield (in kilogram/hectare). */
  targetYield: UapiMeasureInput;
  /** Whether the field will be planted with a variable rate planter. */
  variableRate: Scalars['Boolean']['input'];
};

/**
 * A discount favorite for a user. Users have a list of (favorite) discounts that they can apply to Plans
 * when creating/updating them.
 *
 * Note: Favorite discounts are saved in some order of 'priority' and they are meant to be applied to a plan
 * following that same order.
 */
export type UapiDiscountFavorite = UapiNode & {
  __typename?: 'DiscountFavorite';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  name: Scalars['String']['output'];
  /**
   * Discount favorites are persisted (and later applied to crop plans) in order of priority.
   *   Values go from 0 to 2147483647 being zero (0) the highest priority.
   */
  priority: Scalars['Int']['output'];
  type: UapiDiscountFavoriteType;
  user?: Maybe<UapiUser>;
};

/** The type of a discount favorite. */
export enum UapiDiscountFavoriteType {
  PERCENT = 'PERCENT',
  PRICE = 'PRICE',
  PRICE_PER_UNIT = 'PRICE_PER_UNIT'
}

/** Filters available for retrieving discountFavorites. */
export type UapiDiscountFavoritesFilter = {
  dataLegitimacy?: UapiDataLegitimacyQuery;
  itemStatuses?: InputMaybe<Array<UapiItemStatusQuery>>;
};

/** Input type for dismissing a field plan alert with an optional seed product. */
export type UapiDismissFieldPlanAlertInput = {
  alertType: UapiCropPlanAlertType;
  fieldPlanId: Scalars['ID']['input'];
  seedProductId?: InputMaybe<Scalars['ID']['input']>;
};

/** Represents a dismissed alert on a field plan. */
export type UapiDismissedFieldPlanAlert = {
  __typename?: 'DismissedFieldPlanAlert';
  alertType: UapiCropPlanAlertType;
  seedProduct?: Maybe<UapiSeedProduct>;
};

/** Input to download prescriptions as a single compressed zip file in specified monitor format. */
export type UapiDownloadPrescriptionsInput = {
  /** Monitor format which is used to download prescriptions in. */
  monitorFileFormatId: Scalars['ID']['input'];
  /** List of one or multiple prescription IDs to download */
  prescriptionIds: Array<Scalars['ID']['input']>;
  /**
   * Optional parameter to specify row spacing for certain monitor types (e.g. Stara monitor).
   *   If the unitOfMeasurementSystem is IMPERIAL or CANADA, rowSpacing will be interpreted in inches.
   *   If the unitOfMeasurementSystem is SI, rowSpacing will be interpreted in centimeters.
   */
  rowSpacing?: InputMaybe<Scalars['Int']['input']>;
  /** Unit of Measurement System for the download prescriptions. Usually determined based on user preference in FieldView. */
  unitOfMeasurementSystem: UapiUnitOfMeasurementSystem;
};

/** Input to duplicate a prescription */
export type UapiDuplicatePrescriptionInput = {
  /** Name of the new duplicated prescription */
  newName: Scalars['String']['input'];
  /** Id of the original prescription to duplicate */
  originalId: Scalars['ID']['input'];
};

/** Possible states of a grower eligibility for a program instance. */
export enum UapiEligibilityStatus {
  /** The grower is eligible for the program instance. */
  ELIGIBLE = 'ELIGIBLE',
  /** The eligibility of the grower for the program instance cannot be determined. */
  INDETERMINATE = 'INDETERMINATE',
  /** The grower is not eligible for the program instance. */
  INELIGIBLE = 'INELIGIBLE',
  /** The eligibility of the grower for the program instance has not yet been determined. */
  PENDING = 'PENDING'
}

/** Possible values when querying on a grower program eligibility by status. */
export enum UapiEligibilityStatusQuery {
  ALL = 'ALL',
  /** The grower is eligible for the program instance. */
  ELIGIBLE = 'ELIGIBLE',
  /** The eligibility of the grower for the program instance cannot be determined. */
  INDETERMINATE = 'INDETERMINATE',
  /** The grower is not eligible for the program instance. */
  INELIGIBLE = 'INELIGIBLE',
  /** The eligibility of the grower for the program instance has not yet been determined. */
  PENDING = 'PENDING'
}

/** Input type for sending an email agreement for signing. */
export type UapiEmailRecordedAgreementInput = {
  agreementTemplateId: Scalars['ID']['input'];
  dataLegitimacy?: UapiDataLegitimacy;
  recipientEmail: Scalars['Email']['input'];
  recipientName: Scalars['String']['input'];
  senderUserId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Possible values for user email verification status */
export enum UapiEmailVerificationStatus {
  GRACE_PERIOD = 'GRACE_PERIOD',
  LEGACY = 'LEGACY',
  UNVERIFIED = 'UNVERIFIED',
  VERIFIED = 'VERIFIED'
}

/** Input parameters for enrolling a field in a program instance. */
export type UapiEnrollFieldInput = {
  /** The program instance specific details of the field enrollment. */
  enrollmentDetails: UapiFieldEnrollmentDetailsInput;
  /** The field enrollment being enrolled. */
  fieldEnrollmentId: Scalars['ID']['input'];
};

/** Input parameters for enrolling a grower in a program instance. */
export type UapiEnrollGrowerInput = {
  /** The grower being enrolled. */
  growerId: Scalars['ID']['input'];
  /** The program instance to which the grower should be enrolled. */
  programInstanceId: Scalars['ID']['input'];
  /** The recorded agreement id for grower T&C. */
  recordedAgreementId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Count of field enrollments in a program offer type.
 *
 * This is used to summarize the count of fields enrolled in a program offer type for a grower's program enrollment.
 */
export type UapiEnrolledOfferTypeCount = {
  __typename?: 'EnrolledOfferTypeCount';
  count: Scalars['Int']['output'];
  programOfferType: UapiProgramOfferType;
};

/**
 * Field program enrolled operationFields grouped by enrollment status.
 *
 * Field summary statistics are provided by Location service via OperationFieldsACK.
 * FieldProgramEnrollments are provided by this subgraph via OperationFieldsACK as well.
 */
export type UapiEnrolledOperationFieldsByEnrollmentStatus = {
  __typename?: 'EnrolledOperationFieldsByEnrollmentStatus';
  enrollmentStatus: UapiFieldProgramEnrollmentStatus;
  operationFields: UapiOperationFieldsAck;
};

/** Represents a way to evaluate a field task. */
export type UapiEvaluationMethod = {
  __typename?: 'EvaluationMethod';
  configuration?: Maybe<Scalars['JSON']['output']>;
  ruleset?: Maybe<UapiRuleset>;
};

/**
 * Evaluation Result artifact data related to harvesting activity.
 *
 * Note that any Null list means data was not populated. An Empty list means no data was found.
 */
export type UapiEvaluationResultHarvestingArtifact = {
  __typename?: 'EvaluationResultHarvestingArtifact';
  prescription?: Maybe<UapiPrescriptionResultOutput>;
  trial?: Maybe<UapiTrialResultOutput>;
};

/** Input type for EvaluationResultHarvestingArtifact. */
export type UapiEvaluationResultHarvestingArtifactInput = {
  prescription?: InputMaybe<UapiEvaluationResultPrescriptionAsHarvestedInput>;
  trialId?: InputMaybe<Scalars['ID']['input']>;
};

/** Evaluation Result artifact data related to harvest data. */
export type UapiEvaluationResultHarvestingData = {
  __typename?: 'EvaluationResultHarvestingData';
  /** This value includes any post harvest adjustments */
  area?: Maybe<UapiMeasure>;
  /** This value includes any post harvest adjustments */
  averageYield?: Maybe<UapiMeasure>;
  harvestingDate?: Maybe<Scalars['Date']['output']>;
  /** Id of machine (combine) used during harvest */
  machineId?: Maybe<Scalars['String']['output']>;
  /** This value includes any post harvest adjustments */
  moistureMass?: Maybe<UapiMeasure>;
  phaPresent: Scalars['Boolean']['output'];
  seedProduct?: Maybe<UapiSeedProduct>;
  /** This value includes any post harvest adjustments */
  wetMass?: Maybe<UapiMeasure>;
};

/** Input type for EvaluationResultHarvestingData. */
export type UapiEvaluationResultHarvestingDataInput = {
  /** This value includes any post harvest adjustments */
  area?: InputMaybe<UapiMeasureInput>;
  /** This value includes any post harvest adjustments */
  averageYield?: InputMaybe<UapiMeasureInput>;
  harvestingDate?: InputMaybe<Scalars['Date']['input']>;
  /** Machine id used during harvesting */
  machineId?: InputMaybe<Scalars['String']['input']>;
  /** This value includes any post harvest adjustments */
  moistureMass?: InputMaybe<UapiMeasureInput>;
  phaPresent: Scalars['Boolean']['input'];
  seedProductId?: InputMaybe<Scalars['ID']['input']>;
  /** This value includes any post harvest adjustments */
  wetMass?: InputMaybe<UapiMeasureInput>;
};

/** Evaluation Result artifact data related to harvesting summary. */
export type UapiEvaluationResultHarvestingDataSummary = {
  __typename?: 'EvaluationResultHarvestingDataSummary';
  /** This value includes any post harvest adjustments */
  area?: Maybe<UapiMeasure>;
  /** This value includes any post harvest adjustments */
  averageYield?: Maybe<UapiMeasure>;
  harvestingDates?: Maybe<Array<Scalars['Date']['output']>>;
  /**
   * Set of unique machine ids used during harvesting.
   *   NOTE: currently permits null as an edge case where the machine Id could not be retrieved.
   */
  machineIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** This value includes any post harvest adjustments */
  moistureMass?: Maybe<UapiMeasure>;
  phaPresent: Scalars['Boolean']['output'];
  seedProducts?: Maybe<Array<UapiSeedProduct>>;
  /** This value includes any post harvest adjustments */
  wetMass?: Maybe<UapiMeasure>;
};

/**
 * Evaluation Result artifact data related to planting activity.
 *
 * Note that any Null list means data was not populated. An Empty list means no data was found.
 */
export type UapiEvaluationResultPlantingArtifact = {
  __typename?: 'EvaluationResultPlantingArtifact';
  prescription?: Maybe<UapiEvaluationResultPrescriptionAsPlanted>;
};

/** Input type for EvaluationResultPlantingArtifact. */
export type UapiEvaluationResultPlantingArtifactInput = {
  prescription?: InputMaybe<UapiEvaluationResultPrescriptionAsPlantedInput>;
};

/** Evaluation Result artifact data related to planted seed products. */
export type UapiEvaluationResultPlantingData = {
  __typename?: 'EvaluationResultPlantingData';
  area?: Maybe<UapiMeasure>;
  /**
   * Set of unique machine ids used during planting.
   *   NOTE: currently permits null as an edge case where the serial number could not be retrieved.
   */
  machineSerialNumbers?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  plantingDates?: Maybe<Array<Scalars['DateTime']['output']>>;
  seedProduct?: Maybe<UapiSeedProduct>;
  seedingRate?: Maybe<UapiMeasure>;
};

/** Input type for EvaluationResultPlantingData. */
export type UapiEvaluationResultPlantingDataInput = {
  area?: InputMaybe<UapiMeasureInput>;
  /**
   * Set of unique machine ids used during planting.
   *   NOTE: currently permits null as an edge case where the serial number could not be retrieved.
   */
  machineSerialNumbers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  plantingDates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  seedProductId: Scalars['ID']['input'];
  seedingRate?: InputMaybe<UapiMeasureInput>;
};

/** Evaluation Result artifact data related to planted seed products summary. */
export type UapiEvaluationResultPlantingDataSummary = {
  __typename?: 'EvaluationResultPlantingDataSummary';
  area?: Maybe<UapiMeasure>;
  /**
   * Set of unique machine ids used during planting.
   *   NOTE: currently permits null as an edge case where the serial number could not be retrieved.
   */
  machineSerialNumbers?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  plantingDates?: Maybe<Array<Scalars['DateTime']['output']>>;
  seedProducts: Array<UapiSeedProduct>;
  seedingRate?: Maybe<UapiMeasure>;
};

/** Evaluation Result artifact data related to the harvest data within a prescription. */
export type UapiEvaluationResultPrescriptionAsHarvested = {
  __typename?: 'EvaluationResultPrescriptionAsHarvested';
  summary?: Maybe<Array<UapiEvaluationResultHarvestingDataSummary>>;
  zones?: Maybe<Array<UapiEvaluationResultPrescriptionZoneAsHarvested>>;
};


/** Evaluation Result artifact data related to the harvest data within a prescription. */
export type UapiEvaluationResultPrescriptionAsHarvestedSummaryArgs = {
  groupByProduct: Scalars['Boolean']['input'];
  includeCheckStrip: Scalars['Boolean']['input'];
};

/** Input type for EvaluationResultPrescriptionAsHarvested. */
export type UapiEvaluationResultPrescriptionAsHarvestedInput = {
  zones?: InputMaybe<Array<UapiEvaluationResultPrescriptionZoneAsHarvestedInput>>;
};

/** Evaluation Result artifact data related to the actual planting data within a prescription. */
export type UapiEvaluationResultPrescriptionAsPlanted = {
  __typename?: 'EvaluationResultPrescriptionAsPlanted';
  summary?: Maybe<Array<UapiEvaluationResultPlantingDataSummary>>;
  zones?: Maybe<Array<UapiEvaluationResultPrescriptionZoneAsPlanted>>;
};


/** Evaluation Result artifact data related to the actual planting data within a prescription. */
export type UapiEvaluationResultPrescriptionAsPlantedSummaryArgs = {
  groupByProduct: Scalars['Boolean']['input'];
  includeCheckStrip: Scalars['Boolean']['input'];
};

/** Input type for EvaluationResultPrescriptionAsPlanted. */
export type UapiEvaluationResultPrescriptionAsPlantedInput = {
  zones?: InputMaybe<Array<UapiEvaluationResultPrescriptionZoneAsPlantedInput>>;
};

/** Evaluation Result artifact data related to the harvest data within a prescription's zone. */
export type UapiEvaluationResultPrescriptionZoneAsHarvested = {
  __typename?: 'EvaluationResultPrescriptionZoneAsHarvested';
  harvestingData?: Maybe<Array<UapiEvaluationResultHarvestingData>>;
  isCheckStrip: Scalars['Boolean']['output'];
  summary?: Maybe<UapiEvaluationResultHarvestingDataSummary>;
  zoneId: Scalars['String']['output'];
};

/** Input type for EvaluationResultPrescriptionZoneAsHarvested. */
export type UapiEvaluationResultPrescriptionZoneAsHarvestedInput = {
  harvestingData?: InputMaybe<Array<UapiEvaluationResultHarvestingDataInput>>;
  isCheckStrip: Scalars['Boolean']['input'];
  zoneId: Scalars['String']['input'];
};

/** Evaluation Result artifact data related to the actual planting data within a prescription's zone. */
export type UapiEvaluationResultPrescriptionZoneAsPlanted = {
  __typename?: 'EvaluationResultPrescriptionZoneAsPlanted';
  isCheckStrip: Scalars['Boolean']['output'];
  plantingData?: Maybe<Array<UapiEvaluationResultPlantingData>>;
  summary?: Maybe<UapiEvaluationResultPlantingDataSummary>;
  zoneId: Scalars['String']['output'];
};

/** Input type for EvaluationResultPrescriptionZoneAsPlanted. */
export type UapiEvaluationResultPrescriptionZoneAsPlantedInput = {
  isCheckStrip: Scalars['Boolean']['input'];
  plantingData?: InputMaybe<Array<UapiEvaluationResultPlantingDataInput>>;
  zoneId: Scalars['String']['input'];
};

/**
 * Possible values for an evaluation status.
 *
 * Evaluation status represents the result of evaluating actual agronomic data for an activity against planned activity.
 * For example, when a field is enrolled in a program, a planting activity plan is created for the field plan.
 * After the planting activity is complete, the actual planting data for the field can be evaluated to determine if the activity was compliant with the plan.
 */
export enum UapiEvaluationStatus {
  COMPLIANT = 'COMPLIANT',
  INDETERMINATE = 'INDETERMINATE',
  NON_COMPLIANT = 'NON_COMPLIANT',
  PENDING = 'PENDING'
}

/**
 * Count of plan evaluation results with an evaluation status.
 *
 * Evaluation results could be for planting, harvest or other agronomic activity.
 */
export type UapiEvaluationStatusCount = {
  __typename?: 'EvaluationStatusCount';
  count: Scalars['Int']['output'];
  evaluationStatus: UapiEvaluationStatus;
};

/** Input to Export a prescription to JDOC as a Work Plan. */
export type UapiExportPrescriptionAsAjdocWorkPlanInput = {
  /** Prescription ID to export as a JDOC Work Plan */
  prescriptionId: Scalars['ID']['input'];
  /** JDOC Field that the prescriptions will be exported for. */
  targetJDOCFieldId: Scalars['ID']['input'];
  /** JDOC Organization where the prescriptions will be exported to. */
  targetJDOCOrganizationId: Scalars['ID']['input'];
  /** Unit of Measurement System for the Work Plan. Usually determined based on user preference in FieldView. */
  unitOfMeasurementSystem: UapiUnitOfMeasurementSystem;
};

/**
 * Input to Export prescriptions to JDOC Rx Files as a single compressed zip file.
 * https://developer.deere.com/dev-docs/files
 */
export type UapiExportPrescriptionsToJdocFilesInput = {
  /** If not provided, it will default to John Deere RX ShapeFile format */
  monitorFileFormatId?: InputMaybe<Scalars['ID']['input']>;
  /** List of one or multiple prescription IDs to export to JDOC Rx Files */
  prescriptionIds: Array<Scalars['ID']['input']>;
  /** JDOC Organization where the prescriptions will be exported to. */
  targetJDOCOrganizationId: Scalars['ID']['input'];
  /** Unit of Measurement System for Export prescriptions to JDOC. Usually determined based on user preference in FieldView. */
  unitOfMeasurementSystem: UapiUnitOfMeasurementSystem;
};

/**
 * Identifier of an object type specified in an external system.
 * ** deprecated: Unused identifier type for legacy programs **
 */
export type UapiExternalIdentity = {
  __typename?: 'ExternalIdentity';
  id: Scalars['ID']['output'];
  source: UapiExternalIdentitySource;
};

/**
 * A reference to an object by its entity (type) and unique identifier
 * ** deprecated: Unused identifier type for legacy programs **
 */
export enum UapiExternalIdentitySource {
  DART = 'DART'
}

/** A type to represent a farm where a field is contained */
export type UapiFarm = {
  __typename?: 'Farm';
  clientName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/**
 * Zone attributes for Prescription type: Fertility
 * See: https://gitlab.tcc.li/climate/cfvrec/saam/projects/prescription-manager/-/blob/main/prescription_manager/model/prescriptions/schema.py?ref_type=heads#L57-69
 */
export type UapiFertilityZone = UapiZone & {
  __typename?: 'FertilityZone';
  area: UapiMeasure;
  geometry: Scalars['GeoJSONGeometry']['output'];
  id: Scalars['ID']['output'];
  isCheckStrip: Scalars['Boolean']['output'];
  product: Array<UapiChemicalProduct>;
  rate?: Maybe<UapiMeasure>;
};

/** Fertility Zone Metadata */
export type UapiFertilityZoneMetadata = UapiZoneMetadata & {
  __typename?: 'FertilityZoneMetadata';
  /**
   * Average of all zone's application rate if it is set
   *   Returns null if application rate is not set for any zones.
   */
  applicationRateAvgAllZones?: Maybe<UapiMeasure>;
  /**
   * List of unique chemicals that are used for fertility prescription.
   *   Returns null if chemical products are not set.
   */
  chemicalProducts?: Maybe<Array<UapiChemicalProduct>>;
  /** The summation of each zone's area. */
  totalArea: UapiMeasure;
  /** The summation of each zone's area excluding zones that are marked as check strips. */
  totalAreaNoCheckStrip: UapiMeasure;
  /** Number of zones */
  totalNumZones: Scalars['Int']['output'];
};

/** A named enclosed area of land used for agricultural purposes such as cultivating crops. */
export type UapiField = UapiNode & {
  __typename?: 'Field';
  anomalies: Array<UapiFieldAnomalyValue>;
  /**
   * The parameters (cropId, seasonName, and years) are filters.  If omitted, all records are returned by default.  For
   *   example, if cropId is omitted, records for all crops are returned.
   */
  applicationEventAggregates?: Maybe<UapiApplicationEventAggregates>;
  area: UapiMeasure;
  /**
   * The audit metadata for Field with ONLY createdAt & updatedAt values
   *   createdBy and updatedBy values from Homestead are nullable which contradicts the schema
   */
  auditMetadata: UapiAuditMetadata;
  centroid: Scalars['GeoJSONGeometry']['output'];
  countryCode?: Maybe<Scalars['CountryCode']['output']>;
  cropMonitoring?: Maybe<UapiCropMonitoringFieldRecord>;
  enabled: Scalars['Boolean']['output'];
  farm: UapiFarm;
  firstAdministrativeDivisionCode?: Maybe<Scalars['String']['output']>;
  geometry: Scalars['GeoJSONGeometry']['output'];
  harvestEventAggregates?: Maybe<UapiHarvestEventAggregates>;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  machineDataMaps?: Maybe<UapiMachineDataMaps>;
  name: Scalars['String']['output'];
  /** The nearest known local cash price to this field for a given crop on a given date. */
  nearestAvailableLocalCashPrice?: Maybe<UapiLocalCashPrice>;
  operation: UapiOperation;
  plantingEventAggregates?: Maybe<UapiPlantingEventAggregates>;
  /**
   * List of prescriptions associated with this Field. The list includes both primary and non-primary prescriptions.
   *   Note: Each grower is permitted to have only one primary script per field, cropping year, and activity type.
   *   This also means a field can have multiple primary prescriptions as long as they are for different activity types or cropping years.
   */
  prescriptions: UapiPrescriptionConnection;
  /** The field enrollments linked to the field. */
  programEnrollments: Array<UapiFieldProgramEnrollment>;
  secondAdministrativeDivisionCode?: Maybe<Scalars['String']['output']>;
  source: UapiFieldSource;
  /** Includes FieldView subscription context for a field */
  subscriptions: UapiFieldViewFieldSubscriptionContext;
  timeZone?: Maybe<Scalars['String']['output']>;
  user: UapiUser;
};


/** A named enclosed area of land used for agricultural purposes such as cultivating crops. */
export type UapiFieldApplicationEventAggregatesArgs = {
  cropId?: InputMaybe<Scalars['ID']['input']>;
  seasonName?: InputMaybe<UapiSeasonName>;
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** A named enclosed area of land used for agricultural purposes such as cultivating crops. */
export type UapiFieldCropMonitoringArgs = {
  dataLegitimacy?: InputMaybe<UapiDataLegitimacyQuery>;
  seasonName?: InputMaybe<UapiSeasonName>;
  seasonYear: Scalars['Int']['input'];
};


/** A named enclosed area of land used for agricultural purposes such as cultivating crops. */
export type UapiFieldHarvestEventAggregatesArgs = {
  cropId?: InputMaybe<Scalars['ID']['input']>;
  seasonName?: InputMaybe<UapiSeasonName>;
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** A named enclosed area of land used for agricultural purposes such as cultivating crops. */
export type UapiFieldMachineDataMapsArgs = {
  activityType: UapiAgronomicActivityType;
  backendMachineDataSource?: InputMaybe<UapiBackendMachineDataSource>;
  cropId: Scalars['ID']['input'];
  dataLegitimacy?: InputMaybe<UapiDataLegitimacyQuery>;
  seasonName: UapiSeasonName;
  seasonYear: Scalars['Int']['input'];
};


/** A named enclosed area of land used for agricultural purposes such as cultivating crops. */
export type UapiFieldNearestAvailableLocalCashPriceArgs = {
  cropId: Scalars['ID']['input'];
  priceAsOf: Scalars['Date']['input'];
};


/** A named enclosed area of land used for agricultural purposes such as cultivating crops. */
export type UapiFieldPlantingEventAggregatesArgs = {
  cropId?: InputMaybe<Scalars['ID']['input']>;
  seasonName?: InputMaybe<UapiSeasonName>;
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** A named enclosed area of land used for agricultural purposes such as cultivating crops. */
export type UapiFieldPrescriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UapiFieldPrescriptionsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A named enclosed area of land used for agricultural purposes such as cultivating crops. */
export type UapiFieldProgramEnrollmentsArgs = {
  dataLegitimacy?: UapiDataLegitimacyQuery;
  itemStatus?: UapiItemStatusQuery;
  programInstanceIds: Array<Scalars['ID']['input']>;
};

/** Possible values in Field anomalies list */
export enum UapiFieldAnomalyValue {
  /** Geometry is too large */
  AREA_TOO_LARGE = 'AREA_TOO_LARGE',
  /** Geometry is too small */
  AREA_TOO_SMALL = 'AREA_TOO_SMALL',
  /** Ratio of bounding box area / geometry area is too large. Likely contains multiple actual fields */
  DISPERSE = 'DISPERSE',
  /** Geometry bounding box exceeds maximum size in either width or height. */
  ENVELOPE_TOO_LARGE = 'ENVELOPE_TOO_LARGE',
  /** Geometry is unmanageably complex, i.e. may cause problems during field health processing */
  HIGH_COMPLEXITY = 'HIGH_COMPLEXITY',
  /** Geometry is invalid, likely determined by JTS */
  INVALID_GEOMETRY = 'INVALID_GEOMETRY',
  /** Geometry is just a point */
  POINT = 'POINT',
  /** Geometry contains too many vertices */
  TOO_MANY_VERTICES = 'TOO_MANY_VERTICES',
  /** Geometry is located at (0, 0), in the Gulf of Guinea. */
  ZERO_ZERO = 'ZERO_ZERO'
}

/** Defines an applied activity on a field. */
export type UapiFieldApplyingTask = UapiNode & {
  __typename?: 'FieldApplyingTask';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  fieldPlan: UapiFieldPlan;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  products: Array<UapiAppliedProductPlan>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<UapiTaskState>;
};

/** Connection Type for Field. */
export type UapiFieldConnection = {
  __typename?: 'FieldConnection';
  /** Contains the nodes in this connection */
  edges: Array<UapiFieldEdge>;
  /** Pagination data for this connection */
  pageInfo: UapiPageInfo;
};

/** An edge in a connection. */
export type UapiFieldEdge = {
  __typename?: 'FieldEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UapiField;
};

/**
 * Union type for field program enrollment configuration.
 *
 * The actual type associated with a configuration may vary with a program instance.
 */
export type UapiFieldEnrollmentConfiguration = UapiDekalbIntegradoFieldEnrollmentConfiguration | UapiVAloraFieldEnrollmentConfiguration;

/**
 * The program-specific enrollment configurations.
 *
 * Only one field must be populated.
 */
export type UapiFieldEnrollmentDetailsInput = {
  /** Input parameters for enrolling in the Dekalb Integrado program. */
  dekalbIntegrado?: InputMaybe<UapiDekalbIntegradoFieldEnrollmentDetailsInput>;
  /** Input parameters for enrolling in the VAlora program. */
  valora?: InputMaybe<UapiVAloraFieldEnrollmentDetailsInput>;
};

/** Defines a harvesting activity on a field. */
export type UapiFieldHarvestingTask = UapiNode & {
  __typename?: 'FieldHarvestingTask';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  fieldPlan: UapiFieldPlan;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  results: UapiHarvestingEvaluationResultConnection;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<UapiTaskState>;
  trialContext?: Maybe<UapiTrialContext>;
};


/** Defines a harvesting activity on a field. */
export type UapiFieldHarvestingTaskResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: UapiResultsOnFieldHarvestingTaskFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A plan of what is to be done on a field for each agronomic activity. */
export type UapiFieldPlan = UapiNode & {
  __typename?: 'FieldPlan';
  applyingTasks: Array<UapiFieldApplyingTask>;
  auditMetadata: UapiAuditMetadata;
  /** @deprecated Use historicalAverage.yield instead */
  averageYield?: Maybe<UapiMeasure>;
  cropPlan: UapiCropPlan;
  dataLegitimacy: UapiDataLegitimacy;
  designer?: Maybe<UapiPlanDesigner>;
  dismissedAlerts: Array<UapiDismissedFieldPlanAlert>;
  field?: Maybe<UapiField>;
  harvestingTasks: Array<UapiFieldHarvestingTask>;
  historicalAverages?: Maybe<UapiFieldPlanHistoricalAverages>;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  notes: Array<UapiNote>;
  plannedCrop?: Maybe<UapiCrop>;
  plantingTasks: Array<UapiFieldPlantingTask>;
  previousCrop?: Maybe<UapiCrop>;
  tags: Array<Scalars['String']['output']>;
  targetYield?: Maybe<UapiMeasure>;
};

/** The connection type for FieldPlan. */
export type UapiFieldPlanConnection = {
  __typename?: 'FieldPlanConnection';
  edges: Array<UapiFieldPlanEdge>;
  pageInfo: UapiPageInfo;
};

/** An edge in a connection. */
export type UapiFieldPlanEdge = {
  __typename?: 'FieldPlanEdge';
  cursor: Scalars['String']['output'];
  node: UapiFieldPlan;
};

/** Holds historical average measurements for a field plan. */
export type UapiFieldPlanHistoricalAverages = {
  __typename?: 'FieldPlanHistoricalAverages';
  relativeMaturity: Array<UapiCropAverage>;
  seedingRate: Array<UapiCropAverage>;
  yield: Array<UapiCropAverage>;
};

/** Entity representing a set of field plans. */
export type UapiFieldPlanSet = {
  __typename?: 'FieldPlanSet';
  /**
   * Total planned area for fields in the field set.
   *   Null if there is no plan data for the set of fields (count is zero).
   *
   *   Note: The area for a field is the area at the time of creation of field plan.
   */
  area?: Maybe<UapiMeasure>;
  /** Count of fields in the field set. */
  count: Scalars['Int']['output'];
  /**
   * Plan Harvest Evaluation Result statics for the field plans.
   *
   *   Return value is Null if summary statistics cannot be computed.
   */
  harvestStats?: Maybe<UapiFieldPlanSetHarvestStats>;
};


/** Entity representing a set of field plans. */
export type UapiFieldPlanSetHarvestStatsArgs = {
  filter?: InputMaybe<UapiFieldPlanSetHarvestStatsFilter>;
};

/** Plan Harvest Summary Statistics for Fields in a field set. */
export type UapiFieldPlanSetHarvestStats = {
  __typename?: 'FieldPlanSetHarvestStats';
  /**
   * Weighted average yield for fields in the field set.
   *
   *   Null if there is no harvest data for the set of fields.
   */
  averageYield?: Maybe<UapiMeasure>;
  /** Count of fields in the field set. */
  count: Scalars['Int']['output'];
  /**
   * Total harvested area for fields in the field set.
   *
   *   The harvest area for a field only includes the area within a Field Boundary.
   *
   *   Null if there is no harvest data for the set of fields.
   */
  harvestedArea?: Maybe<UapiMeasure>;
  /**
   * Total planted area for the fields in the field set for the specified harvest stats filters.
   *
   *   The planted area for a field only includes the area within a Field Boundary.
   *
   *   Null if there is no planted data for the set of fields.
   */
  plantedArea?: Maybe<UapiMeasure>;
  /**
   * Return On Investment summary statistics for fields in the field set.
   *
   *   Null if there is no harvest data for the set of fields.
   */
  roiResultStats?: Maybe<UapiRoiResultStats>;
};

/** Filter type for Plan Harvest Stats Field Set. */
export type UapiFieldPlanSetHarvestStatsFilter = {
  /**
   * Evaluation offer of the harvest evaluation result.
   *
   *   If empty, evaluation offer is ignored.
   */
  evaluationOffers?: InputMaybe<Array<UapiProgramOfferType>>;
  /**
   * Evaluation statuses of harvest results.
   *
   *   If empty, harvest evaluation status is ignored.
   */
  evaluationStatuses?: InputMaybe<Array<UapiEvaluationStatus>>;
  /**
   * If True field plans with positive ROI will be used for summary stats.
   *
   *   If False field plans with negative ROI will be used for summary stats.
   *   If Null field plans with both positive and negative ROI will be used for summary stats.
   */
  hasPositiveRoi?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filters available for retrieving fieldPlans. */
export type UapiFieldPlansFilter = {
  dataLegitimacy?: UapiDataLegitimacyQuery;
  designerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fieldIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemStatuses?: InputMaybe<Array<UapiItemStatusQuery>>;
  updatedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  updatedSince?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Defines what seed products should be used when planting a field. */
export type UapiFieldPlantingTask = UapiNode & {
  __typename?: 'FieldPlantingTask';
  alternateProducts: Array<UapiSeedProductPlan>;
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  fieldPlan: UapiFieldPlan;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  method?: Maybe<UapiEvaluationMethod>;
  notes: Array<UapiNote>;
  plantingMethod?: Maybe<UapiPlantingMethod>;
  prescriptionContext?: Maybe<UapiPrescriptionContext>;
  products: Array<UapiSeedProductPlan>;
  results: UapiPlantingEvaluationResultConnection;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<UapiTaskState>;
  targetPlantingDate?: Maybe<Scalars['Date']['output']>;
};


/** Defines what seed products should be used when planting a field. */
export type UapiFieldPlantingTaskResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: UapiResultsOnFieldPlantingTaskFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Input to filter prescriptions for a specific field */
export type UapiFieldPrescriptionsFilter = {
  /**
   * Filter by if the prescription is primary prescription or not.
   *   Use null to apply no filter on this criteria.
   */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Filter by season name
   *   Using null or empty list applies no filter on this criteria.
   */
  seasonName?: InputMaybe<UapiSeasonName>;
  /**
   * Filter by prescription types
   *   Using null or empty list applies no filter on this criteria.
   */
  types?: InputMaybe<Array<UapiPrescriptionType>>;
  /**
   * Filter by cropping years
   *   Using null or empty list applies no filter on this criteria.
   */
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** The enrollment of a field into a program instance. */
export type UapiFieldProgramEnrollment = UapiNode & {
  __typename?: 'FieldProgramEnrollment';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  /** The most recent eligibility result for the field and program instance pair. */
  eligibilityResult?: Maybe<UapiFieldProtocolEligibilityResult>;
  /**
   * Field area when the field was enrolled.
   *
   *   Value is null if the enrollmentStatus is not ENROLLED.
   */
  enrolledArea?: Maybe<UapiMeasure>;
  /**
   * Date time when the field was enrolled.
   *
   *   Value is null if the enrollmentStatus is not ENROLLED.
   */
  enrolledAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * User who enrolled the field.
   *
   *   Value is null if the enrollmentStatus is not ENROLLED.
   */
  enrolledBy?: Maybe<UapiParty>;
  /**
   * Configuration associated with the field enrollment.
   *
   *   The configuration object is usecase specific.
   */
  enrollmentConfiguration?: Maybe<UapiFieldEnrollmentConfiguration>;
  /** The state of the field enrollment. */
  enrollmentStatus: UapiFieldProgramEnrollmentStatus;
  /** The field associated with the enrollment. */
  field: UapiField;
  /** The grower enrollment associated with the field enrollment. */
  growerProgramEnrollment: UapiGrowerProgramEnrollment;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  /** The field plan associated with the field enrollment. */
  plan?: Maybe<UapiFieldPlan>;
  /** The program instance associated with the enrollment. */
  programInstance: UapiProgramInstance;
  tenant: UapiParty;
  /** Whether the field enrollment has been unenrolled from the program. */
  unenrolled: Scalars['Boolean']['output'];
};

/** A paginated connection for field enrollment. */
export type UapiFieldProgramEnrollmentConnection = {
  __typename?: 'FieldProgramEnrollmentConnection';
  edges: Array<UapiFieldProgramEnrollmentEdge>;
  pageInfo: UapiPageInfo;
};

/** A pagination edge in a connection for field enrollment. */
export type UapiFieldProgramEnrollmentEdge = {
  __typename?: 'FieldProgramEnrollmentEdge';
  cursor: Scalars['String']['output'];
  node: UapiFieldProgramEnrollment;
};

/** Columns available for sorting field program enrollments. */
export enum UapiFieldProgramEnrollmentOrderColumn {
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT'
}

/** Ordering parameters for field program enrollments. */
export type UapiFieldProgramEnrollmentOrderInput = {
  column?: UapiFieldProgramEnrollmentOrderColumn;
  direction?: UapiOrderByDirection;
};

/** Possible states of a field enrollment in a program instance. */
export enum UapiFieldProgramEnrollmentStatus {
  /** Not enough data was available to determine the eligibility of the field for the program instance. */
  AWAITING_DATA = 'AWAITING_DATA',
  /** The field is eligible for the program instance. */
  ELIGIBLE = 'ELIGIBLE',
  /** The field is enrolled in the program instance. */
  ENROLLED = 'ENROLLED',
  /** The eligibility of the field for the program instance cannot be determined. */
  INDETERMINATE = 'INDETERMINATE',
  /** The field is not eligible for the program instance. */
  INELIGIBLE = 'INELIGIBLE',
  /**
   * The field is nominated for the program instance.
   *
   *   When a grower is nominated to a program instance, all of their fields are
   *   automatically nominated as well.
   */
  NOMINATED = 'NOMINATED',
  /** The eligibility of the field for the program instance has not yet been determined. */
  PENDING = 'PENDING'
}

/**
 * Count of field enrollments in a program by enrollment status.
 *
 * This is used to summarize the count of fields enrolled in a program by the enrollment status for a grower's program enrollment.
 */
export type UapiFieldProgramEnrollmentStatusCount = {
  __typename?: 'FieldProgramEnrollmentStatusCount';
  count: Scalars['Int']['output'];
  enrollmentStatus: UapiFieldProgramEnrollmentStatus;
};

/** Possible values when querying on a field program enrollment by status. */
export enum UapiFieldProgramEnrollmentStatusQuery {
  ALL = 'ALL',
  /** Not enough data was available to determine the eligibility of the field for the program instance. */
  AWAITING_DATA = 'AWAITING_DATA',
  /** The field is eligible for the program instance. */
  ELIGIBLE = 'ELIGIBLE',
  /** The field is enrolled in the program instance. */
  ENROLLED = 'ENROLLED',
  /** The eligibility of the field for the program instance cannot be determined. */
  INDETERMINATE = 'INDETERMINATE',
  /** The field is not eligible for the program instance. */
  INELIGIBLE = 'INELIGIBLE',
  /** The field has been nominated for enrollment into the program instance. */
  NOMINATED = 'NOMINATED',
  /** The eligibility of the field for the program instance has not yet been determined. */
  PENDING = 'PENDING'
}

/** The eligibility of a field for a protocol. */
export type UapiFieldProtocolEligibilityResult = UapiNode & {
  __typename?: 'FieldProtocolEligibilityResult';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  /** The state of the eligibility result. */
  eligibilityStatus: UapiProtocolEligibilityStatus;
  /** The field associated with the eligibility result. */
  field: UapiField;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  /** The protocol associated with the eligibility result. */
  protocol: UapiProtocol;
  /** The results of the individual rules. */
  ruleResults: Array<UapiRuleResult>;
  tenant: UapiParty;
};

/**
 * Machine data stats from a particular field region, crop, season and year.
 * If region geometry is not supplied, all data linked to that field will be considered.
 * plantingStats and harvestStats may be null depending on planting and harvest data being available
 * in machine-data-subgraph datastore.
 */
export type UapiFieldRegionStats = {
  __typename?: 'FieldRegionStats';
  crop: UapiCrop;
  field: UapiField;
  harvestStats?: Maybe<UapiHarvestStats>;
  plantingStats?: Maybe<UapiPlantingStats>;
  region?: Maybe<Scalars['GeoJSONGeometry']['output']>;
  seasonName: UapiSeasonName;
  seasonYear: Scalars['Int']['output'];
};

/** An enum to describe the attributes that the fields are to be sorted by */
export enum UapiFieldSortByValue {
  NAME = 'NAME'
}

/** The field source returned from Homestead */
export type UapiFieldSource = {
  __typename?: 'FieldSource';
  attributes: UapiFieldSourceValue;
  boundary: UapiFieldSourceValue;
};

/** Possible values for field boundary & attribute sources from Homestead */
export enum UapiFieldSourceValue {
  API_CLIENT = 'API_CLIENT',
  DATAINBOX_IMPORT = 'DATAINBOX_IMPORT',
  DATAINBOX_MAPSHOTS = 'DATAINBOX_MAPSHOTS',
  DATAINBOX_OTHER = 'DATAINBOX_OTHER',
  DATAINBOX_SUMMIT = 'DATAINBOX_SUMMIT',
  EQUIPMENT_GENERATED = 'EQUIPMENT_GENERATED',
  EQUIPMENT_GENERATED_BEFORE_2018 = 'EQUIPMENT_GENERATED_BEFORE_2018',
  FIELDVIEW = 'FIELDVIEW',
  FIELDVIEW_IMPORT = 'FIELDVIEW_IMPORT',
  FIELD_SELECTION_ANDROID = 'FIELD_SELECTION_ANDROID',
  FIELD_SELECTION_IOS = 'FIELD_SELECTION_IOS',
  FIELD_SYNC = 'FIELD_SYNC',
  INTEGRATION_TEST = 'INTEGRATION_TEST',
  MAPPING_AND_FIELD_SELECTION = 'MAPPING_AND_FIELD_SELECTION',
  MFS_CUSTOM_FIELD = 'MFS_CUSTOM_FIELD',
  SETI = 'SETI'
}

/** Represents a FieldView feature */
export type UapiFieldViewFeature = {
  __typename?: 'FieldViewFeature';
  /** The name of this subscription feature */
  name: Scalars['String']['output'];
};

/** Represent a snapshot of field subscription context such as features and products */
export type UapiFieldViewFieldSubscriptionContext = {
  __typename?: 'FieldViewFieldSubscriptionContext';
  /** List of products purchased/obtained through subscriptions the entity has */
  currentFieldViewProducts: Array<UapiFieldViewProduct>;
  /** List of eligible features based on the subscription(s) the entity has */
  eligibleFieldViewFeatures: Array<UapiFieldViewFeature>;
};

/** Represents a snapshot of the operation subscription context */
export type UapiFieldViewOperationSubscriptionContext = {
  __typename?: 'FieldViewOperationSubscriptionContext';
  /** List of products purchased/obtained through subscriptions the entity has */
  currentFieldViewProducts: Array<UapiFieldViewProduct>;
  /** List of eligible features based on the subscription(s) the entity has */
  eligibleFieldViewFeatures: Array<UapiFieldViewFeature>;
  /** Primary subscription tier for an entity */
  primaryFieldViewSubscription: UapiFieldViewSubscription;
  /** List of higher tier products that the customer or representative can upgrade to */
  upsellFieldViewProducts: Array<UapiFieldViewProduct>;
};

/** Represents a product stored in Product Assets */
export type UapiFieldViewProduct = {
  __typename?: 'FieldViewProduct';
  /** If the product is active or not */
  active: Scalars['Boolean']['output'];
  /** The country this specific product is offerred. Operation's without subscriptions (free) will return null */
  country?: Maybe<Scalars['CountryCode']['output']>;
  /** The features enabled by the product */
  features: Array<UapiFieldViewFeature>;
  /** The name of this product */
  name: Scalars['String']['output'];
  /** If the product is paid */
  paidProduct: Scalars['Boolean']['output'];
  /** The product year. Operation's without subscriptions (free) will return null */
  productYear?: Maybe<Scalars['Int']['output']>;
  /** FieldView product type */
  type: UapiFieldViewProductType;
};

/** Represents a FieldView product trial */
export type UapiFieldViewProductTrial = {
  __typename?: 'FieldViewProductTrial';
  /** The country this specific product is offerred */
  country: Scalars['CountryCode']['output'];
  /** The name of this product */
  name: Scalars['String']['output'];
  /** FieldView Product Trail details */
  trial: UapiFieldViewProductTrialDetails;
  /** List of trial fields IDs */
  trialFields: Array<Scalars['ID']['output']>;
};

/** Represents a field view product trial details */
export type UapiFieldViewProductTrialDetails = {
  __typename?: 'FieldViewProductTrialDetails';
  /** Number of fields allowed */
  numberOfFieldsAllowed: Scalars['Int']['output'];
  /** Number of fields enabled */
  numberOfFieldsEnabled: Scalars['Int']['output'];
};

/** Represents a FieldView Product Type */
export enum UapiFieldViewProductType {
  /** The standard product type. */
  STANDARD = 'STANDARD'
}

/** Represents a operation-level or field-level subscription stored in Product Assets */
export type UapiFieldViewSubscription = {
  __typename?: 'FieldViewSubscription';
  /** The expiration date of this subscription. Operation's without subscriptions (free) will return null */
  expirationDate?: Maybe<Scalars['Date']['output']>;
  /** The public name of this subscription */
  name: Scalars['String']['output'];
  /** The product associated to this subscription */
  product: UapiFieldViewProduct;
  /** The provisions associated to this subscription */
  provisions: Array<UapiFieldViewSubscriptionProvision>;
};

/** Represents a provision of a FieldView subscription */
export type UapiFieldViewSubscriptionProvision = {
  __typename?: 'FieldViewSubscriptionProvision';
  auditMetadata: UapiAuditMetadata;
  marketYear: Scalars['Int']['output'];
  provisionStatus: UapiFieldViewSubscriptionProvisionStatus;
  sponsor: UapiUser;
};

/** Request to provision a FieldView subscription */
export type UapiFieldViewSubscriptionProvisionInput = {
  country: Scalars['CountryCode']['input'];
  dataLegitimacy?: UapiDataLegitimacy;
  marketYear: Scalars['Int']['input'];
  productName: Scalars['String']['input'];
  recipientEmail: Scalars['String']['input'];
  validFrom: Scalars['DateTime']['input'];
  validUntil: Scalars['DateTime']['input'];
};

/** Response returned after provisioning (or attempting to provision) a FieldView subscription */
export type UapiFieldViewSubscriptionProvisionResponse = {
  __typename?: 'FieldViewSubscriptionProvisionResponse';
  auditMetadata: UapiAuditMetadata;
  country: Scalars['CountryCode']['output'];
  dataLegitimacy: UapiDataLegitimacy;
  id: Scalars['ID']['output'];
  marketYear: Scalars['Int']['output'];
  product: UapiFieldViewProduct;
  provisionStatus: UapiFieldViewSubscriptionProvisionStatus;
  recipientEmail: Scalars['String']['output'];
  sponsor: UapiUser;
  validFrom: Scalars['DateTime']['output'];
  validUntil: Scalars['DateTime']['output'];
};

/** The status of a FieldView subscription provision */
export enum UapiFieldViewSubscriptionProvisionStatus {
  /** The provision is activated & product asset expiration is updated */
  ACTIVATED = 'ACTIVATED',
  /** The provision is assigned & ready for provision within market year */
  ASSIGNED = 'ASSIGNED'
}

/** Input to specify filters and sorting options for fields */
export type UapiFieldsSearchControlInput = {
  partialNameSearch?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<UapiFieldSortByValue>;
  sortDirection?: InputMaybe<UapiSortDirection>;
};

/** A type to represent the stats of a field */
export type UapiFieldsStats = {
  __typename?: 'FieldsStats';
  count?: Maybe<Scalars['Int']['output']>;
  totalArea?: Maybe<UapiMeasure>;
};

/** A range of floats for input purposes. */
export type UapiFloatRangeInput = {
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  maxValueInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  minValue?: InputMaybe<Scalars['Float']['input']>;
  minValueInclusive?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Fungicide Recommendation Details */
export type UapiFungicideApplicationDetail = {
  __typename?: 'FungicideApplicationDetail';
  eligibility: Scalars['Boolean']['output'];
  factors?: Maybe<Array<UapiFungicideApplicationFactor>>;
  reason: Scalars['String']['output'];
};

/** Fungicide Application Recommendation Factor */
export type UapiFungicideApplicationFactor = {
  __typename?: 'FungicideApplicationFactor';
  description?: Maybe<Scalars['String']['output']>;
  factor: Scalars['String']['output'];
};

/** Fungicide Application Recommendation */
export type UapiFungicideApplicationRecommendation = UapiNode & UapiProgramRecommendation & {
  __typename?: 'FungicideApplicationRecommendation';
  id: Scalars['ID']['output'];
  metadata: UapiRecommendationMetadata;
  recommendations?: Maybe<Array<UapiFungicideApplicationDetail>>;
  subject: UapiField;
  subjectParty?: Maybe<UapiParty>;
};

/** Fungicide Application Recommendation Connection */
export type UapiFungicideApplicationRecommendationConnection = {
  __typename?: 'FungicideApplicationRecommendationConnection';
  edges: Array<UapiFungicideApplicationRecommendationEdge>;
  pageInfo: UapiPageInfo;
};

/** Fungicide Application Recommendation Edge */
export type UapiFungicideApplicationRecommendationEdge = {
  __typename?: 'FungicideApplicationRecommendationEdge';
  cursor: Scalars['String']['output'];
  node: UapiFungicideApplicationRecommendation;
};

/** Input objects to specify the field and additional parameters necesssary for the zone generation process */
export type UapiGenerateZonesInput = {
  /** List of CCI layer inputs to use for zone generation (nullable) */
  cciLayers?: InputMaybe<UapiZoneGenerationCciLayerInput>;
  /** Selection of zoning model to use for zone generation */
  model: UapiZoneModel;
  /** Explicit number of zones recommended by the user (nullable); if omitted, the optimal number of zones is selected */
  numberOfZones?: InputMaybe<Scalars['Int']['input']>;
  /** Target object on which to perform zone generation including ID and type information */
  target: UapiZoneGenerationTarget;
  /** List of yield layer inputs to use for zone generation (nullable) */
  yieldLayers?: InputMaybe<UapiZoneGenerationYieldLayerInput>;
};

/**
 * Union type representing different kinds of geospatial assets used in visualizations.
 * Each type may require specific parameters for correct rendering.
 */
export type UapiGeospatialAsset = UapiRasterTileset;

/**
 * Defines the legend associated with a geospatial asset, providing context for visualization of the data.
 * Includes a title, optional description, a list of legend items, and units of measurement.
 * These legends are most commonly associated with raster assets where the data is burned into pixels
 * and a legend will for comprehension.
 */
export type UapiGeospatialAssetLegend = {
  __typename?: 'GeospatialAssetLegend';
  items: Array<UapiGeospatialAssetLegendItem>;
  units?: Maybe<Scalars['String']['output']>;
};

/** Represents an individual item in a  geospatial asset legend, specifying its value and color. */
export type UapiGeospatialAssetLegendItem = {
  color: UapiRgba;
};

/**
 * Enumeration of possible sources for geospatial assets available for visualization.
 * These types describe where the asset was generated.
 */
export enum UapiGeospatialAssetSource {
  AG_VIZ = 'AG_VIZ',
  FV_SPATIAL = 'FV_SPATIAL'
}

/** A grower eligibility result. */
export type UapiGrowerEligibilityResult = UapiNode & {
  __typename?: 'GrowerEligibilityResult';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  eligibilityStatus: UapiEligibilityStatus;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  /** Eligibility rule results */
  ruleResults?: Maybe<Array<UapiRuleResult>>;
  tenant: UapiParty;
};

/** The enrollment of a grower into a program instance. */
export type UapiGrowerProgramEnrollment = UapiNode & {
  __typename?: 'GrowerProgramEnrollment';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  eligibilityResult?: Maybe<UapiGrowerEligibilityResult>;
  /** Field Set representing the enrolled fields for the grower program enrollment. */
  enrolledFieldPlanSet: UapiFieldPlanSet;
  /** The state of the grower enrollment. */
  enrollmentStatus: UapiGrowerProgramEnrollmentStatus;
  /** The field enrollments linked to the grower enrollment. */
  fieldProgramEnrollments: UapiFieldProgramEnrollmentConnection;
  /** The grower associated with the enrollment. */
  grower: UapiUser;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  /** Flag to indicate if an enrollment requires assistance. */
  needsAssistance: Scalars['Boolean']['output'];
  /** The program instance associated with the enrollment. */
  programInstance: UapiProgramInstance;
  /** Rebate, Incentive or Offer Payments made to the Grower Enrolled in a Program. */
  programPayments: Array<UapiProgramPayment>;
  /**
   * Statistics representing the progress of the grower participation in the enrolled program.
   *
   *   Return value is Null if the progress statistics cannot be computed or cannot be fetched due to lack of authorization or other intermittent errors.
   */
  programProgressStats?: Maybe<UapiGrowerProgramProgressStats>;
  /**
   * True if the reconciliation has been completed for the grower program enrollment.
   *
   *   An enrollment is marked as reconciled after reviewing program compliance for the
   *   participating fields and initiating pending payments to the enrolled grower.
   */
  reconciled: Scalars['Boolean']['output'];
  /**
   * Datetime when the enrollment was reconciled.
   *
   *   Not null only when enrollment status is reconciled.
   */
  reconciledAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Party that reconciled the enrollment for the season.
   *
   *   This could be a service that marks the enrollments as reconciled at the end of season.
   *   Not null only when enrollment status is reconciled.
   */
  reconciledBy?: Maybe<UapiParty>;
  /** Recorded agreement for the enrollment. */
  recordedAgreement?: Maybe<UapiRecordedAgreement>;
  tenant: UapiParty;
  /**
   * Total Rebate, Incentive or Offer payment amount.
   *
   *   Amount value will be 0.00, if no payments were made to the grower.
   */
  totalPaymentAmount: UapiMonetaryAmount;
};


/** The enrollment of a grower into a program instance. */
export type UapiGrowerProgramEnrollmentFieldProgramEnrollmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: UapiGrowerProgramEnrollmentsFieldProgramEnrollmentFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UapiFieldProgramEnrollmentOrderInput>>;
};

/** A paginated connection for grower enrollment. */
export type UapiGrowerProgramEnrollmentConnection = {
  __typename?: 'GrowerProgramEnrollmentConnection';
  edges: Array<UapiGrowerProgramEnrollmentEdge>;
  pageInfo: UapiPageInfo;
};

/** A pagination edge in a connection for grower enrollment. */
export type UapiGrowerProgramEnrollmentEdge = {
  __typename?: 'GrowerProgramEnrollmentEdge';
  cursor: Scalars['String']['output'];
  node: UapiGrowerProgramEnrollment;
};

/** Columns available for sorting grower program enrollments. */
export enum UapiGrowerProgramEnrollmentOrderBy {
  UPDATED_AT = 'UPDATED_AT'
}

/** Ordering parameters for grower program enrollments. */
export type UapiGrowerProgramEnrollmentOrdering = {
  by?: UapiGrowerProgramEnrollmentOrderBy;
  direction?: UapiOrderByDirection;
};

/** Possible states of a grower enrollment in a program instance. */
export enum UapiGrowerProgramEnrollmentStatus {
  /** Not enough data was available to determine the eligibility of the grower for the program instance. */
  AWAITING_DATA = 'AWAITING_DATA',
  /** The grower is eligible for the program instance. */
  ELIGIBLE = 'ELIGIBLE',
  /**
   * The grower is enrolled in the program instance.
   *
   *   In VAlora, this state is reached with the grower signs the terms & conditions.
   */
  ENROLLED = 'ENROLLED',
  /** The eligibility of the grower for the program instance cannot be determined. */
  INDETERMINATE = 'INDETERMINATE',
  /** The grower is not eligible for the program instance. */
  INELIGIBLE = 'INELIGIBLE',
  /**
   * The grower is nominated for the program instance.
   *
   *   This state is reached when the CSR nominates a grower to a program instance.
   */
  NOMINATED = 'NOMINATED',
  /** The eligibility of the grower for the program instance has not yet been determined. */
  PENDING = 'PENDING',
  /**
   * The grower is pre-enrolled in the program instance.
   *
   *   For VAlora, this state is reached if a grower opts to send a terms &
   *   conditions email as opposed to signing directly. If the grower signs the T&C
   *   directly this state is skipped.
   */
  PRE_ENROLLED = 'PRE_ENROLLED'
}

/** Possible values when querying on a grower program enrollment by status. */
export enum UapiGrowerProgramEnrollmentStatusQuery {
  ALL = 'ALL',
  /** Not enough data was available to determine the eligibility of the grower for the program instance. */
  AWAITING_DATA = 'AWAITING_DATA',
  /** The grower is eligible for the program instance. */
  ELIGIBLE = 'ELIGIBLE',
  /** The grower is enrolled in the program instance. */
  ENROLLED = 'ENROLLED',
  /** The eligibility of the grower for the program instance cannot be determined. */
  INDETERMINATE = 'INDETERMINATE',
  /** The grower is not eligible for the program instance. */
  INELIGIBLE = 'INELIGIBLE',
  /** The grower is nominated for the program instance. */
  NOMINATED = 'NOMINATED',
  /** The eligibility of the grower for the program instance has not yet been determined. */
  PENDING = 'PENDING',
  /** The grower is pre-enrolled in the program instance. */
  PRE_ENROLLED = 'PRE_ENROLLED'
}

/** Filters available for retrieving field enrollments on a grower enrollment. */
export type UapiGrowerProgramEnrollmentsFieldProgramEnrollmentFilter = {
  dataLegitimacy?: UapiDataLegitimacyQuery;
  /** Filter the results by enrollment status. */
  enrollmentStatus?: UapiFieldProgramEnrollmentStatusQuery;
  /** Filter the results by field. */
  fieldIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemStatus?: UapiItemStatusQuery;
};

/**
 * Statistics representing the progress of a grower participation in a program.
 *
 * For Advisors, these statistics provide a quick overview of how various growers are participating in the program and help Advisors identify growers who may need additional support or intervention.
 */
export type UapiGrowerProgramProgressStats = {
  __typename?: 'GrowerProgramProgressStats';
  /** Counts of fields by enrolled offer type. */
  enrolledOfferCounts: Array<UapiEnrolledOfferTypeCount>;
  /** Counts of fields by program enrollment status. */
  fieldEnrollmentStatusCounts: Array<UapiFieldProgramEnrollmentStatusCount>;
  /** Counts of fields by harvesting evaluation status. */
  harvestingEvaluationStatusCounts: Array<UapiEvaluationStatusCount>;
  /** Counts of fields by planting evaluation status. */
  plantingEvaluationStatusCounts: Array<UapiEvaluationStatusCount>;
  /** Counts of fields by prescription approval status. */
  prescriptionApprovalCounts: Array<UapiPrescriptionApprovalStatusCount>;
};

/** A filter for growth stage predictions that overlap with a specific date range. */
export type UapiGrowthStageDateRangeFilter = {
  /**
   * The date range to filter growth stage predictions by.
   *   Predictions are included if they overlap with this range.
   */
  dateRange: UapiDateRangeInput;
  /** Optional. If provided, only growth stages with these IDs are considered. */
  growthStageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** An observed growth stage associated with a crop monitoring field extent. */
export type UapiGrowthStageObservation = {
  __typename?: 'GrowthStageObservation';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  growthStage: UapiCropGrowthStage;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  observedOn: Scalars['Date']['output'];
};

/** Hail NotificationData */
export type UapiHailNotificationData = {
  __typename?: 'HailNotificationData';
  fields: Array<UapiHailNotificationDataField>;
  timeInterval: Scalars['String']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
  totalFieldCount?: Maybe<Scalars['Int']['output']>;
  units: Scalars['String']['output'];
};

/** Hail Notification DataField */
export type UapiHailNotificationDataField = {
  __typename?: 'HailNotificationDataField';
  acres?: Maybe<Scalars['Float']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  hailSize: Scalars['Float']['output'];
  hailSizeRange?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  operationId: Scalars['ID']['output'];
  primaryFieldId: Scalars['ID']['output'];
  pro?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/**
 * Aggregated data related to a single harvest event that occurred for a specific season and year involving a particular
 * crop and seed product.  For example, the average yield might represent the average yield per hectare for corn grown in
 * SPRING of 2023 using seed product DEKALB DKC081-18RIB.  Note that the seed product may be null if we don't have a record
 * for it.
 */
export type UapiHarvestEvent = {
  __typename?: 'HarvestEvent';
  averageYield: UapiMeasure;
  crop: UapiCrop;
  harvestedArea: UapiMeasure;
  seasonName: UapiSeasonName;
  seasonYear: Scalars['Int']['output'];
  seedProduct?: Maybe<UapiSeedProduct>;
};

/**
 * Harvest data aggregated over multiple years for a specified season and crop.  Note that seed products are not provided
 * at this level of aggregation because multiple seed products could be grown over a series of years.  However, this
 * aggregate includes a list of the HarvestEvent entities used to generate the aggregation, so the caller can re-aggregate
 * the data as required.
 */
export type UapiHarvestEventAggregates = {
  __typename?: 'HarvestEventAggregates';
  averageYield: UapiMeasure;
  events?: Maybe<Array<UapiHarvestEvent>>;
  eventsByCropSeason?: Maybe<Array<UapiHarvestEventByCropSeason>>;
  maximumYield: UapiMeasure;
  maximumYieldYear: Scalars['Int']['output'];
  numYears: Scalars['Int']['output'];
};


/**
 * Harvest data aggregated over multiple years for a specified season and crop.  Note that seed products are not provided
 * at this level of aggregation because multiple seed products could be grown over a series of years.  However, this
 * aggregate includes a list of the HarvestEvent entities used to generate the aggregation, so the caller can re-aggregate
 * the data as required.
 */
export type UapiHarvestEventAggregatesEventsByCropSeasonArgs = {
  backendMachineDataSource?: InputMaybe<UapiBackendMachineDataSource>;
};

/**
 * Aggregated metrics for one harvest event for a specific crop, season name, and year.
 *
 * Additional attributes (e.g., seed product) may be added in the future.
 */
export type UapiHarvestEventByCropSeason = {
  __typename?: 'HarvestEventByCropSeason';
  /**
   * Standardized yield.
   *   Calculated as: #$#wetMass * moistureFactor / harvestedArea#$#
   *   moistureFactor (crop/region-specific) normalizes wet mass to a standard moisture content.
   */
  averageStdYield: UapiMeasure;
  /**
   * Wet yield (mass per area).
   *   Calculated as: #$#wetMass / harvestedArea#$#
   */
  averageWetYield?: Maybe<UapiMeasure>;
  crop: UapiCrop;
  /**
   * Total dry mass (standardized).
   *   Calculated as: #$#averageStdYield * harvestedArea#$#
   */
  dryMass: UapiMeasure;
  /** Earliest harvest timestamp for that crop/season/year based on the field location. */
  firstHarvestLocalDate: Scalars['DateTime']['output'];
  /** Earliest harvest timestamp for that crop/season/year in UTC. */
  firstHarvestedDateTime: Scalars['DateTime']['output'];
  harvestedArea: UapiMeasure;
  /** Latest harvest timestamp for that crop/season/year based on the field location. */
  lastHarvestLocalDate: Scalars['DateTime']['output'];
  /** Latest harvest timestamp; the interval between first and last is the harvest window in UTC. */
  lastHarvestedDateTime: Scalars['DateTime']['output'];
  /**
   * legacySeasonTag is a temporary, deprecated compatibility field used by existing Web/Mobile clients.
   *   Use seasonName and seasonYear going forward.
   * @deprecated Please use seasonName and seasonYear
   */
  legacySeasonTag?: Maybe<Scalars['String']['output']>;
  /**
   * Mass of water in the harvested material.
   *   Calculated as: #$#moistureMass = wetMass * (moisturePercent / 100)#$#
   */
  moistureMass?: Maybe<UapiMeasure>;
  /** Moisture reading expressed as a percentage (0–100). */
  moisturePercent?: Maybe<UapiMeasure>;
  /**
   * The number of pounds of dry grain in a bushel.
   *   For example, the default nominal weight for corn is 56 pounds per bushel.
   *   This field is nullable since some speciality crops do not have a nominal weight value.
   */
  nominalWeight?: Maybe<UapiMeasure>;
  seasonName: UapiSeasonName;
  seasonYear: Scalars['Int']['output'];
  wetMass?: Maybe<UapiMeasure>;
};

/** Aggregated harvest stats by: Crop */
export type UapiHarvestStats = {
  __typename?: 'HarvestStats';
  /** This will always have at least 1 element (even if seedProduct = null) */
  bySeedProduct: Array<UapiHarvestStatsBySeedProduct>;
  crop: UapiCrop;
  /** Example: Measure(u: "percent", v: 15.5) */
  cropNominalMoisture: UapiMeasure;
  /** Example: Measure(u: "pounds/bushel", v: 56) */
  cropNominalWeight: UapiMeasure;
  data: UapiHarvestStatsData;
};

/** Aggregated harvest stats by: Crop, SeedProduct */
export type UapiHarvestStatsBySeedProduct = {
  __typename?: 'HarvestStatsBySeedProduct';
  crop: UapiCrop;
  /** Example: Measure(u: "percent", v: 15.5) */
  cropNominalMoisture: UapiMeasure;
  /** Example: Measure(u: "pounds/bushel", v: 56) */
  cropNominalWeight: UapiMeasure;
  data: UapiHarvestStatsData;
  seedProduct?: Maybe<UapiSeedProduct>;
};

/**
 * Aggregated harvest stats data with Post Harvest Adjustments applied when available.
 * Definitions:
 * ### Possible Post Harvest Adjustments:
 * - Crop:
 * - nominalMoisture
 * - shrinkFactor
 * - Field:
 * - wetMass: affects wetMass, moistureMass, moistureRatio
 * - moistureRatio: affects moistureRatio, moistureMass
 * - harvestedArea: affects harvestArea, averageYield
 * - Machine:
 * - trueUp: affects dryWeight, wetMass, moistureMass, averageYield
 */
export type UapiHarvestStatsData = {
  __typename?: 'HarvestStatsData';
  /** Average yield in standard unit: 'kg/ha'. */
  averageYield: UapiMeasure;
  /** Total weight of yield in standard unit: 'kg'. Result of multiplying 'averageYield' by 'harvestedArea'. */
  dryWeight: UapiMeasure;
  /** Uses standard unit: 'ha'. */
  harvestedArea: UapiMeasure;
  /** True if any type of PHA was applied like machine, field, crop. */
  hasPha: Scalars['Boolean']['output'];
  /** Total weight of water in standard unit: 'kg'. */
  moistureMass: UapiMeasure;
  /** It's calculated from: moistureMass / wetMass. */
  moistureRatio: Scalars['Float']['output'];
  /** Total weight of mass including moisture in standard unit: 'kg'. */
  wetMass: UapiMeasure;
};

/** Aggregated harvest stats for a set of fields */
export type UapiHarvestStatsForFieldSet = {
  __typename?: 'HarvestStatsForFieldSet';
  fields: Array<UapiField>;
  harvestedArea: UapiMeasure;
  /** number of fields with any harvest records available, given the parameters provided (i.e., crop, seasonName, years) */
  numFieldsWithHarvestRecords: Scalars['Int']['output'];
  summaryByCropSeason: Array<UapiHarvestStatsForFieldSetSummaryByCropSeason>;
};

/** Aggregated harvest stats for a set of fields, crop and season. */
export type UapiHarvestStatsForFieldSetSummaryByCropSeason = {
  __typename?: 'HarvestStatsForFieldSetSummaryByCropSeason';
  /**
   * Standardized yield.
   *   Calculated as: #$#wetMass * moistureFactor / harvestedArea#$#
   *   moistureFactor (crop/region-specific) normalizes wet mass to a standard moisture content.
   */
  averageStdYield: UapiMeasure;
  /**
   * Wet yield (mass per area).
   *   Calculated as: #$#wetMass / harvestedArea#$#
   */
  averageWetYield?: Maybe<UapiMeasure>;
  crop: UapiCrop;
  /**
   * Total dry mass (standardized).
   *   Calculated as: #$#averageStdYield * harvestedArea#$#
   */
  dryMass: UapiMeasure;
  harvestedArea: UapiMeasure;
  /**
   * legacySeasonTag is a temporary, deprecated compatibility field used by existing Web/Mobile clients.
   *   Use seasonName and seasonYear going forward.
   * @deprecated Please use seasonName and seasonYear
   */
  legacySeasonTag?: Maybe<Scalars['String']['output']>;
  /**
   * Mass of water in the harvested material.
   *   Calculated as: #$#moistureMass = wetMass * (moisturePercent / 100)#$#
   */
  moistureMass?: Maybe<UapiMeasure>;
  /** Moisture reading expressed as a percentage (0–100). */
  moisturePercent?: Maybe<UapiMeasure>;
  /**
   * The number of pounds of dry grain in a bushel.
   *   For example, the default nominal weight for corn is 56 pounds per bushel.
   *   This field is nullable since some speciality crops do not have a nominal weight value.
   */
  nominalWeight?: Maybe<UapiMeasure>;
  seasonName: UapiSeasonName;
  seasonYear: Scalars['Int']['output'];
  wetMass?: Maybe<UapiMeasure>;
};

/** Represents an evaluation result for harvesting. */
export type UapiHarvestingEvaluationResult = UapiNode & {
  __typename?: 'HarvestingEvaluationResult';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  evaluationAt?: Maybe<Scalars['DateTime']['output']>;
  evaluationBy?: Maybe<UapiParty>;
  evaluationOffer?: Maybe<UapiProgramOfferType>;
  harvestingArtifact?: Maybe<UapiEvaluationResultHarvestingArtifact>;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  roiAnalysisResults: Array<UapiPlanRoiAnalysisResult>;
  ruleResults: Array<UapiRuleEvaluation>;
  status: UapiEvaluationStatus;
  statusReasons: Array<Scalars['String']['output']>;
  /** The version of the evaluation result, set only on creation. The latest version reflects the latest agronomic data. */
  version: Scalars['Int']['output'];
};


/** Represents an evaluation result for harvesting. */
export type UapiHarvestingEvaluationResultRoiAnalysisResultsArgs = {
  filter?: InputMaybe<UapiPlanRoiResultsFilterInput>;
};

/** The connection type for HarvestingEvaluationResult. */
export type UapiHarvestingEvaluationResultConnection = {
  __typename?: 'HarvestingEvaluationResultConnection';
  edges: Array<UapiHarvestingEvaluationResultEdge>;
  pageInfo: UapiPageInfo;
};

/** An edge in a connection. */
export type UapiHarvestingEvaluationResultEdge = {
  __typename?: 'HarvestingEvaluationResultEdge';
  cursor: Scalars['String']['output'];
  node: UapiHarvestingEvaluationResult;
};

/** A crop that was planted in a prior year. */
export type UapiHistoricalCropYear = {
  __typename?: 'HistoricalCropYear';
  crop?: Maybe<UapiCrop>;
  year: Scalars['Int']['output'];
};

/** A crop that was planted in a prior year. */
export type UapiHistoricalCropYearInput = {
  /** The crop that was planted, if any. */
  cropId?: InputMaybe<Scalars['ID']['input']>;
  /** The year the crop was planted. */
  year: Scalars['Int']['input'];
};

/** Challenger product and recommendation details */
export type UapiHybridPairingChallengerDetail = {
  __typename?: 'HybridPairingChallengerDetail';
  /** Yield delta between challenger product and champion product */
  avgYieldDelta?: Maybe<UapiMeasure>;
  /** Bayer Recommended Product for comparison */
  challenger: UapiSeedProduct;
  /** Probability of success of challenger product over champion product */
  posScore?: Maybe<Scalars['Float']['output']>;
};

/** Details of HPR recommendation */
export type UapiHybridPairingDetails = {
  __typename?: 'HybridPairingDetails';
  /** List of challenger products and recommendation details */
  challengers: Array<UapiHybridPairingChallengerDetail>;
  /** Competitor Product */
  champion: UapiSeedProduct;
};

/** Filters used for champion and challenger products */
export type UapiHybridPairingProductFilterInput = {
  /** List of selected brands */
  brands?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of selected products */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Hybrid Pairing Recommendation */
export type UapiHybridPairingRecommendation = UapiNode & UapiProgramRecommendation & {
  __typename?: 'HybridPairingRecommendation';
  id: Scalars['ID']['output'];
  metadata: UapiRecommendationMetadata;
  pairings?: Maybe<Array<UapiHybridPairingDetails>>;
  subject: UapiField;
  subjectParty?: Maybe<UapiParty>;
};

/** Hybrid Pairing Recommendation Connection */
export type UapiHybridPairingRecommendationConnection = {
  __typename?: 'HybridPairingRecommendationConnection';
  edges: Array<UapiHybridPairingRecommendationEdge>;
  pageInfo: UapiPageInfo;
};

/** Hybrid Pairing Recommendation Edge */
export type UapiHybridPairingRecommendationEdge = {
  __typename?: 'HybridPairingRecommendationEdge';
  cursor: Scalars['String']['output'];
  node: UapiHybridPairingRecommendation;
};

/** Imagery Notification Data */
export type UapiImageryNotificationData = {
  __typename?: 'ImageryNotificationData';
  /** The date on which the image was taken. Formatted as "YYYY-MM-DD". */
  date: Scalars['Date']['output'];
  fields: Array<UapiImageryNotificationDataField>;
};

/** Imagery Data Field */
export type UapiImageryNotificationDataField = {
  __typename?: 'ImageryNotificationDataField';
  absThumbnailUrl: Scalars['URL']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  operationId?: Maybe<Scalars['ID']['output']>;
  rankThumbnailUrl: Scalars['URL']['output'];
  referenceDate: Scalars['DateTime']['output'];
  variability: Scalars['Float']['output'];
};

/** The status of a particular entity. */
export enum UapiItemStatus {
  /** The item is available for use */
  ACTIVE = 'ACTIVE',
  /** The item no longer exists */
  DELETED = 'DELETED',
  /** The item exists, but is not available for use */
  DISABLED = 'DISABLED',
  /** The item is awaiting further action before becoming active */
  PENDING = 'PENDING'
}

/** Possible values when querying for item status. */
export enum UapiItemStatusQuery {
  ACTIVE = 'ACTIVE',
  ALL = 'ALL',
  DELETED = 'DELETED',
  DISABLED = 'DISABLED',
  PENDING = 'PENDING'
}

/**
 * A local cash price available for a crop on a given date from a particular source.
 * ### Example
 * ```graphql
 * {
 * crop: {
 * id: "c7093350-c426-4c02-b1f9-316d871800ab",
 * name: "Corn",
 * itemStatus: "ACTIVE",
 * dataLegitimacy: "LEGITIMATE"
 * }
 * priceAsOf: "2025-10-22"
 * pricePerUnit: {
 * quantity: {
 * v: 60
 * u: "kg"
 * }
 * priceForQuantity: {
 * currencyCode: "BRL"
 * amount: "54.00"
 * }
 * source {
 * name: "Itapetininga"
 * }
 * }
 * }
 */
export type UapiLocalCashPrice = {
  __typename?: 'LocalCashPrice';
  crop: UapiCrop;
  price: UapiUnitPrice;
  priceAsOf: Scalars['Date']['output'];
  source: UapiLocalCashPriceSource;
};

/** The source/buyer/provider of a local cash price. */
export type UapiLocalCashPriceSource = {
  __typename?: 'LocalCashPriceSource';
  name: Scalars['String']['output'];
};

/** Represents a Logo location */
export type UapiLogo = {
  __typename?: 'Logo';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

/** Error that can occurr for a single correction. */
export type UapiMachineDataCorrectionError = {
  __typename?: 'MachineDataCorrectionError';
  code?: Maybe<UapiMachineDataCorrectionErrorCode>;
  id: Scalars['ID']['output'];
  /** Human readable explanation of the error for the individual correction. */
  reason: Scalars['String']['output'];
};

/** Types of error that can occur for an individual correction. */
export enum UapiMachineDataCorrectionErrorCode {
  CONFLICTING_CORRECTION = 'CONFLICTING_CORRECTION',
  FAILED = 'FAILED'
}

/** Possible values for a MachineDataCorrection status. */
export enum UapiMachineDataCorrectionJobStatus {
  APPLIED = 'APPLIED',
  PENDING = 'PENDING',
  SUCCEEDED = 'SUCCEEDED'
}

/** General Result or Error for a correction for a single Data Aggregation. */
export type UapiMachineDataCorrectionPayload = {
  __typename?: 'MachineDataCorrectionPayload';
  errors: Array<UapiMachineDataCorrectionError>;
  result?: Maybe<UapiMachineDataCorrectionResult>;
};

/** Success Result of a correction for a single Data Aggregation. */
export type UapiMachineDataCorrectionResult = {
  __typename?: 'MachineDataCorrectionResult';
  correctionId: Scalars['ID']['output'];
  cropId: Scalars['ID']['output'];
  fieldId: Scalars['ID']['output'];
  seasonName: UapiSeasonName;
  seasonYear: Scalars['Int']['output'];
  status: UapiMachineDataCorrectionJobStatus;
};

/**
 * A map that contains machine data that can be used to perform analysis or visualization.
 * This maps includes geospatial assets that are contain access to the map in various formats.
 */
export type UapiMachineDataMap = {
  __typename?: 'MachineDataMap';
  assets: Array<UapiGeospatialAsset>;
  name: UapiMachineDataMapName;
};

/**
 * Enumeration of possible names for machine data maps.
 * These names are used to identify the specific data or attribute being contained within the assets.
 */
export enum UapiMachineDataMapName {
  ACTUAL_POPULATION_BY_MASS = 'ACTUAL_POPULATION_BY_MASS',
  ACTUAL_POPULATION_BY_SEED_COUNT = 'ACTUAL_POPULATION_BY_SEED_COUNT',
  APPLIED_DF = 'APPLIED_DF',
  CEC = 'CEC',
  CLEAN_FURROW = 'CLEAN_FURROW',
  COMBINE_ELEVATION = 'COMBINE_ELEVATION',
  COMBINE_SPEED = 'COMBINE_SPEED',
  DOWN_FORCE = 'DOWN_FORCE',
  ELEVATION = 'ELEVATION',
  FURROW_MOISTURE = 'FURROW_MOISTURE',
  HARVEST_DATE = 'HARVEST_DATE',
  HYBRID = 'HYBRID',
  MOISTURE = 'MOISTURE',
  ORGANIC_MATTER = 'ORGANIC_MATTER',
  PLANTER_SPEED = 'PLANTER_SPEED',
  PLANTING_DATE = 'PLANTING_DATE',
  RX_PLANTING = 'RX_PLANTING',
  SEED_TREATMENT = 'SEED_TREATMENT',
  SINGULATION = 'SINGULATION',
  SOIL_TEMPERATURE = 'SOIL_TEMPERATURE',
  SPACING = 'SPACING',
  TARGET_POPULATION_BY_MASS = 'TARGET_POPULATION_BY_MASS',
  TARGET_POPULATION_BY_SEED_COUNT = 'TARGET_POPULATION_BY_SEED_COUNT',
  UNIFORM_FURROW = 'UNIFORM_FURROW',
  YIELD = 'YIELD'
}

/** A collection of machine data maps for a field, crop, season, year */
export type UapiMachineDataMaps = {
  __typename?: 'MachineDataMaps';
  cropId: Scalars['ID']['output'];
  fieldId: Scalars['ID']['output'];
  maps: Array<UapiMachineDataMap>;
  seasonName: UapiSeasonName;
  seasonYear: Scalars['Int']['output'];
};

/** Manual Rule Result. */
export type UapiManualRuleResult = {
  __typename?: 'ManualRuleResult';
  name: Scalars['String']['output'];
  result: UapiRuleResultStatus;
};

/** Manual Rule Result Input. Used when just a name and result status are required. */
export type UapiManualRuleResultInput = {
  name: Scalars['String']['input'];
  result: UapiRuleResultStatus;
};

/** Response type for mark as read mutation */
export type UapiMarkNotificationsAsReadResponse = {
  __typename?: 'MarkNotificationsAsReadResponse';
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output'];
  /** Indicates how many notifications where updated */
  updatedNotifications: Scalars['Int']['output'];
};

/** Matter state i.e liquid or solid */
export enum UapiMatterState {
  LIQUID = 'LIQUID',
  SOLID = 'SOLID'
}

/**
 * The measure of some value, where:
 *
 * * "v" contains the value.
 * * "u" describes the unit of measure.
 *
 * The “u” key must be included for any dimensional measurement,
 * but may be left out for dimensionless measurements such as pH.
 *
 * Units of measure use the SI unit or derived unit representation,
 * full word, no abbreviation, singular, all lowercase.
 *
 * ##### Example
 * ```
 * {
 * "v": "42",
 * "u": "hectare"
 * }
 * ```
 */
export type UapiMeasure = {
  __typename?: 'Measure';
  /** The unit */
  u?: Maybe<Scalars['String']['output']>;
  /** The value */
  v: Scalars['Float']['output'];
};

/**
 * Input type for a measurement.
 *
 * https://github.com/graphql/graphql-spec/issues/215
 */
export type UapiMeasureInput = {
  u?: InputMaybe<Scalars['String']['input']>;
  v: Scalars['Float']['input'];
};

/** A range range of measures for input purposes. */
export type UapiMeasureRangeInput = {
  maxValue?: InputMaybe<UapiMeasureInput>;
  maxValueInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  minValue?: InputMaybe<UapiMeasureInput>;
  minValueInclusive?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Possible values for MFA enrollment status */
export enum UapiMfaEnrollmentStatus {
  /** Indicates that the user has not elected to enable multi-factor authentication for their account sign-ins. */
  DISABLED = 'DISABLED',
  /** Indicates that the user has elected to enable multi-factor authentication for their account sign-ins. */
  ENABLED = 'ENABLED',
  /** Indicates that the user is required to use multi-factor authentication for their account sign-ins (e.g. due to their privileged role). */
  REQUIRED = 'REQUIRED'
}

/**
 * A monetary value with currency.
 *
 * ##### Example
 * ```
 * {
 * "currencyCode": "USD",
 * "amount": "100.00"
 * }
 * ```
 */
export type UapiMonetaryAmount = {
  __typename?: 'MonetaryAmount';
  /** Decimal money amount. */
  amount: Scalars['Decimal']['output'];
  /** Currency of the monetary amount. */
  currencyCode: Scalars['Currency']['output'];
};

/** Input type for a Monetary Amount. */
export type UapiMonetaryAmountInput = {
  amount: Scalars['Decimal']['input'];
  currencyCode: Scalars['Currency']['input'];
};

/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutation = {
  __typename?: 'Mutation';
  /** Mark crop plan as ACCEPTED status */
  acceptCropPlan?: Maybe<UapiCropPlan>;
  /** Activate the prescription by updating the prescription's status from PENDING to ACTIVE (enables visibility to grower) */
  activatePrescription: UapiPrescription;
  /** Bulk adding a tag to FieldPlan(s). If its tagged already with the given tag do nothing, else append to tags list. Limit 100 inputs. */
  addTagsOnFieldPlans?: Maybe<Array<Maybe<UapiFieldPlan>>>;
  /** Calculate Return On Investment for the seed density trial. */
  calculateSeedDensityTrialRoiResult: UapiSeedDensityTrialRoiResult;
  /** Clone a Crop Plan. This will duplicate the whole CropPlan including descendent types. */
  cloneCropPlan: UapiCropPlan;
  /** Clone a Trial. Fresh agronomic artifact data will be used instead of cloned. */
  cloneTrial?: Maybe<UapiTrial>;
  /**
   * Apply corrections to machine data records for a specific field id, crop id, season name, and year.
   *   The correction are applied asynchonously and the backend can only process 10 corrections at a time.
   */
  correctSeasonForPlantingEvent: UapiMachineDataCorrectionPayload;
  correctSeedProductForPlantingEvent: UapiMachineDataCorrectionPayload;
  /**
   * Create a Clickwrap Agreement.
   *
   *   DocuSign Clickwrap returns an agreement URL to show in the modal for signing.
   */
  createClickwrapAgreement: UapiClipwrapAgreement;
  /** Create a new Crop Plan. */
  createCropPlan: UapiCropPlan;
  /** Bulk create new Crop Plan Crop Favorites. Limit 100 inputs. If a crop plan crop favorite already exists, nothing will change. */
  createCropPlanCropFavorites: Array<UapiCropPlanCropFavorite>;
  /**
   * Bulk create Discount Favorite(s) for a single user. Limit 100 inputs.
   *   New discount priorities are automatically set to the end of the existing list of discounts.
   */
  createDiscountFavorites: Array<UapiDiscountFavorite>;
  /** Create a new harvesting field task. */
  createFieldHarvestingTask: UapiFieldHarvestingTask;
  /** Create a new Field Plan. */
  createFieldPlan: UapiFieldPlan;
  /** Create a new field planting task. */
  createFieldPlantingTask: UapiFieldPlantingTask;
  createGrowthStageObservations?: Maybe<UapiCreateGrowthStageObservationResponse>;
  /** Create a harvesting evaluation result for a task. */
  createHarvestingEvaluationResult: UapiHarvestingEvaluationResult;
  /**
   * Bulk create new Notes. Limit 100 inputs.
   *   The mutation is all-or-nothing: if it succeeds, it returns an array of Notes in the same order as the input;
   *   otherwise, it returns an empty (data) array along with an error description.
   */
  createNotes: Array<UapiNote>;
  /** Create Paid Product Price the input. */
  createPaidSeedProductPrice: UapiPaidSeedProductPrice;
  /** Create a PDF. */
  createPdf: UapiPdfOutput;
  /** Bulk create product group additional product summaries. Limit 100 inputs. */
  createPlanAdditionalProductSummaries: Array<UapiPlanAdditionalProductSummary>;
  /** Create a product group additional product summary. */
  createPlanAdditionalProductSummary: UapiPlanAdditionalProductSummary;
  /** Bulk create product group discounts. Limit 100 inputs. */
  createPlanDiscounts: Array<UapiPlanDiscount>;
  /** Create a product group. */
  createPlanProductGroup: UapiPlanProductGroup;
  /** Bulk create product group seed product summaries. Limit 100 inputs. */
  createPlanSeedProductSummaries: Array<UapiPlanSeedProductSummary>;
  /** Create a planting evaluation result for a task. */
  createPlantingEvaluationResult: UapiPlantingEvaluationResult;
  /**
   * Create a new Program.
   *
   *   For programs that repeat every year such as Delaro Fungicide Protection program,
   *   a program is created once and program instances are created for every year.
   */
  createProgram: UapiProgram;
  /** Create a new instance of a Program. */
  createProgramInstance: UapiProgramInstance;
  /** Specify a stage of program instance. */
  createProgramInstanceStage: UapiProgramInstanceStage;
  /** Create a program payment for a grower enrollment. */
  createProgramPayment: UapiProgramPayment;
  /** Create a protocol associated with a program instance. */
  createProtocol: UapiProtocol;
  /** Create a new ProtocolRuleset for a Protocol. */
  createProtocolRuleset: UapiProtocolRuleset;
  /** Bulk create new Seed Product Favorites. Limit 100 inputs. */
  createSeedProductFavorites: Array<UapiSeedProductFavorite>;
  /** Create a new seed product recommendation preference. */
  createSeedProductRecommendationsPreference: UapiSeedProductRecommendationsPreference;
  /** Create a temporary url to access a signed recorded agreement document. */
  createSignedAgreementTransientURL: Scalars['URL']['output'];
  /** Create a new trial. */
  createTrial: UapiTrial;
  /** Bulk create trial blocks. Limit 5 inputs. */
  createTrialBlocks: Array<UapiTrialBlock>;
  /** Delete a Crop Plan. */
  deleteCropPlan?: Maybe<UapiCropPlan>;
  /** Delete Crop Plan Crop Favorite. Returns null on failure. */
  deleteCropPlanCropFavorite?: Maybe<UapiCropPlanCropFavorite>;
  /** Delete Discount Favorite. */
  deleteDiscountFavorite?: Maybe<UapiDiscountFavorite>;
  /** Delete a Note. */
  deleteNote?: Maybe<UapiNote>;
  /** Delete a product group additional product summary. */
  deletePlanAdditionalProductSummary?: Maybe<UapiPlanAdditionalProductSummary>;
  /** Delete a product group discount. */
  deletePlanDiscount?: Maybe<UapiPlanDiscount>;
  /** Delete a product group. */
  deletePlanProductGroup?: Maybe<UapiPlanProductGroup>;
  /** Delete a product group seed product summary. */
  deletePlanSeedProductSummary?: Maybe<UapiPlanSeedProductSummary>;
  /** Delete a prescription */
  deletePrescription?: Maybe<UapiPrescription>;
  /** Delete Seed Product Favorite. Returns the deleted Seed Product Favorite or null on failure. */
  deleteSeedProductFavorite?: Maybe<UapiSeedProductFavorite>;
  /** Bulk dismiss alerts on field plans. Limit 100 inputs. Results may be null if the operation fails for that input. */
  dismissFieldPlanAlerts: Array<Maybe<UapiFieldPlan>>;
  /** Bulk download prescriptions in a single compressed zip file with a specified monitor format. Limit 50 prescriptions. */
  downloadPrescriptions: UapiPrescriptionsDownloadJob;
  /** Duplicate the prescription */
  duplicatePrescription: UapiPrescription;
  /**
   * Create a new Recorded Agreement for email to a user for signing or
   *   Resend by email an already existent Recorded Agreement.
   *
   *   Use cases:
   *   - After opening the clickwrap modal the user selects a legal representative
   *   to sign the template agreement.
   *
   *   - CSR, BSR, or ESR creates a recorded agreement for sending it by email for the user
   *   to sign it.
   *
   *   - Resend an existing Recorded Agreement for email to a user for signing.
   */
  emailRecordedAgreement: UapiRecordedAgreement;
  /** Enroll one or more fields into a program instance. */
  enrollFields: Array<UapiFieldProgramEnrollment>;
  /** Enroll a grower in a program instance. */
  enrollGrower: UapiGrowerProgramEnrollment;
  /** Exporting prescriptions as JDOC Work Plans */
  exportPrescriptionAsAJDOCWorkPlan: UapiPrescriptionAsAjdocWorkPlanExportJob;
  /** Bulk export prescriptions to John Deere Operations Center (JDOC) Rx Files in a single compressed zip file. */
  exportPrescriptionsToJDOCFiles: UapiPrescriptionsToJdocFilesExportJob;
  generateInseasonPdf: UapiPdfExportPayload;
  generateZones: UapiZoneSet;
  /** Mark every notification sent to a user as read. */
  markAllNotificationsAsRead: UapiMarkNotificationsAsReadResponse;
  /** Mark a list of notifications sent to a user as read. */
  markNotificationsAsRead: UapiMarkNotificationsAsReadResponse;
  /** Nominate one or more growers into a program instance. */
  nominateGrower: UapiGrowerProgramEnrollment;
  processZoneGenerationAvailableData: Array<UapiZoneGenerationAvailableData>;
  /**
   * Provisions a FieldView subscription for a grower based on the provided request.
   *   This mutation accepts a provisioning request and returns the resulting
   *   provisioning record with its current status.
   */
  provisionFieldViewSubscription: UapiFieldViewSubscriptionProvisionResponse;
  /** Mark crop plan as READ status */
  readCropPlan?: Maybe<UapiCropPlan>;
  /**
   * Reconcile a grower enrollment for a program instance.
   *
   *   An enrollment should be marked as reconciled after reviewing program compliance for the
   *   participating fields and initiating pending payments to the enrolled grower.
   *
   *   Note: "Reconciling" an enrollment does not restrict additional future payments or compliance reviews.
   */
  reconcileGrowerProgramEnrollment: UapiGrowerProgramEnrollment;
  /**
   * Send Crop Plan the specified user. This will change the status to SENT, and update the value of sentWithPricing if it
   *   is included.
   */
  sendCropPlan?: Maybe<UapiCropPlan>;
  /** Sets the trial as a manual trial. Returns Null on error or if client does not have permission. */
  setTrialManual?: Maybe<UapiTrialContext>;
  /** Share the prescription context for a fieldPlantingTaskId with the grower. */
  sharePrescriptionContext?: Maybe<UapiPrescriptionContext>;
  /** Share the trial context for a fieldHarvestingTaskId with the grower. sharedBy set by JWT subject. Returns Null on error or if client does not have authorization. */
  shareTrialContext?: Maybe<UapiTrialContext>;
  /** Un-enroll one or more fields from a program instance. */
  unenrollFields: Array<UapiFieldProgramEnrollment>;
  /** Unshare the trial context for a fieldHarvestingTaskId with the grower. Returns Null on error or if client does not have permission. */
  unshareTrialContext?: Maybe<UapiTrialContext>;
  /** Update an existing Crop Plan. */
  updateCropPlan: UapiCropPlan;
  /** Bulk (sparse) update existing discount favorite(s) for a single user. Limit 100 inputs. Will not change priority: use updateDiscountFavoritesPriorities to change priorities. */
  updateDiscountFavorites: Array<UapiDiscountFavorite>;
  /**
   * Update the priorities of discount favorites for a single user based on the order of the provided IDs. Limit 100
   *   inputs. Must pass in all active (and no other) favorites or exception will be raised.
   */
  updateDiscountFavoritesPriorities: Array<UapiDiscountFavorite>;
  /** Update an existing harvesting field task. */
  updateFieldHarvestingTask: UapiFieldHarvestingTask;
  /**
   * Bulk (sparse) update existing Field Plan(s).
   *   If an attribute is not supplied, it will not update the value.
   *   If an attribute is null, the value will be updated to null if possible.
   *   Limit 100 elements in update list.
   */
  updateFieldPlans?: Maybe<Array<Maybe<UapiFieldPlan>>>;
  /** Bulk update historical averages for FieldPlan(s). Limit 100 inputs. Results may be null if the operation fails for that input. */
  updateFieldPlansHistoricalAverages: Array<Maybe<UapiFieldPlan>>;
  /**
   * Bulk (sparse) update existing Field Planting Task(s).
   *   If an attribute is not supplied, it will not update the value.
   *   If an attribute is null, the value will be updated to null if possible.
   *   Limit 100 elements in update list.
   */
  updateFieldPlantingTasks?: Maybe<Array<Maybe<UapiFieldPlantingTask>>>;
  /**
   * (Sparse) update existing Grower Enrollment.
   *   If an attribute is not supplied, it will not update the value.
   *   If an attribute is null, the value will be updated to null if possible.
   *   If an attribute provided is null and the field is non-nullable, a bad request exception will be raised.
   */
  updateGrowerProgramEnrollment: UapiGrowerProgramEnrollment;
  updateGrowthStageObservations?: Maybe<UapiUpdateGrowthStageObservationResponse>;
  /**
   * Update a harvesting evaluation result for a task.
   *   Note, the version will not be updated by this mutation.
   */
  updateHarvestingEvaluationResult: UapiHarvestingEvaluationResult;
  /** Update an existing Note. */
  updateNote: UapiNote;
  updatePartyRelationships: Array<UapiPartyRelationship>;
  /** Update an existing product group additional product summary. */
  updatePlanAdditionalProductSummary: UapiPlanAdditionalProductSummary;
  /** Update an existing product group discount. */
  updatePlanDiscount: UapiPlanDiscount;
  /**
   * Bulk update product group seed product summaries. Limit 100 inputs.
   *   The mutation allows partial success: it returns an array of PlanSeedProductSummary in the same order as the input,
   *   with null entries where some items failed to persist. For each null value, the response also includes an array
   *   of error descriptions.
   */
  updatePlanSeedProductSummaries?: Maybe<Array<Maybe<UapiPlanSeedProductSummary>>>;
  /**
   * Update a planting evaluation result for a task.
   *   Note, the version will not be updated by this mutation.
   */
  updatePlantingEvaluationResult: UapiPlantingEvaluationResult;
  /** Update the prescription as primary */
  updatePrescriptionAsPrimary: UapiPrescription;
  /** Update the PrescriptionContext's approval related fields on a FieldPlantingTask. */
  updatePrescriptionContextApproval?: Maybe<UapiPrescriptionContext>;
  /** Update the PrescriptionContext's prescription generation related fields on a FieldPlantingTask */
  updatePrescriptionContextGeneration?: Maybe<UapiPrescriptionContext>;
  /** Update the prescription's update a prescription's program instance. */
  updatePrescriptionProgramInstance: UapiPrescription;
  /**
   * Update the prescription's program status to ACTIVE (enables visibility to grower)
   * @deprecated Use updatePrescriptionProgramInstance instead.
   */
  updatePrescriptionProgramStatus: UapiPrescription;
  /** Update an existing Program. */
  updateProgram: UapiProgram;
  /** Update the instance of a program for the program instance id. */
  updateProgramInstance: UapiProgramInstance;
  /** Update a stage of a program instance. */
  updateProgramInstanceStage: UapiProgramInstanceStage;
  /** Update protocol associated with a program instance. */
  updateProtocol: UapiProtocol;
  /** Update an existing ProtocolRuleset. */
  updateProtocolRuleset: UapiProtocolRuleset;
  updateSeedBrandAffiliations: Array<UapiSeedBrand>;
  /** Update Seed Product Favorite. */
  updateSeedProductFavorite: UapiSeedProductFavorite;
  /**
   * Bulk (sparse) update existing Seed Product Recommendation Preference(s). Limit 100 inputs. Returns the updated Seed
   *   Product Recommendation Preference(s) or null on failure.
   */
  updateSeedProductRecommendationsPreferences?: Maybe<Array<UapiSeedProductRecommendationsPreference>>;
  /** Update (sparse) an existing trial. */
  updateTrial?: Maybe<UapiTrial>;
  /** Bulk (sparse) update existing trial block(s). Limit 100 inputs. */
  updateTrialBlocks: Array<UapiTrialBlock>;
  updateUserGroupAssignment: UapiUpdateUserGroupAssignmentResponse;
  updateUserMfaEnrollmentStatus: UapiUser;
  /**
   * Bulk upsert product group discounts. Limit 100 inputs.
   *   The mutation follows this behavior:
   *   - Create a discount if an id is not provided as input
   *   - (Sparse) Update existing discounts
   *   - Remove existing discounts not present in the input array
   *
   *   Note: Updates also the priorities of existing (and new) discounts for a single user based on the order of
   *   the provided input.
   */
  upsertPlanDiscounts?: Maybe<Array<Maybe<UapiPlanDiscount>>>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationAcceptCropPlanArgs = {
  id: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationActivatePrescriptionArgs = {
  id: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationAddTagsOnFieldPlansArgs = {
  input: Array<UapiAddTagOnFieldPlanInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCalculateSeedDensityTrialRoiResultArgs = {
  input: UapiCalculateSeedDensityTrialRoiInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCloneCropPlanArgs = {
  input: UapiCloneCropPlanInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCloneTrialArgs = {
  input: UapiCloneTrialInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCorrectSeasonForPlantingEventArgs = {
  correction: UapiSeasonEventCorrectionInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCorrectSeedProductForPlantingEventArgs = {
  correction: UapiSeedProductEventCorrectionInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateClickwrapAgreementArgs = {
  input: UapiClickwrapAgreementInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateCropPlanArgs = {
  input: UapiCreateCropPlanInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateCropPlanCropFavoritesArgs = {
  input: Array<UapiCreateCropPlanCropFavoriteInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateDiscountFavoritesArgs = {
  input: Array<UapiCreateDiscountFavoriteInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateFieldHarvestingTaskArgs = {
  input: UapiCreateFieldHarvestingTaskInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateFieldPlanArgs = {
  input: UapiCreateFieldPlanInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateFieldPlantingTaskArgs = {
  input: UapiCreateFieldPlantingTaskInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateGrowthStageObservationsArgs = {
  observations: Array<UapiCreateGrowthStageObservationInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateHarvestingEvaluationResultArgs = {
  input: UapiCreateHarvestingEvaluationResultInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateNotesArgs = {
  input: Array<UapiCreateNoteInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreatePaidSeedProductPriceArgs = {
  input: UapiCreatePaidSeedProductPriceInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreatePdfArgs = {
  input: UapiCreatePdfInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreatePlanAdditionalProductSummariesArgs = {
  input: Array<UapiCreatePlanAdditionalProductSummaryInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreatePlanAdditionalProductSummaryArgs = {
  input: UapiCreatePlanAdditionalProductSummaryInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreatePlanDiscountsArgs = {
  input: Array<UapiCreatePlanDiscountInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreatePlanProductGroupArgs = {
  input: UapiCreatePlanProductGroupInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreatePlanSeedProductSummariesArgs = {
  input: Array<UapiCreatePlanSeedProductSummaryInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreatePlantingEvaluationResultArgs = {
  input: UapiCreatePlantingEvaluationResultInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateProgramArgs = {
  input: UapiCreateProgramInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateProgramInstanceArgs = {
  input: UapiCreateProgramInstanceInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateProgramInstanceStageArgs = {
  input: UapiCreateProgramInstanceStageInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateProgramPaymentArgs = {
  input: UapiCreateProgramPaymentInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateProtocolArgs = {
  input: UapiCreateProtocolInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateProtocolRulesetArgs = {
  input: UapiCreateProtocolRulesetInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateSeedProductFavoritesArgs = {
  input: Array<UapiCreateSeedProductFavoriteInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateSeedProductRecommendationsPreferenceArgs = {
  input: UapiCreateSeedProductRecommendationsPreferenceInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateSignedAgreementTransientUrlArgs = {
  recordedAgreementId: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateTrialArgs = {
  input: UapiCreateTrialInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationCreateTrialBlocksArgs = {
  input: Array<UapiCreateTrialBlockInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationDeleteCropPlanArgs = {
  id: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationDeleteCropPlanCropFavoriteArgs = {
  id: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationDeleteDiscountFavoriteArgs = {
  id: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationDeleteNoteArgs = {
  id: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationDeletePlanAdditionalProductSummaryArgs = {
  id: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationDeletePlanDiscountArgs = {
  id: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationDeletePlanProductGroupArgs = {
  id: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationDeletePlanSeedProductSummaryArgs = {
  id: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationDeletePrescriptionArgs = {
  id: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationDeleteSeedProductFavoriteArgs = {
  id: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationDismissFieldPlanAlertsArgs = {
  input: Array<UapiDismissFieldPlanAlertInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationDownloadPrescriptionsArgs = {
  input: UapiDownloadPrescriptionsInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationDuplicatePrescriptionArgs = {
  input: UapiDuplicatePrescriptionInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationEmailRecordedAgreementArgs = {
  input: UapiEmailRecordedAgreementInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationEnrollFieldsArgs = {
  enrollments: Array<UapiEnrollFieldInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationEnrollGrowerArgs = {
  enrollInput: UapiEnrollGrowerInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationExportPrescriptionAsAjdocWorkPlanArgs = {
  input: UapiExportPrescriptionAsAjdocWorkPlanInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationExportPrescriptionsToJdocFilesArgs = {
  input: UapiExportPrescriptionsToJdocFilesInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationGenerateInseasonPdfArgs = {
  input: UapiPdfExportInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationGenerateZonesArgs = {
  forceReprocess?: InputMaybe<Scalars['Boolean']['input']>;
  input: UapiGenerateZonesInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationMarkAllNotificationsAsReadArgs = {
  userLegacyId: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationMarkNotificationsAsReadArgs = {
  notificationIds: Array<Scalars['ID']['input']>;
  userLegacyId: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationNominateGrowerArgs = {
  nomination: UapiNominateGrowerInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationProcessZoneGenerationAvailableDataArgs = {
  forceReprocess?: InputMaybe<Scalars['Boolean']['input']>;
  targets: Array<UapiZoneGenerationTarget>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationProvisionFieldViewSubscriptionArgs = {
  input: UapiFieldViewSubscriptionProvisionInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationReadCropPlanArgs = {
  id: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationReconcileGrowerProgramEnrollmentArgs = {
  input: UapiReconcileGrowerProgramEnrollmentInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationSendCropPlanArgs = {
  id: Scalars['ID']['input'];
  targetUserId: Scalars['ID']['input'];
  withPricing?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationSetTrialManualArgs = {
  fieldHarvestingTaskId: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationSharePrescriptionContextArgs = {
  fieldPlantingTaskId: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationShareTrialContextArgs = {
  fieldHarvestingTaskId: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUnenrollFieldsArgs = {
  enrollmentIds: Array<Scalars['ID']['input']>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUnshareTrialContextArgs = {
  fieldHarvestingTaskId: Scalars['ID']['input'];
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateCropPlanArgs = {
  input: UapiUpdateCropPlanInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateDiscountFavoritesArgs = {
  input: Array<UapiUpdateDiscountFavoriteInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateDiscountFavoritesPrioritiesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateFieldHarvestingTaskArgs = {
  input: UapiUpdateFieldHarvestingTaskInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateFieldPlansArgs = {
  input: Array<UapiUpdateFieldPlanInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateFieldPlansHistoricalAveragesArgs = {
  fieldPlanIds: Array<Scalars['ID']['input']>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateFieldPlantingTasksArgs = {
  input: Array<UapiUpdateFieldPlantingTaskInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateGrowerProgramEnrollmentArgs = {
  input: UapiUpdateGrowerProgramEnrollmentInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateGrowthStageObservationsArgs = {
  observations: Array<UapiUpdateGrowthStageObservationInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateHarvestingEvaluationResultArgs = {
  input: UapiUpdateHarvestingEvaluationResultInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateNoteArgs = {
  input: UapiUpdateNoteInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdatePartyRelationshipsArgs = {
  input: Array<UapiUpdatePartyRelationshipInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdatePlanAdditionalProductSummaryArgs = {
  input: UapiUpdatePlanAdditionalProductSummaryInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdatePlanDiscountArgs = {
  input: UapiUpdatePlanDiscountInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdatePlanSeedProductSummariesArgs = {
  input: Array<UapiUpdatePlanSeedProductSummaryInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdatePlantingEvaluationResultArgs = {
  input: UapiUpdatePlantingEvaluationResultInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdatePrescriptionAsPrimaryArgs = {
  input: UapiUpdatePrescriptionAsPrimaryInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdatePrescriptionContextApprovalArgs = {
  input: UapiUpdatePrescriptionContextApprovalInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdatePrescriptionContextGenerationArgs = {
  input: UapiUpdatePrescriptionContextGenerationInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdatePrescriptionProgramInstanceArgs = {
  input: UapiUpdatePrescriptionProgramInstanceInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdatePrescriptionProgramStatusArgs = {
  input: UapiUpdatePrescriptionProgramStatusInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateProgramArgs = {
  input: UapiUpdateProgramInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateProgramInstanceArgs = {
  input: UapiUpdateProgramInstanceInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateProgramInstanceStageArgs = {
  input: UapiUpdateProgramInstanceStageInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateProtocolArgs = {
  input: UapiUpdateProtocolInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateProtocolRulesetArgs = {
  input: UapiUpdateProtocolRulesetInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateSeedBrandAffiliationsArgs = {
  input: UapiUpdateSeedBrandAffiliationsInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateSeedProductFavoriteArgs = {
  input: UapiUpdateSeedProductFavoriteInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateSeedProductRecommendationsPreferencesArgs = {
  input: Array<UapiUpdateSeedProductRecommendationsPreferenceInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateTrialArgs = {
  input: UapiUpdateTrialInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateTrialBlocksArgs = {
  input: Array<UapiUpdateTrialBlockInput>;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateUserGroupAssignmentArgs = {
  input: UapiUpdateUserGroupAssignmentInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpdateUserMfaEnrollmentStatusArgs = {
  input: UapiUpdateUserMfaEnrollmentStatusInput;
};


/** Mutations related to FieldView subscription and product asset provisioning workflows. */
export type UapiMutationUpsertPlanDiscountsArgs = {
  input: Array<UapiUpsertPlanDiscountInput>;
};

/** Interface that represents a node in a graph. */
export type UapiNode = {
  id: Scalars['ID']['output'];
};

/** Input parameters for nominating a grower to a program instance. */
export type UapiNominateGrowerInput = {
  /** The grower being enrolled. */
  growerId: Scalars['ID']['input'];
  /** The program instance to which the grower should be enrolled. */
  programInstanceId: Scalars['ID']['input'];
  /** The recorded agreement id for grower T&C. */
  recordedAgreementId?: InputMaybe<Scalars['ID']['input']>;
};

/** Non-Satellite Imagery Field */
export type UapiNonSatImageryField = {
  __typename?: 'NonSatImageryField';
  /** Date and time when the image was acquired */
  acquisitionDate: Scalars['DateTime']['output'];
  /** Field */
  field: UapiField;
  /** Partner name */
  partnerName: Scalars['String']['output'];
};

/** Notification from Non-Satellite imagery data */
export type UapiNonSatImageryNotificationData = {
  __typename?: 'NonSatImageryNotificationData';
  /** List of fields with non-satellite imagery */
  fields: Array<UapiNonSatImageryField>;
};

/** Notification requiring attention from Non-Satellite imagery data */
export type UapiNonSatImageryRequiresAttentionNotificationData = {
  __typename?: 'NonSatImageryRequiresAttentionNotificationData';
  /** Date and time when the image was acquired */
  acquisitionDate: Scalars['DateTime']['output'];
  /** Field name */
  fieldName: Scalars['String']['output'];
  /** Partner name */
  partnerName: Scalars['String']['output'];
};

/** Represents a Note made by a user on some other graphql type object. */
export type UapiNote = UapiNode & {
  __typename?: 'Note';
  auditMetadata: UapiAuditMetadata;
  content: Scalars['String']['output'];
  dataLegitimacy: UapiDataLegitimacy;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  /** The ID of the object (graphql type) that the Note is a reference to. */
  subjectId: Scalars['ID']['output'];
  /** The graphql type name of the subject, used when non-federated querying from Note. */
  subjectType: Scalars['String']['output'];
  /** Who owns the Note. */
  user?: Maybe<UapiUser>;
};

/** Connection Type for User Notifications. */
export type UapiNotificationConnection = {
  __typename?: 'NotificationConnection';
  edges: Array<UapiNotificationEdge>;
  pageInfo: UapiPageInfo;
};

/** An edge in a connection. */
export type UapiNotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor: Scalars['String']['output'];
  node: UapiUserNotification;
};

/** This represents a grower operation. */
export type UapiOperation = UapiParty & {
  __typename?: 'Operation';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  /** Fields belonging to the Operation */
  fields: UapiFieldConnection;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  /** Operation name */
  name: Scalars['String']['output'];
  /** Owner of the operation */
  owner: UapiUser;
  /** Includes FieldView subscription context for an operation */
  subscriptions: UapiFieldViewOperationSubscriptionContext;
};


/** This represents a grower operation. */
export type UapiOperationFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UapiOperationFieldsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Connection Type for Operations. */
export type UapiOperationConnection = {
  __typename?: 'OperationConnection';
  edges: Array<UapiOperationEdge>;
  pageInfo: UapiPageInfo;
};

/** An edge in a connection. */
export type UapiOperationEdge = {
  __typename?: 'OperationEdge';
  cursor: Scalars['String']['output'];
  node: UapiOperation;
};

/** Type shared by other subgraph(s) using Aggregation Context Keyset (ACK) pattern to populate fields from multiple graphs */
export type UapiOperationFieldsAck = {
  __typename?: 'OperationFieldsACK';
  /**
   * The parameters (cropId, seasonName, and years) are filters.  If omitted, all records are returned by default.  For
   *   example, if cropId is omitted, records for all crops are returned.
   */
  applicationStats?: Maybe<UapiApplicationStatsForFieldSet>;
  /** Program enrollments for the fields in the keyset (field ids). */
  fieldProgramEnrollments: UapiFieldProgramEnrollmentConnection;
  /** returns number of harvest stats records available, given the parameters provided (i.e., crop, seasonName, years) */
  harvestStats?: Maybe<UapiHarvestStatsForFieldSet>;
  operationId: Scalars['ID']['output'];
  /** returns number of planting stats records available, given the parameters provided (i.e., crop, seasonName, years) */
  plantingStats?: Maybe<UapiPlantingStatsForFieldSet>;
  stats?: Maybe<UapiFieldsStats>;
};


/** Type shared by other subgraph(s) using Aggregation Context Keyset (ACK) pattern to populate fields from multiple graphs */
export type UapiOperationFieldsAckApplicationStatsArgs = {
  cropId?: InputMaybe<Scalars['ID']['input']>;
  seasonName?: InputMaybe<UapiSeasonName>;
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** Type shared by other subgraph(s) using Aggregation Context Keyset (ACK) pattern to populate fields from multiple graphs */
export type UapiOperationFieldsAckFieldProgramEnrollmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: UapiOperationFieldsFieldProgramEnrollmentsFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UapiFieldProgramEnrollmentOrderInput>>;
};


/** Type shared by other subgraph(s) using Aggregation Context Keyset (ACK) pattern to populate fields from multiple graphs */
export type UapiOperationFieldsAckHarvestStatsArgs = {
  cropId?: InputMaybe<Scalars['ID']['input']>;
  seasonName?: InputMaybe<UapiSeasonName>;
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** Type shared by other subgraph(s) using Aggregation Context Keyset (ACK) pattern to populate fields from multiple graphs */
export type UapiOperationFieldsAckPlantingStatsArgs = {
  cropId?: InputMaybe<Scalars['ID']['input']>;
  seasonName?: InputMaybe<UapiSeasonName>;
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Filters available for retrieving field program enrollments. */
export type UapiOperationFieldsFieldProgramEnrollmentsFilter = {
  dataLegitimacy?: UapiDataLegitimacyQuery;
  /** Filter the results by enrollment status. */
  enrollmentStatus?: UapiFieldProgramEnrollmentStatusQuery;
  itemStatus?: UapiItemStatusQuery;
  /** Filter the results by program instance. */
  programInstanceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input to filter Operation Fields */
export type UapiOperationFieldsFilter = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
};

/** Search filters for queries on shared operations. */
export type UapiOperationsSharedWithAllFilter = {
  userIds: Array<Scalars['ID']['input']>;
};

/** Possible directions in which to order a list of items when provided with an `orderBy` argument. */
export enum UapiOrderByDirection {
  /** Ascending order for a given `orderBy` argument. */
  ASC = 'ASC',
  /** Descending order for a given `orderBy` argument. */
  DESC = 'DESC'
}

/** Information about pagination in a connection. */
export type UapiPageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Actual Seed Product Price Paid. */
export type UapiPaidSeedProductPrice = UapiNode & {
  __typename?: 'PaidSeedProductPrice';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  /**
   * Field for which the Paid Seed Product Price was provided.
   *
   *   If value is null, the price is not specific to the Field.
   */
  field?: Maybe<UapiField>;
  id: Scalars['ID']['output'];
  /**
   * True if an invoice was presented for the paid product price.
   *
   *   Note that the invoice is not uploaded (yet) anywhere in the system.
   */
  invoice?: Maybe<Scalars['Boolean']['output']>;
  itemStatus: UapiItemStatus;
  /** Unit price for the seed product. */
  price: UapiUnitPrice;
  /** Season for which the Seed Product Price was provided. */
  seasonName: UapiSeasonName;
  /** Seed Product for which the price was provided. */
  seedProduct: UapiSeedProduct;
  version: Scalars['Int']['output'];
  /** Year for which the Paid Seed Product Price was provided. */
  year: Scalars['Int']['output'];
};

/** Filters available for retrieving Paid Seed Product Prices. */
export type UapiPaidSeedProductPriceFilter = {
  dataLegitimacy?: UapiDataLegitimacyQuery;
  fieldId: Scalars['ID']['input'];
  latest?: InputMaybe<Scalars['Boolean']['input']>;
  seasonName: UapiSeasonName;
  seedProductId?: InputMaybe<Scalars['ID']['input']>;
  year: Scalars['Int']['input'];
};

/** Represents a Party interface. */
export type UapiParty = {
  dataLegitimacy: UapiDataLegitimacy;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  /** Party name */
  name: Scalars['String']['output'];
};

/** This represents a relationship between two parties. */
export type UapiPartyRelationship = {
  __typename?: 'PartyRelationship';
  auditMetadata?: Maybe<UapiAuditMetadata>;
  dataLegitimacy: UapiDataLegitimacy;
  id: Scalars['ID']['output'];
  itemStatus?: Maybe<UapiItemStatus>;
  /** The passive or affected party in the relationship (e.g. the grower in "SALES_REPRESENTATIVE_OF") */
  objectParty: UapiParty;
  /**
   * A label that provides specific context or scope for the relationship
   *   The Season ID is currently being used within the Valora effort for storage / filter purposes.
   */
  qualifier?: Maybe<Scalars['String']['output']>;
  /** Type of relationship */
  relationshipType: UapiPartyRelationshipType;
  /** The active party in the relationship (e.g. the sales representative in "SALES_REPRESENTATIVE_OF") */
  subjectParty: UapiParty;
};

/** Connection Type for Party Relationships. */
export type UapiPartyRelationshipConnection = {
  __typename?: 'PartyRelationshipConnection';
  edges: Array<UapiPartyRelationshipEdge>;
  pageInfo: UapiPageInfo;
};

/** An edge in a connection. */
export type UapiPartyRelationshipEdge = {
  __typename?: 'PartyRelationshipEdge';
  cursor: Scalars['String']['output'];
  node: UapiPartyRelationship;
};

/** Search filters for queries on party relationships. */
export type UapiPartyRelationshipFilter = {
  dataLegitimacy?: InputMaybe<UapiDataLegitimacyQuery>;
  itemStatus?: InputMaybe<UapiItemStatusQuery>;
  objectPartyId?: InputMaybe<Scalars['ID']['input']>;
  objectPartyNameSubstring?: InputMaybe<Scalars['String']['input']>;
  qualifier?: InputMaybe<Scalars['String']['input']>;
  relationshipTypeId: Scalars['ID']['input'];
  subjectPartyId?: InputMaybe<Scalars['ID']['input']>;
  updatedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  updatedSince?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Sort columns for queries on party relationships. */
export enum UapiPartyRelationshipOrderBy {
  OBJECT_PARTY_NAME = 'OBJECT_PARTY_NAME',
  UPDATED_AT = 'UPDATED_AT'
}

/** Input specification for ordering party relationship query results. */
export type UapiPartyRelationshipOrdering = {
  by: UapiPartyRelationshipOrderBy;
  direction?: InputMaybe<UapiOrderByDirection>;
};

/** This represents a type of party relationship. */
export type UapiPartyRelationshipType = {
  __typename?: 'PartyRelationshipType';
  id: Scalars['ID']['output'];
  /** Relationship type name */
  name: Scalars['String']['output'];
};

/** Possible values for querying for a Party Relationship Type. */
export enum UapiPartyRelationshipTypeQuery {
  CUSTOMER_SUCCESS_REPRESENTATIVE_OF = 'CUSTOMER_SUCCESS_REPRESENTATIVE_OF',
  OWNER = 'OWNER',
  SALES_REPRESENTATIVE_OF = 'SALES_REPRESENTATIVE_OF'
}

/** Optional criteria to refine party relationship results. */
export type UapiPartyRelationshipsFilter = {
  /**
   * An identifier used to scope the relationship.
   *   For details on supported values and usage, refer to `PartyRelationship.qualifier`.
   */
  qualifier?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for the generateInseasonPdf mutation. Describes the page to be rendered as a PDF
 * and provides controls for file naming, render timing, and timeout behavior.
 *
 * Used exclusively with the InSeason service. For PDF generation in other services, a more
 * general solution is under development.
 */
export type UapiPdfExportInput = {
  /** Optional filename for the downloaded PDF file. */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Maximum time in milliseconds to wait for PDF generation. Defaults to 30000ms (30 seconds). */
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The URL of a page designed specifically for PDF export, typically a view that omits
   *   application chrome (headers, navigation bars, etc.) so that the output is
   *   device-independent and report-ready.
   *
   *   Ex: https://climate.com/static/field-view/#/in-season/pdf
   */
  url: Scalars['String']['input'];
  /** Optional CSS selector to wait for before rendering the PDF. Useful for waiting on dynamic content to load. */
  waitForSelector?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The result of the generateInseasonPdf mutation. Contains the generated PDF as
 * base64-encoded content, which can be decoded and offered to the user as a file download.
 */
export type UapiPdfExportPayload = {
  __typename?: 'PdfExportPayload';
  /** The base64-encoded PDF content. Present if generation was successful. */
  content: Scalars['String']['output'];
};

/** The presigned URL for the PDF. */
export type UapiPdfOutput = {
  __typename?: 'PdfOutput';
  url: Scalars['String']['output'];
};

/** Group entry that represents a free form product. */
export type UapiPlanAdditionalProductSummary = UapiNode & {
  __typename?: 'PlanAdditionalProductSummary';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  name: Scalars['String']['output'];
  unitPrice?: Maybe<UapiPrice>;
  units?: Maybe<UapiMeasure>;
};

/** The designer of the field plan. */
export type UapiPlanDesigner = UapiProgramInstance | UapiUser;

/** Input type for the designer. */
export type UapiPlanDesignerInput = {
  designerId: Scalars['ID']['input'];
  designerType: UapiPlanDesignerType;
};

/** Possible types of designers. */
export enum UapiPlanDesignerType {
  PROGRAM_INSTANCE = 'PROGRAM_INSTANCE',
  USER = 'USER'
}

/** Discount for a product group. */
export type UapiPlanDiscount = UapiNode & {
  __typename?: 'PlanDiscount';
  amount?: Maybe<UapiPlanDiscountAmount>;
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  name: Scalars['String']['output'];
  /**
   * Discounts are applied in order of priority.
   *   Values go from 0 to 2147483647 being zero (0) the highest priority.
   */
  priority: Scalars['Int']['output'];
};

/** Union type for a discount amount. */
export type UapiPlanDiscountAmount = UapiMeasure | UapiPrice | UapiPricePerUnit;

/** A named group of products and discounts. */
export type UapiPlanProductGroup = UapiNode & {
  __typename?: 'PlanProductGroup';
  /** Implicitly ordered by createdAt ascending to maintain user-created ordering for plan */
  additionalProducts: Array<UapiPlanAdditionalProductSummary>;
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  /** Implicitly ordered by createdAt ascending to maintain user-created ordering for plan */
  discounts: Array<UapiPlanDiscount>;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  name: Scalars['String']['output'];
  /** Implicitly ordered by createdAt ascending to maintain user-created ordering for plan */
  products: Array<UapiPlanSeedProductSummary>;
};

/** Union type for a Field Plan Return On Investment (ROI) Analysis. */
export type UapiPlanRoiAnalysisResult = UapiSeedDensityTrialRoiResult;

/** Available filters for retrieving Return On Investment results for a Field Plan. */
export type UapiPlanRoiResultsFilterInput = {
  latest?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Group entry that represents a seed product. */
export type UapiPlanSeedProductSummary = UapiNode & {
  __typename?: 'PlanSeedProductSummary';
  area?: Maybe<UapiMeasure>;
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  notes: Array<UapiNote>;
  seedProduct?: Maybe<UapiSeedProduct>;
  seedingRate?: Maybe<UapiMeasure>;
  unitPrice?: Maybe<UapiPrice>;
  /** Number of product units (Bags, boxes, etc.). */
  units?: Maybe<UapiMeasure>;
};

/** Represents an evaluation result for planting. */
export type UapiPlantingEvaluationResult = UapiNode & {
  __typename?: 'PlantingEvaluationResult';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  evaluationAt?: Maybe<Scalars['DateTime']['output']>;
  evaluationBy?: Maybe<UapiParty>;
  evaluationOffer?: Maybe<UapiProgramOfferType>;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  plantingArtifact?: Maybe<UapiEvaluationResultPlantingArtifact>;
  ruleResults: Array<UapiRuleEvaluation>;
  status: UapiEvaluationStatus;
  statusReasons: Array<Scalars['String']['output']>;
  /** The version of the evaluation result, set only on creation. The latest version reflects the latest agronomic data. */
  version: Scalars['Int']['output'];
};

/** The connection type for PlantingEvaluationResult. */
export type UapiPlantingEvaluationResultConnection = {
  __typename?: 'PlantingEvaluationResultConnection';
  edges: Array<UapiPlantingEvaluationResultEdge>;
  pageInfo: UapiPageInfo;
};

/** An edge in a connection. */
export type UapiPlantingEvaluationResultEdge = {
  __typename?: 'PlantingEvaluationResultEdge';
  cursor: Scalars['String']['output'];
  node: UapiPlantingEvaluationResult;
};

/**
 * Aggregated data related to a single planting event that occurred for a specific season and year involving a particular
 * crop and seed product.  For example, the average seeding rate might represent the average seeds per hectare for corn
 * planted in SPRING of 2023 using seed product DEKALB DKC081-18RIB.  If there were multiple seed products used, there will
 * be multiple PlantingEvents for the same season and year.  Note that the seed product may be null if we don't have a
 * record for it.
 */
export type UapiPlantingEvent = {
  __typename?: 'PlantingEvent';
  averageSeedingRate: UapiMeasure;
  crop: UapiCrop;
  plantedArea: UapiMeasure;
  seasonName: UapiSeasonName;
  seasonYear: Scalars['Int']['output'];
  seedProduct?: Maybe<UapiSeedProduct>;
};

/**
 * Planting data aggregated over multiple years for a specific season and crop.
 * Note that seed products are not provided at this level of aggregation because multiple seed products could
 * be planted over a series of years.  However, this aggregate includes a list of the PlantingEvent entities
 * used to generate the aggregation, so the caller can re-aggregate the data as required.
 *
 * Note that the averageSeedingRate is null if different units were used in the PlantingEventsByCropSeason.
 *
 * events: will group by crop, seasonName, seasonYear, seedProduct
 *
 * eventsByCropSeason: will group by crop, seasonName, seasonYear.  This allows for aggregation of attributes.
 */
export type UapiPlantingEventAggregates = {
  __typename?: 'PlantingEventAggregates';
  averageSeedingRate?: Maybe<UapiMeasure>;
  events?: Maybe<Array<UapiPlantingEvent>>;
  eventsByCropSeason?: Maybe<Array<UapiPlantingEventByCropSeason>>;
  numYears: Scalars['Int']['output'];
};


/**
 * Planting data aggregated over multiple years for a specific season and crop.
 * Note that seed products are not provided at this level of aggregation because multiple seed products could
 * be planted over a series of years.  However, this aggregate includes a list of the PlantingEvent entities
 * used to generate the aggregation, so the caller can re-aggregate the data as required.
 *
 * Note that the averageSeedingRate is null if different units were used in the PlantingEventsByCropSeason.
 *
 * events: will group by crop, seasonName, seasonYear, seedProduct
 *
 * eventsByCropSeason: will group by crop, seasonName, seasonYear.  This allows for aggregation of attributes.
 */
export type UapiPlantingEventAggregatesEventsByCropSeasonArgs = {
  backendMachineDataSource?: InputMaybe<UapiBackendMachineDataSource>;
};

/**
 * Aggregated planting data for a single crop, season, and year.
 *
 * Units and aggregation
 * - `averageSeedingRate` is expressed in ISO-standard units (seeds/hectare or kg/hectare).
 * - If the aggregated `seedProductEvents` use different units, `averageSeedingRate` will be null because values with
 * different units cannot be combined.
 *
 * Dates and times
 * - `firstPlantingLocalDate` and `lastPlantingLocalDate` are the local calendar dates (in the field's timezone) for the
 * earliest and latest planting activities.  The time component is always set to local midnight (00:00:00), so these
 * fields represent dates only.
 * - `firstPlantedDateTime` and `lastPlantedDateTime` are the earliest and latest planting timestamps in UTC (ISO 8601).
 *
 * Season fields
 * - Use `seasonName` and `seasonYear` to identify the season and year for the planting event.
 * - `legacySeasonTag` is provided for backward compatibility and is deprecated; avoid using it in new development.
 *
 * Seed product details
 * - `seedProductEvents` lists the individual SeedProductEvent records that were aggregated to produce this summary.
 * Each entry includes the seed product, area planted, seeding rate, and planting timestamps.
 */
export type UapiPlantingEventByCropSeason = {
  __typename?: 'PlantingEventByCropSeason';
  averageSeedingRate?: Maybe<UapiMeasure>;
  correctionStatus: UapiAggregatedEventCorrectionStatus;
  crop: UapiCrop;
  firstPlantedDateTime: Scalars['DateTime']['output'];
  firstPlantingLocalDate: Scalars['DateTime']['output'];
  lastPlantedDateTime: Scalars['DateTime']['output'];
  lastPlantingLocalDate: Scalars['DateTime']['output'];
  /** @deprecated Please use seasonName and seasonYear */
  legacySeasonTag?: Maybe<Scalars['String']['output']>;
  plantedArea: UapiMeasure;
  seasonName: UapiSeasonName;
  seasonYear: Scalars['Int']['output'];
  seedProductEvents: Array<UapiSeedProductEvent>;
};

/** Possible distinct methods for planting. */
export enum UapiPlantingMethod {
  /** Fixed Seeding Rate */
  FIXED_RATE = 'FIXED_RATE',
  /** Alternating Seed Products */
  SPLIT_PLANT = 'SPLIT_PLANT',
  /** Variable Seeding Rate */
  VARIABLE_RATE = 'VARIABLE_RATE'
}

/** Prescription Summary for planting activity */
export type UapiPlantingPrescriptionSummary = {
  __typename?: 'PlantingPrescriptionSummary';
  area: UapiMeasure;
  product: UapiSeedProduct;
  rate?: Maybe<UapiMeasure>;
  targetYield?: Maybe<UapiMeasure>;
};

/** Aggregated planting stats by: Crop */
export type UapiPlantingStats = {
  __typename?: 'PlantingStats';
  crop: UapiCrop;
  /**
   * If there are different seeding rate units then you will have multiple PlantingStatsData elements,
   *   one per unique seeding rate unit. There are 2 possible standard units: 'seeds/ha' and 'kg/ha'.
   */
  data: Array<UapiPlantingStatsData>;
};

/** Aggregated planting stats data. */
export type UapiPlantingStatsData = {
  __typename?: 'PlantingStatsData';
  averageSeedingRate: UapiMeasure;
  plantedArea: UapiMeasure;
};

/** Aggregated planting stats for a set of fields */
export type UapiPlantingStatsForFieldSet = {
  __typename?: 'PlantingStatsForFieldSet';
  fields: Array<UapiField>;
  /** number of fields with any planting records available, given the parameters provided (i.e., crop, seasonName, years) */
  numFieldsWithPlantingRecords: Scalars['Int']['output'];
};

/**
 * Attributes based on:
 * https://gitlab.tcc.li/climate/cfvrec/saam/projects/prescription-manager/-/blob/main/prescription_manager/model/prescriptions/schema.py?ref_type=heads#L72-81
 */
export type UapiPlantingZone = UapiZone & {
  __typename?: 'PlantingZone';
  area: UapiMeasure;
  geometry: Scalars['GeoJSONGeometry']['output'];
  id: Scalars['ID']['output'];
  isCheckStrip: Scalars['Boolean']['output'];
  product?: Maybe<UapiSeedProduct>;
  seedingRate?: Maybe<UapiMeasure>;
  targetYield?: Maybe<UapiMeasure>;
};

/** Planting Zone Metadata */
export type UapiPlantingZoneMetadata = UapiZoneMetadata & {
  __typename?: 'PlantingZoneMetadata';
  /**
   * seedProducts: A list of unique seed products across all zones.
   *
   *   Returns: an empty list if there are no seed products found in every zone
   */
  seedProducts: Array<UapiSeedProduct>;
  seedingRateAvgAllZones?: Maybe<UapiMeasure>;
  seedingRateAvgCheckStripOnly?: Maybe<UapiMeasure>;
  seedingRateAvgNoCheckStrip?: Maybe<UapiMeasure>;
  /** totalArea: the summation of each zone's area. */
  totalArea: UapiMeasure;
  totalAreaNoCheckStrip: UapiMeasure;
  totalNumZones: Scalars['Int']['output'];
};

/** Precip Notification Data */
export type UapiPrecipNotificationData = {
  __typename?: 'PrecipNotificationData';
  fields: Array<UapiPrecipNotificationDataField>;
  timeInterval: Scalars['String']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
  totalFieldCount?: Maybe<Scalars['Int']['output']>;
  units: Scalars['String']['output'];
};

/** Precip Data Field */
export type UapiPrecipNotificationDataField = {
  __typename?: 'PrecipNotificationDataField';
  acres?: Maybe<Scalars['Float']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  crop: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  operationId: Scalars['ID']['output'];
  precipAmount: UapiMeasure;
  precipLower?: Maybe<UapiMeasure>;
  precipUpper?: Maybe<UapiMeasure>;
  primaryFieldId: Scalars['ID']['output'];
  pro?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** Prescription */
export type UapiPrescription = UapiNode & {
  __typename?: 'Prescription';
  /** @deprecated Please use plannedActivity.type instead */
  activityType: UapiPrescriptionActivityType;
  createdAt: Scalars['DateTime']['output'];
  /** URL of editing prescription on FieldView */
  editUrl: Scalars['URL']['output'];
  /**
   * Connection to 3rd party platforms (e.g., John Deere)
   *   Returns null if there is no connections yet
   */
  externalConnections?: Maybe<Array<UapiPrescriptionExternalConnection>>;
  field: UapiField;
  /** @deprecated Get zone geometry from prescription zones */
  geometry: Scalars['GeoJSONGeometry']['output'];
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  name: Scalars['String']['output'];
  /** Planned activity which the prescription is used for */
  plannedActivity?: Maybe<UapiPrescriptionPlannedActivity>;
  /**
   * Indicates if this prescription is the primary prescription for the field for the planned activity and cropping year.
   *   Primary prescriptions are the planned prescriptions used for execution.
   */
  primary: Scalars['Boolean']['output'];
  /** Indicates the program instance associated with the prescription */
  programInstance?: Maybe<UapiProgramInstance>;
  /** @deprecated Antiquated concept from REST API, use zones instead */
  summary: UapiPrescriptionSummary;
  type: UapiPrescriptionType;
  updatedAt: Scalars['DateTime']['output'];
  zoneMetadata: UapiZoneMetadata;
  zones: Array<UapiZone>;
};

/** Possible Prescription activities. */
export enum UapiPrescriptionActivityType {
  /** Crop Protection Activities */
  APPLICATION = 'APPLICATION',
  APPLICATION_FUNGICIDE = 'APPLICATION_FUNGICIDE',
  APPLICATION_GROWTH_REGULATOR = 'APPLICATION_GROWTH_REGULATOR',
  APPLICATION_HERBICIDE = 'APPLICATION_HERBICIDE',
  APPLICATION_INSECTICIDE = 'APPLICATION_INSECTICIDE',
  /** Fertility Activities */
  FERTILITY = 'FERTILITY',
  FERTILITY_FALL = 'FERTILITY_FALL',
  FERTILITY_IN_SEASON = 'FERTILITY_IN_SEASON',
  FERTILITY_LATE_SEASON = 'FERTILITY_LATE_SEASON',
  FERTILITY_OTHER = 'FERTILITY_OTHER',
  FERTILITY_PRE_PLANT = 'FERTILITY_PRE_PLANT',
  /** Planting Activities */
  PLANTING = 'PLANTING'
}

/**
 * Possible statuses for prescription approval.
 *
 * When a field is enrolled in a program, a seed density prescription may be generated for the field based on the enrollment details.
 * The prescription then goes through an approval process and can be in one of the following states.
 */
export enum UapiPrescriptionApprovalStatus {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING'
}

/**
 * Count of field plans with a prescription approval status.
 *
 * This is used to summarize the count of field plans by the prescription approval status for a grower's program enrollment.
 */
export type UapiPrescriptionApprovalStatusCount = {
  __typename?: 'PrescriptionApprovalStatusCount';
  count: Scalars['Int']['output'];
  prescriptionApprovalStatus: UapiPrescriptionApprovalStatus;
};

/** Action object to capture status and result of exporting a prescription as a JDOC Work Plan. */
export type UapiPrescriptionAsAjdocWorkPlanExportJob = UapiPrescriptionJob & {
  __typename?: 'PrescriptionAsAJDOCWorkPlanExportJob';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** ID of async job. */
  id: Scalars['ID']['output'];
  requestedAt: Scalars['DateTime']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: UapiPrescriptionJobStatus;
  /** URL to JDOC Work Plan */
  workPlanConnection?: Maybe<UapiPrescriptionExternalConnection>;
};

/** The connection type for Prescription. */
export type UapiPrescriptionConnection = {
  __typename?: 'PrescriptionConnection';
  edges: Array<UapiPrescriptionEdge>;
  pageInfo: UapiPageInfo;
};

/** Defines all context required for a prescription. */
export type UapiPrescriptionContext = {
  __typename?: 'PrescriptionContext';
  /** When the approvalStatus was set to APPROVED or DECLINED. */
  approvalAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who marked the approvalStatus as APPROVED or DECLINED. */
  approvalBy?: Maybe<UapiParty>;
  /** Approval State. If any updates are made to the prescription, the status will be reset */
  approvalStatus: UapiPrescriptionApprovalStatus;
  approvalStatusReason?: Maybe<Scalars['String']['output']>;
  /** DateTime when the prescription was generated. */
  generationAt?: Maybe<Scalars['DateTime']['output']>;
  /** User or service that created the prescription. */
  generationBy?: Maybe<UapiParty>;
  /**
   * Any configuration requirements guiding the generation of a prescription.
   * @deprecated Short term hack until we get a long term plan
   */
  generationConfiguration?: Maybe<Scalars['JSON']['output']>;
  /** Status of prescription generation. */
  generationStatus: UapiPrescriptionGenerationStatus;
  generationStatusReason?: Maybe<Scalars['String']['output']>;
  historicalCrops: Array<UapiHistoricalCropYear>;
  prescription?: Maybe<UapiPrescription>;
  /**
   * Seed Product Price used for Prescription Generation.
   *
   *   If seed product price is null, prescription was generated using yield optimal strategy.
   */
  seedProductPrice?: Maybe<UapiUnitPrice>;
  /** Whether or not the prescriptionContext has been shared with other relevant parties */
  shared: Scalars['Boolean']['output'];
  /** DateTime when the prescription context was shared. */
  sharedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User or service that shared the PrescriptionContext. */
  sharedBy?: Maybe<UapiParty>;
};

/** An edge in a Prescription connection. */
export type UapiPrescriptionEdge = {
  __typename?: 'PrescriptionEdge';
  cursor: Scalars['String']['output'];
  node: UapiPrescription;
};

/** The prescription on the enrollment does not have a check strip */
export type UapiPrescriptionEnrolledHasNoCheckStrip = {
  __typename?: 'PrescriptionEnrolledHasNoCheckStrip';
  message: Scalars['String']['output'];
  prescriptionId: Scalars['ID']['output'];
};

/** The prescription on the enrollment was not found on the enrollment */
export type UapiPrescriptionEnrolledNotFound = {
  __typename?: 'PrescriptionEnrolledNotFound';
  message: Scalars['String']['output'];
};

/** Connect of Prescription to external platform (e.g., John Deere) */
export type UapiPrescriptionExternalConnection = {
  __typename?: 'PrescriptionExternalConnection';
  connectedUrl: Scalars['String']['output'];
  type: UapiPrescriptionExternalConnectionType;
};

/** Partner Connection Type */
export enum UapiPrescriptionExternalConnectionType {
  JOHN_DEERE = 'JOHN_DEERE'
}

/** Input to filter prescriptions */
export type UapiPrescriptionFilter = {
  /** Filter by fields */
  fieldIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filter by if the prescription is primary prescription or not.
   *   Use null to apply no filter on this criteria.
   */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by operations */
  operationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filter by season name
   *   Using null or empty list applies no filter on this criteria.
   */
  seasonName?: InputMaybe<UapiSeasonName>;
  /**
   * Filter by prescription types
   *   Using null or empty list applies no filter on this criteria.
   */
  types?: InputMaybe<Array<UapiPrescriptionType>>;
  /**
   * Filter by cropping seasons
   *   Using null or empty list applies no filter on this criteria.
   */
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Possible statuses for prescription generation completion. */
export enum UapiPrescriptionGenerationStatus {
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  /** Generated prescription failed expected requirements or specifications. */
  INELIGIBLE = 'INELIGIBLE',
  /** Status for if the automated prescription was overridden with a manual prescription. */
  MANUAL = 'MANUAL',
  /** Not yet generated. */
  PENDING = 'PENDING'
}

/** Interface representing instance of general prescription-related async job. */
export type UapiPrescriptionJob = {
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  requestedAt: Scalars['DateTime']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: UapiPrescriptionJobStatus;
};

/** The status of a particular prescriptino-related async job. */
export enum UapiPrescriptionJobStatus {
  CANCELLED = 'CANCELLED',
  EXECUTING = 'EXECUTING',
  FAILED = 'FAILED',
  INVALID = 'INVALID',
  PENDING = 'PENDING',
  SUCCEEDED = 'SUCCEEDED'
}

/** File Format of Prescription that is compatible with agricultural equipment monitors. */
export type UapiPrescriptionMonitorFileFormat = {
  __typename?: 'PrescriptionMonitorFileFormat';
  /**
   * Monitor format description
   *   E.g., "John Deere RX ShapeFile format compatible with John Deere equipment"
   */
  description: Scalars['String']['output'];
  /**
   * Monitor format id
   *   E.g., "john-deere-gs2-gs3-rx-shapefile"
   */
  id: Scalars['ID']['output'];
  /**
   * Monitor format name
   *   E.g., "John Deere RX ShapeFile"
   */
  name: Scalars['String']['output'];
};

/** An agronomic activity which a prescription is planned to use for */
export type UapiPrescriptionPlannedActivity = {
  __typename?: 'PrescriptionPlannedActivity';
  activityDate: Scalars['DateTime']['output'];
  croppingYear: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  season: UapiSeasonName;
  type: UapiPrescriptionActivityType;
};

/** The result will either be an error or an output prescription */
export type UapiPrescriptionResultOutput = UapiEvaluationResultPrescriptionAsHarvested | UapiPrescriptionEnrolledNotFound;

/** Prescription Summary */
export type UapiPrescriptionSummary = {
  __typename?: 'PrescriptionSummary';
  planting?: Maybe<Array<UapiPlantingPrescriptionSummary>>;
};

/**
 * Possible Prescription Type.
 * A Prescription type can be be used for multiple Prescription activities
 */
export enum UapiPrescriptionType {
  CROP_PROTECTION = 'CROP_PROTECTION',
  FERTILITY = 'FERTILITY',
  PLANTING = 'PLANTING'
}

/** Action object to capture status and result of downloading prescriptions as a single compressed zip file. */
export type UapiPrescriptionsDownloadJob = UapiPrescriptionJob & {
  __typename?: 'PrescriptionsDownloadJob';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** URL to download the exported prescriptions. If job is not successful, download URL will be null */
  downloadUrl?: Maybe<Scalars['URL']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** ID of async job. */
  id: Scalars['ID']['output'];
  requestedAt: Scalars['DateTime']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: UapiPrescriptionJobStatus;
};

/**
 * Action object to capture status and result of exporting prescriptions to John Deere Operations Center (JDOC) Rx Files
 * as a single compressed zip file.
 */
export type UapiPrescriptionsToJdocFilesExportJob = UapiPrescriptionJob & {
  __typename?: 'PrescriptionsToJDOCFilesExportJob';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** ID of async job. */
  id: Scalars['ID']['output'];
  requestedAt: Scalars['DateTime']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: UapiPrescriptionJobStatus;
};

/**
 * The price of something.
 *
 * ##### Example
 * ```
 * {
 * "currencyCode": "USD",
 * "amount": "100.00"
 * }
 * ```
 */
export type UapiPrice = {
  __typename?: 'Price';
  amount: Scalars['Money']['output'];
  currencyCode: Scalars['Currency']['output'];
};

/** Input type for price. */
export type UapiPriceInput = {
  amount: Scalars['Money']['input'];
  currencyCode: Scalars['Currency']['input'];
};

/**
 * Discount amount on a price per unit basis.
 *
 * ### Example
 * ```graphql
 * {
 * units: {
 * "u": "bags",
 * "v": 5
 * },
 * unitPrice: {
 * "currencyCode": "USD",
 * "amount": "100.00"
 * }
 * }
 * ```
 */
export type UapiPricePerUnit = {
  __typename?: 'PricePerUnit';
  unitPrice: UapiPrice;
  units: UapiMeasure;
};

/** Input type for PricePerUnit. */
export type UapiPricePerUnitInput = {
  unitPrice: UapiPriceInput;
  units: UapiMeasureInput;
};

/** Represents a Program with one or more instances. */
export type UapiProgram = UapiNode & {
  __typename?: 'Program';
  auditMetadata: UapiAuditMetadata;
  countryCodes: Array<Scalars['CountryCode']['output']>;
  dataLegitimacy: UapiDataLegitimacy;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  iconUrl?: Maybe<Scalars['URL']['output']>;
  id: Scalars['ID']['output'];
  /** List program instances for this program. */
  instances: Array<UapiProgramInstance>;
  itemStatus: UapiItemStatus;
  name: Scalars['String']['output'];
};


/** Represents a Program with one or more instances. */
export type UapiProgramInstancesArgs = {
  order?: InputMaybe<Array<UapiProgramInstanceOrdering>>;
};

/** Connection Type for Programs. */
export type UapiProgramConnection = {
  __typename?: 'ProgramConnection';
  /** Contains the nodes in this connection */
  edges: Array<UapiProgramEdge>;
  /** Pagination data for this connection */
  pageInfo: UapiPageInfo;
};

/** An edge in a connection. */
export type UapiProgramEdge = {
  __typename?: 'ProgramEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UapiProgram;
};

/** Input type for filtering programs. */
export type UapiProgramFilter = {
  countryCodes?: InputMaybe<Array<Scalars['CountryCode']['input']>>;
  dataLegitimacy?: InputMaybe<UapiDataLegitimacyQuery>;
  itemStatus?: InputMaybe<UapiItemStatusQuery>;
  updatedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  updatedSince?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * Represents an occurance of a program for a specified time period.
 *
 * A program instance is specific to a geographic region and future enhancements should reflect the geographic regions.
 */
export type UapiProgramInstance = UapiNode & {
  __typename?: 'ProgramInstance';
  /** The agreement template associated with this program instance. */
  agreementTemplate?: Maybe<UapiAgreementTemplate>;
  auditMetadata: UapiAuditMetadata;
  configuration?: Maybe<UapiProgramInstanceConfiguration>;
  /** Country where the program instance is applicable. */
  countryCode: Scalars['CountryCode']['output'];
  /** Crops supported by the program instance. */
  crops: Array<UapiCrop>;
  dataLegitimacy: UapiDataLegitimacy;
  /** Display name for UI needs. */
  displayName: Scalars['String']['output'];
  /** @deprecated Unused field for legacy programs */
  externalIdentity?: Maybe<UapiExternalIdentity>;
  /** The grower program enrollments linked to the program instance. */
  growerProgramEnrollments: UapiGrowerProgramEnrollmentConnection;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  name: Scalars['String']['output'];
  program: UapiProgram;
  /** Rulesets that are applicable to the program grower eligibility, field eligibility and various agronomic activites. */
  protocols: Array<UapiProtocol>;
  /** List program instance stages for this program instance. */
  stages: Array<UapiProgramInstanceStage>;
  /**
   * Crop seasons for which the program instance is applicable.
   *
   *   A program instance may be valid for a single crop season or multiple crop seasons.
   */
  temporalPeriod?: Maybe<UapiProgramTemporalPeriod>;
  /** Start and end dates of the program instance. */
  timeInterval: UapiTimeInterval;
};


/**
 * Represents an occurance of a program for a specified time period.
 *
 * A program instance is specific to a geographic region and future enhancements should reflect the geographic regions.
 */
export type UapiProgramInstanceGrowerProgramEnrollmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UapiProgramInstanceGrowerProgramEnrollmentsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UapiGrowerProgramEnrollmentOrdering>>;
};

/** Configuration data associated with a program instance */
export type UapiProgramInstanceConfiguration = {
  __typename?: 'ProgramInstanceConfiguration';
  challengerSeedBrands: Array<UapiSeedBrand>;
  championSeedBrands: Array<UapiSeedBrand>;
};

/** Connection Type for Program Instances. */
export type UapiProgramInstanceConnection = {
  __typename?: 'ProgramInstanceConnection';
  /** Contains the nodes in this connection */
  edges: Array<UapiProgramInstanceEdge>;
  /** Pagination data for this connection */
  pageInfo: UapiPageInfo;
};

/** An edge in a connection. */
export type UapiProgramInstanceEdge = {
  __typename?: 'ProgramInstanceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UapiProgramInstance;
};

/** Input type for filtering program instances. */
export type UapiProgramInstanceFilter = {
  challengerSeedBrandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  challengerSeedBrandNames?: InputMaybe<Array<Scalars['String']['input']>>;
  dataLegitimacy?: InputMaybe<UapiDataLegitimacyQuery>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  itemStatus?: InputMaybe<UapiItemStatusQuery>;
  programYear?: InputMaybe<Scalars['Int']['input']>;
  updatedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  updatedSince?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Filters available for retrieving grower enrollments on a program instance. */
export type UapiProgramInstanceGrowerProgramEnrollmentsFilter = {
  dataLegitimacy?: UapiDataLegitimacyQuery;
  eligibilityStatus?: InputMaybe<UapiEligibilityStatusQuery>;
  /** Filter the results by enrollment status. */
  enrollmentStatuses?: InputMaybe<Array<UapiGrowerProgramEnrollmentStatusQuery>>;
  /** Filter the results by grower. */
  growerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemStatus?: UapiItemStatusQuery;
};

/** Sort columns for queries on program instances. */
export enum UapiProgramInstanceOrderBy {
  NAME = 'NAME',
  START_DATE = 'START_DATE'
}

/** Input specification for ordering program instance query results. */
export type UapiProgramInstanceOrdering = {
  by: UapiProgramInstanceOrderBy;
  direction?: UapiOrderByDirection;
};

/** Represents a stage (window) associated with a program instance. */
export type UapiProgramInstanceStage = {
  __typename?: 'ProgramInstanceStage';
  end?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  stageType: UapiProgramInstanceStageEnum;
  start?: Maybe<Scalars['DateTime']['output']>;
};

/** Possible values for program instance stage. */
export enum UapiProgramInstanceStageEnum {
  ENROLLMENT = 'ENROLLMENT',
  HARVEST = 'HARVEST',
  ONBOARDING = 'ONBOARDING',
  PLANTING = 'PLANTING',
  REVIEW = 'REVIEW'
}

/**
 * Type of an offer provided by a program.
 *
 * Note: This is a shared enum. The source of truth should Program Catalog domain.
 */
export enum UapiProgramOfferType {
  /** Base or standard offer. May or may not include monetary incentives. */
  BASE = 'BASE',
  /** No (Available or Qualified or Enrolled) Offer. */
  NO_OFFER = 'NO_OFFER',
  /** Offer with incentives to mitigate Risk. */
  RISK_SHARING = 'RISK_SHARING'
}

/** Sort columns for queries on programs. */
export enum UapiProgramOrderBy {
  DISPLAY_NAME = 'DISPLAY_NAME',
  NAME = 'NAME'
}

/** Input specification for ordering program query results. */
export type UapiProgramOrdering = {
  by: UapiProgramOrderBy;
  direction?: UapiOrderByDirection;
};

/** Payment associated with a grower enrolled in a program instance. */
export type UapiProgramPayment = UapiNode & {
  __typename?: 'ProgramPayment';
  auditMetadata: UapiAuditMetadata;
  /** The grower enrollment associated with the payment. */
  growerProgramEnrollment: UapiGrowerProgramEnrollment;
  id: Scalars['ID']['output'];
  /** Payment amount. This could be a rebate or incentive amount. */
  paymentAmount: UapiMonetaryAmount;
};

/** Represents a set of product recommendations including metadata */
export type UapiProgramRecommendation = {
  /** Meta data of recommendation */
  metadata: UapiRecommendationMetadata;
  /** Party who owns the data or subject which is used to create recommendation */
  subjectParty?: Maybe<UapiParty>;
};

/**
 * A single program season.
 *
 * In future, a Program Season should include additional attributes such as crop year (harvest year) and agronomic season (SUMMER, SPRING).
 */
export type UapiProgramSeason = {
  __typename?: 'ProgramSeason';
  name: UapiSeasonName;
  programYear: Scalars['Int']['output'];
  /**
   * Program year typically has been the calendar year the program started.
   *
   *   This may differ from crop year which is typically the year in
   *   which crop is harvested. For Brazil summer which starts in December `24 with
   *   harvest in March '25', the program year is 2024 while the agronomic season is 2025:_SUM.
   */
  year: Scalars['Int']['output'];
};

/** Input type for ProgramSeason. */
export type UapiProgramSeasonInput = {
  name: UapiSeasonName;
  programYear: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

/**
 * Union type representing the interval of a Program.
 *
 * In future the union values will include additional interval types as below:
 */
export type UapiProgramTemporalPeriod = UapiProgramSeason;

/** Input type for ProgramTemporalPeriod. */
export type UapiProgramTemporalPeriodInput = {
  programSeason: UapiProgramSeasonInput;
};

/** Represents a protocol for a Program */
export type UapiProtocol = UapiNode & {
  __typename?: 'Protocol';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  name: Scalars['String']['output'];
  programInstance: UapiProgramInstance;
  protocolRulesets: Array<UapiProtocolRuleset>;
};

/** Possible states of an entity's eligibility in a protocol. */
export enum UapiProtocolEligibilityStatus {
  /** Not enough data was available to determine the eligibility of the entity for the protocol. */
  AWAITING_DATA = 'AWAITING_DATA',
  /** The entity is eligible for the protocol. */
  ELIGIBLE = 'ELIGIBLE',
  /** The eligibility of the entity for the protocol cannot be determined. */
  INDETERMINATE = 'INDETERMINATE',
  /** The entity is not eligible for the protocol. */
  INELIGIBLE = 'INELIGIBLE',
  /** The eligibility of the entity for the protocol has not yet been determined. */
  PENDING = 'PENDING'
}

/** Represents a set of rules that are applicable for a stage of program protocol. */
export type UapiProtocolRuleset = {
  __typename?: 'ProtocolRuleset';
  id: Scalars['ID']['output'];
  ruleset: UapiRuleset;
  rulesetType: UapiRulesetType;
};

/** Queries for Applied Product */
export type UapiQuery = {
  __typename?: 'Query';
  /** Get an agreement template by id. */
  agreementTemplate?: Maybe<UapiAgreementTemplate>;
  appliedProducts: UapiAppliedProductConnection;
  authenticatedUser?: Maybe<UapiUser>;
  crop?: Maybe<UapiCrop>;
  cropMonitoringFieldRecordStats: UapiCropMonitoringFieldRecordStats;
  cropMonitoringFieldRecords: UapiCropMonitoringFieldRecordConnection;
  /** Get a crop plan by id. */
  cropPlan?: Maybe<UapiCropPlan>;
  /** Query to fetch crop plans. */
  cropPlans: UapiCropPlanConnection;
  crops: UapiCropConnection;
  field?: Maybe<UapiField>;
  /** Get a field plan by id. */
  fieldPlan?: Maybe<UapiFieldPlan>;
  /** Query to fetch field plans. */
  fieldPlans: UapiFieldPlanConnection;
  /** Get a field program enrollment by id. */
  fieldProgramEnrollment?: Maybe<UapiFieldProgramEnrollment>;
  /** Retrieve the subscription features available to this specific country */
  fieldViewFeaturesByCountry: Array<UapiFieldViewFeature>;
  /** Retrieve the products available to this specific country */
  fieldViewProductsByCountry: Array<UapiFieldViewProduct>;
  fungicideApplicationRecommendations: UapiFungicideApplicationRecommendationConnection;
  hybridPairingRecommendations: UapiHybridPairingRecommendationConnection;
  /** Query to get aggregated machine data by field ID. */
  machineDataByFieldId: UapiField;
  operation?: Maybe<UapiOperation>;
  /**
   * Returns the set of operations that are shared among all users in the input list.
   *   This is effectively the intersection of the operations accessible to each user.
   */
  operationsSharedWithAll: UapiOperationConnection;
  /** Query to fetch paid seed product prices. */
  paidSeedProductPrices: Array<UapiPaidSeedProductPrice>;
  partyRelationship?: Maybe<UapiPartyRelationship>;
  partyRelationshipType?: Maybe<UapiPartyRelationshipType>;
  partyRelationships: UapiPartyRelationshipConnection;
  /** Get Prescription by id. ID must be UUID */
  prescription?: Maybe<UapiPrescription>;
  /** Get details of export prescription as a JDOC Work Plan job by ID. Returns null if not found. */
  prescriptionAsAJDOCWorkPlanExportJob?: Maybe<UapiPrescriptionAsAjdocWorkPlanExportJob>;
  /** Get available prescription monitor formats */
  prescriptionMonitorFileFormats: Array<UapiPrescriptionMonitorFileFormat>;
  prescriptions: UapiPrescriptionConnection;
  /** Get details of download prescription job by ID. Returns null if not found. */
  prescriptionsDownloadJob?: Maybe<UapiPrescriptionsDownloadJob>;
  /** Get details of export prescriptions to John Deere Operational Centre(JDOC) job by ID. Returns null if not found. */
  prescriptionsToJDOCFilesExportJob?: Maybe<UapiPrescriptionsToJdocFilesExportJob>;
  /** Get a program by id. */
  program?: Maybe<UapiProgram>;
  /** Get a program instance by id. */
  programInstance?: Maybe<UapiProgramInstance>;
  /** Get all program instances */
  programInstances: UapiProgramInstanceConnection;
  /** Get all programs. */
  programs: UapiProgramConnection;
  /** Get a protocol by id. */
  protocol?: Maybe<UapiProtocol>;
  /**
   * Create static seeding rate prescription by recommending optimal seeding rate using Hardin model.
   *   Hardin model is also known as yield model that gives optimal seeding rate based on target yield and hybrid
   *   seed product.
   */
  recommendYieldOptimalSeedingRate: UapiSeedingRateRecommendation;
  /** Get a recorded agreement by id. */
  recordedAgreement?: Maybe<UapiRecordedAgreement>;
  /** Get a ruleset by id. */
  ruleset: UapiRuleset;
  /** Query to fetch seed product favorites. */
  seedProductFavorites: UapiSeedProductFavoriteConnection;
  seedProductRecommendations: UapiSeedProductRecommendationConnection;
  /** Get a seed product recommendation preference by id. */
  seedProductRecommendationsPreference?: Maybe<UapiSeedProductRecommendationsPreference>;
  /** Query to fetch seed product recommendation preferences. */
  seedProductRecommendationsPreferences: UapiSeedProductRecommendationsPreferenceConnection;
  seedProducts: UapiSeedProductConnection;
  /** Query to get aggregated machine data for a single field, crop, season, year and region. */
  singleFieldRegionStats: UapiFieldRegionStats;
  /** Get a trial by id. */
  trial?: Maybe<UapiTrial>;
  /** Get a trial block by id. */
  trialBlock?: Maybe<UapiTrialBlock>;
  /** Retrieve FieldView product trials available to this specific country */
  trialFieldViewProductsByCountry: Array<UapiFieldViewProductTrial>;
  /** Query to fetch trials. */
  trials: UapiTrialConnection;
  user?: Maybe<UapiUser>;
  userGroupAssignment?: Maybe<UapiUserGroupAssignment>;
  userGroupAssignments: UapiUserGroupAssignmentConnection;
  /**
   * Get a single notification
   *   User id is extracted from the authentication token if no Id is included in the parameters.
   */
  userNotification?: Maybe<UapiUserNotification>;
  /**
   * List notifications sent to a user.
   *   User id is extracted from the authentication token if no Id is included in the parameters.
   */
  userNotifications: UapiNotificationConnection;
  users: UapiUserConnection;
  withOperationFields: UapiOperationFieldsAck;
  /** Returns OperationFields enrolled in a program and grouped by enrollment status. */
  withOperationFieldsHavingProgramEnrollmentsByEnrollmentStatus: Array<UapiEnrolledOperationFieldsByEnrollmentStatus>;
  withUsersHavingGroupAssignments: UapiUsersAck;
  /** Returns User Aggregation Context Keyset with list of grower ids enrolled in the program instance. */
  withUsersHavingProgramEnrollments: UapiUsersAck;
  zoneGenerationAvailableData: UapiZoneGenerationAvailableDataConnection;
};


/** Queries for Applied Product */
export type UapiQueryAgreementTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryAppliedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UapiAppliedProductFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UapiAppliedProductOrderByInput>>;
};


/** Queries for Applied Product */
export type UapiQueryCropArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryCropMonitoringFieldRecordStatsArgs = {
  dataLegitimacy?: InputMaybe<UapiDataLegitimacyQuery>;
  operationIds: Array<Scalars['ID']['input']>;
  seasonName: UapiSeasonName;
  seasonYear: Scalars['Int']['input'];
};


/** Queries for Applied Product */
export type UapiQueryCropMonitoringFieldRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: UapiCropMonitoringFieldRecordFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Array<UapiCropMonitoringFieldRecordOrdering>>;
};


/** Queries for Applied Product */
export type UapiQueryCropPlanArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryCropPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: UapiCropPlansFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UapiCropPlansOrdering>>;
};


/** Queries for Applied Product */
export type UapiQueryCropsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UapiCropFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries for Applied Product */
export type UapiQueryFieldArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryFieldPlanArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryFieldPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: UapiFieldPlansFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries for Applied Product */
export type UapiQueryFieldProgramEnrollmentArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryFieldViewFeaturesByCountryArgs = {
  country: Scalars['CountryCode']['input'];
};


/** Queries for Applied Product */
export type UapiQueryFieldViewProductsByCountryArgs = {
  country: Scalars['CountryCode']['input'];
};


/** Queries for Applied Product */
export type UapiQueryFungicideApplicationRecommendationsArgs = {
  fieldIds: Array<Scalars['ID']['input']>;
  year: Scalars['Int']['input'];
};


/** Queries for Applied Product */
export type UapiQueryHybridPairingRecommendationsArgs = {
  challengerFilters?: InputMaybe<UapiHybridPairingProductFilterInput>;
  championFilters?: InputMaybe<UapiHybridPairingProductFilterInput>;
  fieldIds: Array<Scalars['ID']['input']>;
  source?: InputMaybe<UapiRecommendationSource>;
  version?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Int']['input'];
};


/** Queries for Applied Product */
export type UapiQueryMachineDataByFieldIdArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryOperationArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryOperationsSharedWithAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter: UapiOperationsSharedWithAllFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries for Applied Product */
export type UapiQueryPaidSeedProductPricesArgs = {
  filter?: InputMaybe<UapiPaidSeedProductPriceFilter>;
};


/** Queries for Applied Product */
export type UapiQueryPartyRelationshipArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryPartyRelationshipTypeArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryPartyRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter: UapiPartyRelationshipFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Array<UapiPartyRelationshipOrdering>>;
};


/** Queries for Applied Product */
export type UapiQueryPrescriptionArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryPrescriptionAsAjdocWorkPlanExportJobArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryPrescriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UapiPrescriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries for Applied Product */
export type UapiQueryPrescriptionsDownloadJobArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryPrescriptionsToJdocFilesExportJobArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryProgramArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryProgramInstanceArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryProgramInstancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<UapiProgramInstanceFilter>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Array<UapiProgramInstanceOrdering>>;
};


/** Queries for Applied Product */
export type UapiQueryProgramsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<UapiProgramFilter>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Array<UapiProgramOrdering>>;
};


/** Queries for Applied Product */
export type UapiQueryProtocolArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryRecommendYieldOptimalSeedingRateArgs = {
  input: UapiRecommendYieldOptimalSeedingRateInput;
};


/** Queries for Applied Product */
export type UapiQueryRecordedAgreementArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryRulesetArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQuerySeedProductFavoritesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: UapiSeedProductFavoritesFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries for Applied Product */
export type UapiQuerySeedProductRecommendationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  season: UapiSeasonName;
  source: UapiRecommendationSource;
  version?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Int']['input'];
};


/** Queries for Applied Product */
export type UapiQuerySeedProductRecommendationsPreferenceArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQuerySeedProductRecommendationsPreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: UapiSeedProductRecommendationsPreferencesFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries for Applied Product */
export type UapiQuerySeedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UapiSeedProductFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UapiSeedProductOrderByInput>>;
};


/** Queries for Applied Product */
export type UapiQuerySingleFieldRegionStatsArgs = {
  cropId: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
  region?: InputMaybe<Scalars['GeoJSONGeometry']['input']>;
  seasonName: UapiSeasonName;
  seasonYear: Scalars['Int']['input'];
};


/** Queries for Applied Product */
export type UapiQueryTrialArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryTrialBlockArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryTrialFieldViewProductsByCountryArgs = {
  country: Scalars['CountryCode']['input'];
};


/** Queries for Applied Product */
export type UapiQueryTrialsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: UapiTrialFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries for Applied Product */
export type UapiQueryUserArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryUserGroupAssignmentArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryUserGroupAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter: UapiUserGroupAssignmentFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries for Applied Product */
export type UapiQueryUserNotificationArgs = {
  notificationId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
  userLegacyId?: InputMaybe<Scalars['ID']['input']>;
};


/** Queries for Applied Product */
export type UapiQueryUserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userLegacyId?: InputMaybe<Scalars['ID']['input']>;
};


/** Queries for Applied Product */
export type UapiQueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UapiUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Array<UapiUserOrdering>>;
};


/** Queries for Applied Product */
export type UapiQueryWithOperationFieldsArgs = {
  fieldsSearchControl?: InputMaybe<UapiFieldsSearchControlInput>;
  operationId: Scalars['ID']['input'];
};


/** Queries for Applied Product */
export type UapiQueryWithOperationFieldsHavingProgramEnrollmentsByEnrollmentStatusArgs = {
  filter: UapiWithOperationFieldsHavingProgramEnrollmentsByEnrollmentStatusFilter;
};


/** Queries for Applied Product */
export type UapiQueryWithUsersHavingGroupAssignmentsArgs = {
  userGroupIds: Array<Scalars['String']['input']>;
};


/** Queries for Applied Product */
export type UapiQueryWithUsersHavingProgramEnrollmentsArgs = {
  filter: UapiWithUsersHavingProgramEnrollmentsFilter;
};


/** Queries for Applied Product */
export type UapiQueryZoneGenerationAvailableDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter: UapiZoneGenerationAvailableDataFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  targets: Array<UapiZoneGenerationTarget>;
};

/**
 * A color defined using red, green, and blue components, with an optional alpha
 * (transparency) channel. Each RGB channel should be between 0–255, and alpha
 * should be between 0.0–1.0 where 1.0 is fully opaque.
 */
export type UapiRgba = {
  __typename?: 'RGBA';
  alpha?: Maybe<Scalars['Float']['output']>;
  blue: Scalars['Int']['output'];
  green: Scalars['Int']['output'];
  red: Scalars['Int']['output'];
};

/**
 * Parameters for slippy map visualizations, detailing necessary attributes for rendering.
 * Includes URLs for map tiles and thumbnails, along with legend information, version, and source.
 */
export type UapiRasterTileset = {
  __typename?: 'RasterTileset';
  crs: UapiCrs;
  dataLegitimacy: UapiDataLegitimacy;
  legend: UapiGeospatialAssetLegend;
  source: UapiGeospatialAssetSource;
  thumbnailUrl?: Maybe<Scalars['URL']['output']>;
  tileUrlTemplate: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

/** Input to create static seeding rate recommendation for prescription */
export type UapiRecommendYieldOptimalSeedingRateInput = {
  countryCode: Scalars['CountryCode']['input'];
  season: UapiSeasonName;
  /** seedProductId should be UUID. Eg: a0b24688-b113-4951-8f73-e74f479e0185 */
  seedProductId: Scalars['ID']['input'];
  /** Unit of target yield must be kilogram/hectare. */
  targetYieldInKgPerHectare: Scalars['Float']['input'];
};

/** Metadata associated with a recommendation. */
export type UapiRecommendationMetadata = {
  __typename?: 'RecommendationMetadata';
  createdAt: Scalars['DateTime']['output'];
  createdBy: UapiParty;
  dataLegitimacy: UapiDataLegitimacy;
  featureSet?: Maybe<Scalars['String']['output']>;
  itemStatus: UapiItemStatus;
  model?: Maybe<Scalars['String']['output']>;
  /** source of recommendations */
  source: UapiRecommendationSource;
  tenant?: Maybe<UapiParty>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: UapiParty;
  /** version of recommendations */
  version?: Maybe<Scalars['Int']['output']>;
};

/** Identifies the source of recommendation */
export enum UapiRecommendationSource {
  /** DeKalb Integrado Program Seed Product Recommendations */
  DEKALB_INTEGRADO_PROGRAM = 'DEKALB_INTEGRADO_PROGRAM',
  /** Local selection enrollment */
  LOCAL_SELECTION = 'LOCAL_SELECTION',
  /** Science based models */
  SCIENCE_BASED_MODELS = 'SCIENCE_BASED_MODELS',
  /** VAlora Program Seed Product Recommendations */
  VALORA_PROGRAM = 'VALORA_PROGRAM'
}

/** Input parameters for finalizing a grower enrollment in a program instance. */
export type UapiReconcileGrowerProgramEnrollmentInput = {
  /** The grower enrollment being reconciled. */
  growerProgramEnrollmentId: Scalars['ID']['input'];
};

/** Represents a Recorded Agreement for terms and conditions that a user can sign. */
export type UapiRecordedAgreement = UapiNode & {
  __typename?: 'RecordedAgreement';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  id: Scalars['ID']['output'];
  senderUser?: Maybe<UapiUser>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  signedRecordedAgreementUrl?: Maybe<Scalars['URL']['output']>;
  status: UapiRecordedAgreementStatus;
  template: UapiAgreementTemplate;
  user: UapiUser;
};

/** Possible values for a recorded agreement status. */
export enum UapiRecordedAgreementStatus {
  /** The recorded agreement is signed and completed */
  COMPLETED = 'COMPLETED',
  /** The recorded agreement is created for signing */
  CREATED = 'CREATED',
  /** The recorded agreement is declined */
  DECLINED = 'DECLINED',
  /** The recorded agreement is sent or resent for signing */
  SENT = 'SENT',
  /** The recorded agreement is voided or expired */
  VOIDED = 'VOIDED'
}

/**
 * A means of predicting when a crop will be ready for harvest.
 * ### Example
 * ```
 * {
 * "method": "COMPARATIVE",
 * "value":"9.6",
 * "unit": "COMPARATIVE"
 * }
 * ```
 */
export type UapiRelativeMaturity = {
  __typename?: 'RelativeMaturity';
  method?: Maybe<UapiRelativeMaturityMethod>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** A means of predicting when a crop will be ready for harvest. */
export enum UapiRelativeMaturityMethod {
  COMPARATIVE = 'COMPARATIVE',
  HEAT_UNITS = 'HEAT_UNITS'
}

/** Filters available for retrieving results on a field harvesting task. */
export type UapiResultsOnFieldHarvestingTaskFilter = {
  evaluationStatuses?: InputMaybe<Array<UapiEvaluationStatus>>;
  latest?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filters available for retrieving results on a field planting task. */
export type UapiResultsOnFieldPlantingTaskFilter = {
  evaluationStatuses?: InputMaybe<Array<UapiEvaluationStatus>>;
  latest?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Interface type for Return On Investment Result Summary. */
export type UapiRoiResultStats = {
  /**
   * Total additional cost of the seed product resulting from the higher seeding rate for the grower fields in a field set.
   *
   *   Null if there is no ROI data for the set of fields.
   */
  totalAdditionalCost?: Maybe<UapiMonetaryAmount>;
  /**
   * Total additional revenue resulting from higher seeding rate for the grower fields in a field set.
   *
   *   Null if there is no ROI data for the set of fields.
   */
  totalAdditionalRevenue?: Maybe<UapiMonetaryAmount>;
  /**
   * Total Return On Investment (ROI) for the grower fields in a field set.
   *
   *   Null if there is no ROI data for the set of fields.
   */
  totalRoi?: Maybe<UapiMonetaryAmount>;
};

/** Represents a single rule. */
export type UapiRule = UapiNode & {
  __typename?: 'Rule';
  constraintDisplayTemplate?: Maybe<Scalars['String']['output']>;
  constraints: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

/** Manual or Automated Rule Results. */
export type UapiRuleEvaluation = UapiManualRuleResult | UapiRuleResult;

/** The result of a rule in an eligibility result. */
export type UapiRuleResult = {
  __typename?: 'RuleResult';
  /** The rule constraints used to evaluate the rule. */
  constraints: Scalars['JSON']['output'];
  /** The display template used to render the constraints. */
  constraintsDisplay: Scalars['String']['output'];
  /** The data provided to evaluate the rule. */
  factData: Scalars['JSON']['output'];
  /** The display template used to render the fact data. */
  factDataDisplay: Scalars['String']['output'];
  /** The result of evaluating the rule. */
  result: UapiRuleResultStatus;
  /** The associated rule. */
  rule: UapiRule;
};

/** Input type for RuleResult. Used when a system is creating the rule result. */
export type UapiRuleResultInput = {
  constraints: Scalars['JSON']['input'];
  constraintsDisplay: Scalars['String']['input'];
  factData: Scalars['JSON']['input'];
  factDataDisplay: Scalars['String']['input'];
  result: UapiRuleResultStatus;
  ruleId: Scalars['ID']['input'];
};

/** Possible status values resulting from applying a Rule on provided data. */
export enum UapiRuleResultStatus {
  /** The provided data did not satisfy the rule constriants. */
  FAIL = 'FAIL',
  /** Result could not be determined. This could be due to missing data or an application error. */
  INDETERMINATE = 'INDETERMINATE',
  /** The provided data satisfied the rule constraints. */
  PASS = 'PASS'
}

/** Represents a set of rules. */
export type UapiRuleset = UapiNode & {
  __typename?: 'Ruleset';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  name: Scalars['String']['output'];
  rules: Array<UapiRule>;
  versionHistory: Array<UapiRulesetVersion>;
};

/** Possible types of rulesets. */
export enum UapiRulesetType {
  FIELD_ELIGIBILITY = 'FIELD_ELIGIBILITY',
  FIELD_PRELIMINARY_ELIGIBILITY = 'FIELD_PRELIMINARY_ELIGIBILITY',
  GROWER_PRELIMINARY_ELIGIBILITY = 'GROWER_PRELIMINARY_ELIGIBILITY'
}

/**
 * Represents a version of the ruleset.
 *
 * Rulesets are immutable. When a ruleset is updated, a new ruleset version is created.
 */
export type UapiRulesetVersion = UapiNode & {
  __typename?: 'RulesetVersion';
  auditMetadata: UapiAuditMetadata;
  id: Scalars['ID']['output'];
  rules: Array<UapiRule>;
  ruleset: UapiRuleset;
  version: Scalars['Int']['output'];
};

/** Input type for a Season Name / Season Year correction. */
export type UapiSeasonCorrectionInput = {
  correctedSeasonName: UapiSeasonName;
  correctedSeasonYear: Scalars['Int']['input'];
};

/** Input type for a Season Event correction, it is possible to also correct mutiple seed products in the same season. */
export type UapiSeasonEventCorrectionInput = {
  cropId: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
  /**
   * A valid correction must include at least a seasonCorrection or a seedProductCorrection.
   *   Not having any of those is an invalid correction request.
   */
  seasonCorrection?: InputMaybe<UapiSeasonCorrectionInput>;
  seasonName: UapiSeasonName;
  seasonYear: Scalars['Int']['input'];
  seedProductCorrections?: InputMaybe<UapiCropAndSeedProductCorrectionInput>;
};

/** Colloquial name for a season.  For instance, a grower might describe a crop as being planted for the 2024 SPRING season. */
export enum UapiSeasonName {
  FALL = 'FALL',
  SAFRINHA = 'SAFRINHA',
  SPRING = 'SPRING',
  SUMMER = 'SUMMER',
  WINTER = 'WINTER'
}

/**
 * A set of products assigned a name, design, symbols and/or text to differentiate it from its competitors
 * ### Example
 * ```
 * {
 * "id": "537e024e-7779-4d05-8b6b-105757f45a24",
 * "name": "Wellman",
 * "dataSources": [],
 * "itemStatus": "ACTIVE",
 * "dataLegitimacy": "LEGITIMATE"
 * }
 * ```
 */
export type UapiSeedBrand = {
  __typename?: 'SeedBrand';
  dataLegitimacy: UapiDataLegitimacy;
  dataSources: Array<UapiSeedDataSource>;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  name: Scalars['String']['output'];
};

/**
 * An identifier for a data provider
 * ### Example
 * ```
 * {
 * "name": "CDMS",
 * "id: "207094a3-8e7c-4bef-a15b-356741e23852"
 * }
 * ```
 */
export type UapiSeedDataSource = {
  __typename?: 'SeedDataSource';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Return On Investment (ROI) Analysis Result for a Seed Density Trial. */
export type UapiSeedDensityTrialRoiResult = UapiNode & {
  __typename?: 'SeedDensityTrialRoiResult';
  /** Total additional cost of the seed product resulting from the higher seeding rate. */
  additionalCost: UapiMonetaryAmount;
  /** Total additional revenue resulting from higher seeding rate. */
  additionalRevenue: UapiMonetaryAmount;
  /** Additional volume of seeds resulting from the higher seeding rate. */
  additionalSeed: UapiMeasure;
  /** Additional yield resulting from  higher seeding rate. */
  additionalYield: UapiMeasure;
  auditMetadata: UapiAuditMetadata;
  /** Crop commodity price used for revenue calculation. */
  cropCommodityPrice: UapiUnitPrice;
  /** Harvesting evaluation result input for yield and revenue calculation. */
  harvestingEvaluationResult: UapiHarvestingEvaluationResult;
  id: Scalars['ID']['output'];
  /**
   * Paid product price.
   *   If paid product price is not provided by grower, the record will be null.
   */
  paidProductPrice?: Maybe<UapiPaidSeedProductPrice>;
  /** Planting evaluation result input for cost calculation. */
  plantingEvaluationResult: UapiPlantingEvaluationResult;
  /** Catalog Seed product price. */
  productPrice: UapiUnitPrice;
  /** Additional Revenue minus Additional Cost. */
  returnOnInvestment: UapiMonetaryAmount;
  /** Percentage increase comparing the Additional Revenue againt Additional Cost. */
  returnOnInvestmentPercent: UapiMeasure;
  version: Scalars['Int']['output'];
};

/** Aggregate Return On Investment Summary stats for a set of fields using Seed Density Trial. */
export type UapiSeedDensityTrialRoiResultStats = UapiRoiResultStats & {
  __typename?: 'SeedDensityTrialRoiResultStats';
  /**
   * Average additional yield resulting from higher seeding rate for fields in a field set.
   *
   *   Null if there is no ROI data for the set of fields.
   */
  averageAdditionalYield?: Maybe<UapiMeasure>;
  /**
   * Total additional cost of the seed product resulting from the higher seeding rate for the grower fields in a field set.
   *
   *   Null if there is no ROI data for the set of fields.
   */
  totalAdditionalCost?: Maybe<UapiMonetaryAmount>;
  /**
   * Total additional revenue resulting from higher seeding rate for the grower fields in a field set.
   *
   *   Null if there is no ROI data for the set of fields.
   */
  totalAdditionalRevenue?: Maybe<UapiMonetaryAmount>;
  /**
   * Total Return On Investment (ROI) for the grower fields in a field set.
   *
   *   Null if there is no ROI data for the set of fields.
   */
  totalRoi?: Maybe<UapiMonetaryAmount>;
};

/**
 * A plant seed sold as a product
 * #### Example:
 * ```graphql
 * {
 * "id": "050cd2c9-44c4-4fdb-a360-1f2e6b47c2b6",
 * "name": "Bravo",
 * "tenant": {
 * "id": "922a0a8d-5814-46e8-9191-73089cd0f4cc"
 * },
 * "itemStatus": "ACTIVE",
 * "dataLegitimacy": "LEGITIMATE"
 * "brand": {
 * "id": "537e024e-7779-4d05-8b6b-105757f45a24",
 * "name": "Wellman",
 * "itemStatus": "ACTIVE",
 * "dataLegitimacy": "LEGITIMATE"
 * },
 * "crop": {
 * "id": "537e024e-0000-0000-0000-105757f45a24",
 * "name": "Clover, Yellow",
 * "itemStatus": "ACTIVE",
 * "dataLegitimacy": "LEGITIMATE"
 * },
 * "traitStack": {
 * "id": "760c117a-d541-4dd6-b08e-96ad1df3f606",
 * "name": "product-trait-stacks/1Omhn60d70GOglE2gqdhwYEcw38",
 * "marketingName": "STS",
 * "abbreviation": "STS",
 * "commercialNames": [
 * {"name": "Sample TS1", "nameAbbreviation": "STS1", "country": "US"},
 * {"name": "Sample TS2", "nameAbbreviation": "STS2", "country": "CA"}
 * ],
 * "herbicideTolerances": ["Glufosinate", "Glyphosate"],
 * "insectProtections": ["Above Ground", "Below Ground"],
 * "itemStatus": "ACTIVE",
 * "dataLegitimacy": "LEGITIMATE"
 * },
 * "country": "US",
 * "relativeMaturity": {
 * "method":"HEAT_UNITS",
 * "value":"70",
 * "unit": "days"
 * },
 * "relevance": 0.73
 * }
 * ```
 */
export type UapiSeedProduct = UapiNode & {
  __typename?: 'SeedProduct';
  brand?: Maybe<UapiSeedBrand>;
  countries?: Maybe<Array<Scalars['CountryCode']['output']>>;
  crop?: Maybe<UapiCrop>;
  dataLegitimacy: UapiDataLegitimacy;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  name: Scalars['String']['output'];
  relativeMaturity?: Maybe<UapiRelativeMaturity>;
  relevance?: Maybe<Scalars['Float']['output']>;
  tenant: UapiOperation;
  traitStack?: Maybe<UapiTraitStack>;
};

/** The connection type for Seed Product result. */
export type UapiSeedProductConnection = {
  __typename?: 'SeedProductConnection';
  edges: Array<UapiSeedProductEdge>;
  nodes: Array<UapiSeedProduct>;
  pageInfo: UapiPageInfo;
};

/** Input type for a SeedProduct correction. */
export type UapiSeedProductCorrectionInput = {
  correctedSeedProductId: Scalars['ID']['input'];
  seedProductId: Scalars['ID']['input'];
};

/** An edge in a connection. */
export type UapiSeedProductEdge = {
  __typename?: 'SeedProductEdge';
  cursor: Scalars['String']['output'];
  node: UapiSeedProduct;
};

/**
 * Data for a planting event relating to a specific seed product.
 *
 * Units and timezones
 * - All fields except `plantingLocalDate` use ISO-standard units:
 * - `plantedArea` in hectares
 * - `averageSeedingRate` in seeds/hectare or kg/hectare
 * - `firstPlantedDateTime` and `lastPlantedDateTime` in UTC (ISO 8601)
 * - `plantingLocalDate` is derived from `firstPlantedDateTime` by converting that timestamp to the local timezone and
 * taking the calendar date.  The stored value is the local date with the time set to midnight in the local timezone
 * (00:00:00). This makes it easy to group events by the local planting date regardless of timezone.
 *
 * Example
 * - If `firstPlantedDateTime` = 2023-04-01T01:00:00Z and the local timezone is UTC-05:00:
 * - Local time = 2023-03-31T20:00:00-05:00
 * - `plantingLocalDate` = 2023-03-31T00:00:00-05:00 (midnight on March 31 in the local timezone)
 *
 * Source
 * - The `source` field identifies where the planting data originated (for example: "JOHN_DEERE_SYNC", "FIELDVIEW_DRIVE",
 * or another source).
 */
export type UapiSeedProductEvent = {
  __typename?: 'SeedProductEvent';
  averageSeedingRate: UapiMeasure;
  firstPlantedDateTime: Scalars['DateTime']['output'];
  lastPlantedDateTime: Scalars['DateTime']['output'];
  plantedArea: UapiMeasure;
  plantingLocalDate: Scalars['DateTime']['output'];
  seedProduct?: Maybe<UapiSeedProduct>;
  source: Scalars['String']['output'];
};

/** Input type to correct only the seed product / crop for a particular planting event. */
export type UapiSeedProductEventCorrectionInput = {
  /** omit if it the corrected seed product belongs to the same crop */
  correctedCropId?: InputMaybe<Scalars['ID']['input']>;
  correctedSeedProductId: Scalars['ID']['input'];
  cropId: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
  seasonName: UapiSeasonName;
  seasonYear: Scalars['Int']['input'];
  seedProductId: Scalars['ID']['input'];
};

/** A seed product favorite for a user. */
export type UapiSeedProductFavorite = UapiNode & {
  __typename?: 'SeedProductFavorite';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  notes: Array<UapiNote>;
  seedProduct?: Maybe<UapiSeedProduct>;
  seedingRate?: Maybe<UapiMeasure>;
  unitPrice?: Maybe<UapiPrice>;
  user?: Maybe<UapiUser>;
};

/** The connection type for SeedProductFavorite. */
export type UapiSeedProductFavoriteConnection = {
  __typename?: 'SeedProductFavoriteConnection';
  edges: Array<UapiSeedProductFavoriteEdge>;
  pageInfo: UapiPageInfo;
};

/** An edge in a connection. */
export type UapiSeedProductFavoriteEdge = {
  __typename?: 'SeedProductFavoriteEdge';
  cursor: Scalars['String']['output'];
  node: UapiSeedProductFavorite;
};

/** Filters available for retrieving seedProductFavorites. */
export type UapiSeedProductFavoritesFilter = {
  dataLegitimacy?: UapiDataLegitimacyQuery;
  itemStatuses?: InputMaybe<Array<UapiItemStatusQuery>>;
  updatedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  updatedSince?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['ID']['input'];
};

/** Filters available for retrieving seed products. */
export type UapiSeedProductFilter = {
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryCodes?: InputMaybe<Array<Scalars['CountryCode']['input']>>;
  cropId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * `search` searches over seed product name tokens. For example, this SeedProduct:
   *   Seed Product Name: P15100
   *   Brand: Pioneer
   *   Crop: Corn
   *   has the SeedProductToken
   *   CORN PIONEER P151OO (Those are the letter O not the number 0)
   *   so you can type "P15100", and get a match, or "Corn Pioneer P151" and it will be on the list of matches.
   */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Input specification for ordering seed products query results. */
export type UapiSeedProductOrderByInput = {
  direction?: InputMaybe<UapiOrderByDirection>;
  key: UapiSeedProductOrderByKey;
};

/** Fields by which results can be sorted. */
export enum UapiSeedProductOrderByKey {
  RELEVANCE = 'RELEVANCE',
  SEED_PRODUCT_NAME = 'SEED_PRODUCT_NAME'
}

/** Represents a seed product plan. */
export type UapiSeedProductPlan = {
  __typename?: 'SeedProductPlan';
  area?: Maybe<UapiMeasure>;
  planProductGroupName?: Maybe<Scalars['String']['output']>;
  seedProduct?: Maybe<UapiSeedProduct>;
  seedingRate?: Maybe<UapiMeasure>;
  units?: Maybe<UapiMeasure>;
};

/** Input type for a seed product plan. */
export type UapiSeedProductPlanInput = {
  area?: InputMaybe<UapiMeasureInput>;
  /**
   * Entering this string will cause a PlanProductGroup and/or PlanSeedProductSummary be to created
   *   if there is not one already. It will also keep PlanSeedProductSummary in sync with changes
   *   to this SeedProductPlan.
   */
  planProductGroupName?: InputMaybe<Scalars['String']['input']>;
  seedProductId: Scalars['ID']['input'];
  seedingRate?: InputMaybe<UapiMeasureInput>;
  units?: InputMaybe<UapiMeasureInput>;
};

/** Program Recommendation */
export type UapiSeedProductRecommendation = {
  __typename?: 'SeedProductRecommendation';
  id: Scalars['ID']['output'];
  season?: Maybe<UapiSeasonName>;
  seedProduct: UapiSeedProduct;
  year?: Maybe<Scalars['Int']['output']>;
};

/** Program Recommendation Connection */
export type UapiSeedProductRecommendationConnection = {
  __typename?: 'SeedProductRecommendationConnection';
  edges: Array<UapiSeedProductRecommendationEdge>;
  pageInfo: UapiPageInfo;
};

/** Program Recommendation Edge */
export type UapiSeedProductRecommendationEdge = {
  __typename?: 'SeedProductRecommendationEdge';
  cursor: Scalars['String']['output'];
  node: UapiSeedProductRecommendation;
};

/** Seed product recommendations preference for a user. */
export type UapiSeedProductRecommendationsPreference = UapiNode & {
  __typename?: 'SeedProductRecommendationsPreference';
  auditMetadata: UapiAuditMetadata;
  crop?: Maybe<UapiCrop>;
  dataLegitimacy: UapiDataLegitimacy;
  enabled: Scalars['Boolean']['output'];
  excludedProducts: Array<UapiSeedProduct>;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  products: Array<UapiSeedProduct>;
  relativeMaturityHigh: UapiMeasure;
  relativeMaturityLow: UapiMeasure;
  seasonName: UapiSeasonName;
  traitStackSelection: Array<UapiTraitStackSelection>;
  user?: Maybe<UapiUser>;
  year: Scalars['Int']['output'];
};

/** The connection type for SeedProductRecommendationsPreference. */
export type UapiSeedProductRecommendationsPreferenceConnection = {
  __typename?: 'SeedProductRecommendationsPreferenceConnection';
  edges: Array<UapiSeedProductRecommendationsPreferenceEdge>;
  pageInfo: UapiPageInfo;
};

/** An edge in a connection. */
export type UapiSeedProductRecommendationsPreferenceEdge = {
  __typename?: 'SeedProductRecommendationsPreferenceEdge';
  cursor: Scalars['String']['output'];
  node: UapiSeedProductRecommendationsPreference;
};

/** Filters available for retrieving SeedProductRecommendationsPreferences. */
export type UapiSeedProductRecommendationsPreferencesFilter = {
  cropId?: InputMaybe<Scalars['ID']['input']>;
  dataLegitimacy?: UapiDataLegitimacyQuery;
  itemStatuses?: InputMaybe<Array<UapiItemStatusQuery>>;
  seasonName?: InputMaybe<UapiSeasonName>;
  userId: Scalars['ID']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Seeding rate recommendation expressed in seed/hectare. */
export type UapiSeedingRateRecommendation = {
  __typename?: 'SeedingRateRecommendation';
  seedingRate: UapiMeasure;
};

/** Soil Failure Notification Data */
export type UapiSoilFailureNotificationData = UapiSoilNotificationData & {
  __typename?: 'SoilFailureNotificationData';
  /** List of soil sample fields */
  fields: Array<UapiSoilSampleField>;
  /** User who owns the fields */
  ownedBy: UapiUser;
  /** User who uploaded the samples */
  uploadedBy: UapiUser;
  /** Version for this notification data */
  version: Scalars['Int']['output'];
};

/** Soil Grower Notification Data */
export type UapiSoilGrowerNotificationData = UapiSoilNotificationData & {
  __typename?: 'SoilGrowerNotificationData';
  /** List of soil sample fields */
  fields: Array<UapiSoilSampleField>;
  /** User who uploaded the samples */
  uploadedBy: UapiUser;
  /** Version for this notification data */
  version: Scalars['Int']['output'];
};

/** Base interface for soil notifications */
export type UapiSoilNotificationData = {
  /** List of soil sample fields */
  fields: Array<UapiSoilSampleField>;
  /** Version for this notification data */
  version: Scalars['Int']['output'];
};

/** Soil Sample Field */
export type UapiSoilSampleField = {
  __typename?: 'SoilSampleField';
  /** Failure message if sample processing failed */
  failureMessage?: Maybe<Scalars['String']['output']>;
  /** Field */
  field: UapiField;
  /** The date on which the sample was taken. Formatted as "YYYY-MM-DD". */
  sampleDate: Scalars['Date']['output'];
};

/** Soil Uploader Notification Data */
export type UapiSoilUploaderNotificationData = UapiSoilNotificationData & {
  __typename?: 'SoilUploaderNotificationData';
  /** List of soil sample fields */
  fields: Array<UapiSoilSampleField>;
  /** User who owns the fields */
  ownedBy: UapiUser;
  /** Version for this notification data */
  version: Scalars['Int']['output'];
};

/** An enum to describe the direction that should be applied to the sorting of fields */
export enum UapiSortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

/**
 * Substance like NITROGEN or POTASSIUM and so on.
 *
 * ### Example
 * ```
 * {
 * "id": "8becb008-510c-40e8-b2a4-1c1283289023",
 * "name":"NITROGEN"
 * }
 * ```
 * Substances query will be exposed in future PI's
 */
export type UapiSubstance = {
  __typename?: 'Substance';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Properties of a target (e.g., Field) */
export type UapiTargetProperties = {
  __typename?: 'TargetProperties';
  /**
   * Optional average CCI when generating zones using CCI layers.
   *   This measure falls between 0 to 1.
   *   Returns null when generating zones with other types of data layers.
   */
  averageCCI?: Maybe<UapiMeasure>;
  /**
   * Optional average of normalized yield of a target (e.g., field).
   *   This measure is unitless and falls between 0 and 1.
   *   This is available when generating zones using either yield layers.
   *   Returns null when generating zones with other types of data layers.
   */
  averageNormalizedYield?: Maybe<UapiMeasure>;
};

/** Possible states of a task. */
export enum UapiTaskState {
  COMPLETE = 'COMPLETE',
  EXECUTING = 'EXECUTING',
  INCOMPLETE = 'INCOMPLETE',
  PENDING = 'PENDING'
}

/** Type for basic time interval. */
export type UapiTimeInterval = {
  __typename?: 'TimeInterval';
  end?: Maybe<Scalars['DateTime']['output']>;
  start: Scalars['DateTime']['output'];
};

/** Input type for TimeInterval. */
export type UapiTimeIntervalInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
};

/** A filter criteria representing the time to to arrive at a given growth stage. */
export type UapiTimeToGrowthStageFilter = {
  date: UapiDateRangeInput;
  growthStageId: Scalars['ID']['input'];
};

/**
 * A crop variety that has been engineered to express multiple desirable genetic traits
 * ### Example
 * ```
 * {
 * "id": "760c117a-d541-4dd6-b08e-96ad1df3f606",
 * "name": "product-trait-stacks/1Omhn60d70GOglE2gqdhwYEcw38",
 * "marketingName": "Sample Traitstack",
 * "abbreviation": "STS",
 * "commercialNames": [
 * {"name": "Sample TS1", "nameAbbreviation": "STS1", "country": "US"},
 * {"name": "Sample TS1", "nameAbbreviation": "STS2", "country": "CA"}
 * ],
 * "herbicideTolerances": ["Glufosinate", "Glyphosate"],
 * "insectProtections": ["Above Ground", "Below Ground"],
 * "itemStatus": "ACTIVE",
 * "dataLegitimacy": "LEGITIMATE"
 * }
 * ```
 */
export type UapiTraitStack = {
  __typename?: 'TraitStack';
  abbreviation: Scalars['String']['output'];
  commercialNames: Array<UapiTraitStackCommercialName>;
  dataLegitimacy: UapiDataLegitimacy;
  herbicideTolerances: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insectProtections: Array<Scalars['String']['output']>;
  itemStatus: UapiItemStatus;
  marketingName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/**
 * The localized trait stack naming data.
 * ### Example
 * ```
 * {
 * "name": "Sample TS",
 * "nameAbbreviation": "STS",
 * "country": "US"
 * }
 * ```
 */
export type UapiTraitStackCommercialName = {
  __typename?: 'TraitStackCommercialName';
  country: Scalars['CountryCode']['output'];
  name: Scalars['String']['output'];
  nameAbbreviation: Scalars['String']['output'];
};

/** Trait selection for recommendations preference. */
export type UapiTraitStackSelection = {
  __typename?: 'TraitStackSelection';
  selected: Scalars['Boolean']['output'];
  traitStack: UapiTraitStack;
};

/** Input type for create Trait Stack selection. */
export type UapiTraitStackSelectionInput = {
  selected: Scalars['Boolean']['input'];
  traitStackId: Scalars['ID']['input'];
};

/** The result of executing a trial request. */
export type UapiTrial = UapiNode & {
  __typename?: 'Trial';
  auditMetadata: UapiAuditMetadata;
  crop: UapiCrop;
  dataLegitimacy: UapiDataLegitimacy;
  designer?: Maybe<UapiTrialDesigner>;
  field: UapiField;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  seasonName: UapiSeasonName;
  status: UapiTrialStatus;
  statusReasons: Array<Scalars['String']['output']>;
  summary?: Maybe<UapiTrialSummary>;
  trialBlocks: Array<UapiTrialBlock>;
  type: UapiTrialType;
  year: Scalars['Int']['output'];
};


/** The result of executing a trial request. */
export type UapiTrialSummaryArgs = {
  filter?: UapiTrialSummaryFilter;
};

/** Agronomic artifact data related to the trial. */
export type UapiTrialAgronomicArtifact = {
  __typename?: 'TrialAgronomicArtifact';
  harvesting?: Maybe<UapiTrialHarvestingArtifact>;
  planting?: Maybe<UapiTrialPlantingArtifact>;
};

/** The whole representation of a trial on a field. */
export type UapiTrialBlock = UapiNode & {
  __typename?: 'TrialBlock';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  designer?: Maybe<UapiTrialDesigner>;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  status: UapiTrialBlockStatus;
  statusReasons: Array<Scalars['String']['output']>;
  trial: UapiTrial;
  trialUnits: Array<UapiTrialUnit>;
  type: UapiTrialBlockType;
};

/** Possible statuses of a trial. */
export enum UapiTrialBlockStatus {
  ELIMINATED = 'ELIMINATED',
  PENDING = 'PENDING',
  QUALIFIED = 'QUALIFIED',
  SELECTED = 'SELECTED'
}

/** Possible types of a trial block. */
export enum UapiTrialBlockType {
  /** A trial block with two units, one champion (control) zone and one challenger (treatment) zone. */
  CHAMPION_CHALLENGER_ZONES = 'CHAMPION_CHALLENGER_ZONES',
  /** A trial block with two units, one control and one treatment, in close proximity with one another. */
  DUET = 'DUET',
  /** A trial block with 2-n units, the geometries will be dictated by the traversals/products that were used. */
  SIDE_BY_SIDE_TRIAL_BLOCK = 'SIDE_BY_SIDE_TRIAL_BLOCK',
  /** A trial block with three units, one control and two treatments. */
  STRIP_TRIPLET = 'STRIP_TRIPLET'
}

/** The connection type for Trial. */
export type UapiTrialConnection = {
  __typename?: 'TrialConnection';
  edges: Array<UapiTrialEdge>;
  pageInfo: UapiPageInfo;
};

/** Defines all context required for a trial. */
export type UapiTrialContext = {
  __typename?: 'TrialContext';
  /** Whether the trial was manually created or not. */
  manualTrial: Scalars['Boolean']['output'];
  /** DateTime when the trials were shared. Null when not shared. */
  sharedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User or service that shared the trial context. Null when not shared. */
  sharedBy?: Maybe<UapiParty>;
  /** Whether or not the Trials have been shared with other relevant parties. */
  sharedTrial: Scalars['Boolean']['output'];
};

/** The designer of the trial. */
export type UapiTrialDesigner = UapiProgramInstance | UapiUser;

/** Input type for the designer. */
export type UapiTrialDesignerInput = {
  designerId: Scalars['ID']['input'];
  designerType: UapiTrialDesignerType;
};

/** Possible types of designers. */
export enum UapiTrialDesignerType {
  PROGRAM_INSTANCE = 'PROGRAM_INSTANCE',
  USER = 'USER'
}

/** An edge in a connection. */
export type UapiTrialEdge = {
  __typename?: 'TrialEdge';
  cursor: Scalars['String']['output'];
  node: UapiTrial;
};

/** Filter for Trial query. */
export type UapiTrialFilter = {
  dataLegitimacy?: InputMaybe<UapiDataLegitimacyQuery>;
  designerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fieldIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemStatuses?: InputMaybe<Array<UapiItemStatusQuery>>;
  seasonNames?: InputMaybe<Array<UapiSeasonName>>;
  types?: InputMaybe<Array<UapiTrialType>>;
  updatedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  updatedSince?: InputMaybe<Scalars['DateTime']['input']>;
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Trial artifact data aggregate for harvesting. */
export type UapiTrialHarvestingArtifact = {
  __typename?: 'TrialHarvestingArtifact';
  /** Harvesting data by seed product. */
  bySeedProduct: Array<UapiTrialHarvestingArtifactBySeedProduct>;
  crop: UapiCrop;
  /** Example: Measure(u: "percent", v: 15.5) */
  cropNominalMoisture?: Maybe<UapiMeasure>;
  /** Example: Measure(u: "pounds/bushel", v: 56) */
  cropNominalWeight?: Maybe<UapiMeasure>;
  data: UapiTrialHarvestingData;
};

/** Aggregated harvest data by Crop and SeedProduct. */
export type UapiTrialHarvestingArtifactBySeedProduct = {
  __typename?: 'TrialHarvestingArtifactBySeedProduct';
  data: UapiTrialHarvestingData;
  seedProduct?: Maybe<UapiSeedProduct>;
};

/** Trial harvesting data related to harvested crops. */
export type UapiTrialHarvestingData = {
  __typename?: 'TrialHarvestingData';
  /** [PHA] Harvested area. */
  area?: Maybe<UapiMeasure>;
  /** [PHA] Average yield. */
  averageYield?: Maybe<UapiMeasure>;
  /** [PHA] Total weight of yield. Result of multiplying 'averageYield' by 'area'. */
  dryWeight?: Maybe<UapiMeasure>;
  /**
   * If hasPha is not set, it is unknown if there are any adjustments or the data was manually entered.
   *   True if any type of PHA was applied like machine, field, crop.
   */
  hasPha?: Maybe<Scalars['Boolean']['output']>;
  /** [PHA] Total weight of water. */
  moistureMass?: Maybe<UapiMeasure>;
  /** [PHA] Calculated from: moistureMass / wetMass. */
  moistureRatio?: Maybe<Scalars['Float']['output']>;
  /** [PHA] Total weight of mass including moisture. */
  wetMass?: Maybe<UapiMeasure>;
};

/** Performance comparison between champion and challenger units in a trial. */
export type UapiTrialPerformanceComparison = {
  __typename?: 'TrialPerformanceComparison';
  challengerValue: UapiMeasure;
  championValue: UapiMeasure;
  difference: UapiMeasure;
  /** How the challenger performance compared to the champion performance. */
  percentChange: Scalars['Float']['output'];
};

/** Trial artifact data aggregate for planting. */
export type UapiTrialPlantingArtifact = {
  __typename?: 'TrialPlantingArtifact';
  crop: UapiCrop;
  data: Array<UapiTrialPlantingData>;
};

/** Trial planting data related to planted seed products. */
export type UapiTrialPlantingData = {
  __typename?: 'TrialPlantingData';
  area?: Maybe<UapiMeasure>;
  seedingRate?: Maybe<UapiMeasure>;
};

/** The result will either be an error or an output Trial */
export type UapiTrialResultOutput = UapiPrescriptionEnrolledHasNoCheckStrip | UapiPrescriptionEnrolledNotFound | UapiTrial;

/** The result of a trial. */
export enum UapiTrialStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

/** The results of performing the trial. */
export type UapiTrialSummary = {
  __typename?: 'TrialSummary';
  averageYieldComparison?: Maybe<UapiTrialPerformanceComparison>;
};

/** Filter for the summary on Trial. */
export type UapiTrialSummaryFilter = {
  trialBlockStatuses?: InputMaybe<Array<UapiTrialBlockStatus>>;
};

/** Possible types of a trial. */
export enum UapiTrialType {
  SEED_DENSITY = 'SEED_DENSITY',
  SPLIT_PLANT = 'SPLIT_PLANT'
}

/** A unit within a trial block. */
export type UapiTrialUnit = UapiNode & {
  __typename?: 'TrialUnit';
  agronomicArtifact?: Maybe<UapiTrialAgronomicArtifact>;
  area: UapiMeasure;
  auditMetadata: UapiAuditMetadata;
  centroid: Scalars['GeoJSONGeometry']['output'];
  dataLegitimacy: UapiDataLegitimacy;
  geometry: Scalars['GeoJSONGeometry']['output'];
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  role: UapiTrialUnitRole;
  /** Optional tags to help classify or add context to a trial unit. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  trialBlock: UapiTrialBlock;
};

/** Possible roles of a trial unit. */
export enum UapiTrialUnitRole {
  /** A new or hypothetical treatment being compared to the champion. */
  CHALLENGER = 'CHALLENGER',
  /** An established or default treatment. */
  CHAMPION = 'CHAMPION',
  /** Treatment role could not be determined. */
  INDETERMINATE = 'INDETERMINATE'
}

/**
 * Unit of Measurement Systems
 *
 * - SI: International System of Units
 * - IMPERIAL: Imperial System
 * - CANADA: Canadian Metric System
 */
export enum UapiUnitOfMeasurementSystem {
  CANADA = 'CANADA',
  IMPERIAL = 'IMPERIAL',
  SI = 'SI'
}

/**
 * Price of a unit.
 *
 * A unit may be a composite entity such as a Bag of 60 kgs.
 *
 * ### Example
 *
 * The price of 60 kgs of a seed product is represented as below.
 * The price per kg for this example will be 0.90 BRL.
 *
 * ```graphql
 * {
 * quantity: {
 * v: 60
 * u: "kg"
 * }
 * priceForQuantity: {
 * currencyCode: "BRL"
 * amount: "54.00"
 * }
 * }
 */
export type UapiUnitPrice = {
  __typename?: 'UnitPrice';
  priceForQuantity: UapiMonetaryAmount;
  quantity: UapiMeasure;
};

/** Input type for UnitPrice. */
export type UapiUnitPriceInput = {
  priceForQuantity: UapiMonetaryAmountInput;
  quantity: UapiMeasureInput;
};

/** Input type for updating a crop plan. */
export type UapiUpdateCropPlanInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  status: UapiCropPlanStatus;
};

/** Input type for updating a discount favorite. */
export type UapiUpdateDiscountFavoriteInput = {
  id: Scalars['ID']['input'];
  type?: InputMaybe<UapiDiscountFavoriteType>;
};

/** Input type for updating a field harvesting task. */
export type UapiUpdateFieldHarvestingTaskInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<UapiTaskState>;
};

/** Input type for updating a field plan. */
export type UapiUpdateFieldPlanInput = {
  id: Scalars['ID']['input'];
  itemStatus?: InputMaybe<UapiItemStatus>;
  plannedCropId?: InputMaybe<Scalars['ID']['input']>;
  previousCropId?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  targetYield?: InputMaybe<UapiMeasureInput>;
};

/** Input type for updating a field planting task. */
export type UapiUpdateFieldPlantingTaskInput = {
  alternateProducts?: InputMaybe<Array<UapiSeedProductPlanInput>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  method?: InputMaybe<UapiCreateEvaluationMethodInput>;
  plantingMethod?: InputMaybe<UapiPlantingMethod>;
  products?: InputMaybe<Array<UapiSeedProductPlanInput>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<UapiTaskState>;
  targetPlantingDate?: InputMaybe<Scalars['Date']['input']>;
};

/** Update grower program enrollment input. Sparse update. */
export type UapiUpdateGrowerProgramEnrollmentInput = {
  growerProgramEnrollmentId: Scalars['ID']['input'];
  needsAssistance?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Properties that can be supplied when updating a growth state observation. */
export type UapiUpdateGrowthStageObservationInput = {
  growthStageId?: InputMaybe<Scalars['ID']['input']>;
  growthStateObservationId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  observedOn?: InputMaybe<Scalars['Date']['input']>;
};

/** The growth state observations that were updated. */
export type UapiUpdateGrowthStageObservationResponse = {
  __typename?: 'UpdateGrowthStageObservationResponse';
  growthStateObservations?: Maybe<Array<UapiGrowthStageObservation>>;
};

/** Input type for updating the harvesting evaluation result. */
export type UapiUpdateHarvestingEvaluationResultInput = {
  /** To unset the recorded value, request should pass null value for evaluationOffer. If the field is not included, recorded value will not be updated. */
  evaluationOffer?: InputMaybe<UapiProgramOfferType>;
  id: Scalars['ID']['input'];
  /** To avoid updates, do not include manual rule results in the input. */
  manualRuleResults?: InputMaybe<Array<UapiManualRuleResultInput>>;
  status: UapiEvaluationStatus;
  statusReasons: Array<Scalars['String']['input']>;
};

/** Input type for update Note. */
export type UapiUpdateNoteInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** Input type for updating a party relationship. */
export type UapiUpdatePartyRelationshipInput = {
  itemStatus?: InputMaybe<UapiItemStatus>;
  objectPartyId: Scalars['ID']['input'];
  qualifier?: InputMaybe<Scalars['String']['input']>;
  relationshipTypeId: Scalars['ID']['input'];
  subjectPartyId: Scalars['ID']['input'];
};

/** Input type for updating a group entry that represents a free from product. */
export type UapiUpdatePlanAdditionalProductSummaryInput = {
  id: Scalars['ID']['input'];
  unitPrice?: InputMaybe<UapiPriceInput>;
  units?: InputMaybe<UapiMeasureInput>;
};

/**
 * Input type for updating a discount.
 *
 * Note: Requires one and only one of percentage, price or pricePerUnit to be set.
 */
export type UapiUpdatePlanDiscountInput = {
  id: Scalars['ID']['input'];
  percentage?: InputMaybe<UapiMeasureInput>;
  price?: InputMaybe<UapiPriceInput>;
  pricePerUnit?: InputMaybe<UapiPricePerUnitInput>;
};

/** Input type for updating a group entry that represents a seed product. */
export type UapiUpdatePlanSeedProductSummaryInput = {
  area?: InputMaybe<UapiMeasureInput>;
  id: Scalars['ID']['input'];
  seedingRate?: InputMaybe<UapiMeasureInput>;
  unitPrice?: InputMaybe<UapiPriceInput>;
  units?: InputMaybe<UapiMeasureInput>;
};

/** Input type for updating the planting evaluation result. */
export type UapiUpdatePlantingEvaluationResultInput = {
  /** To unset the recorded value, request should pass null value for evaluationOffer. If the field is not included, recorded value will not be updated. */
  evaluationOffer?: InputMaybe<UapiProgramOfferType>;
  id: Scalars['ID']['input'];
  /** To avoid updates, do not include manual rule results in the input. */
  manualRuleResults?: InputMaybe<Array<UapiManualRuleResultInput>>;
  status: UapiEvaluationStatus;
  statusReasons: Array<Scalars['String']['input']>;
};

/** Input to update a prescription as primary */
export type UapiUpdatePrescriptionAsPrimaryInput = {
  fieldId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

/** Input type for updating a PrescriptionContext's approval related fields. */
export type UapiUpdatePrescriptionContextApprovalInput = {
  approvalAt?: InputMaybe<Scalars['DateTime']['input']>;
  approvalById?: InputMaybe<Scalars['ID']['input']>;
  approvalStatus: UapiPrescriptionApprovalStatus;
  approvalStatusReason?: InputMaybe<Scalars['String']['input']>;
  fieldPlantingTaskId: Scalars['ID']['input'];
};

/** Input type for updating a PrescriptionContext's prescription generation related fields. */
export type UapiUpdatePrescriptionContextGenerationInput = {
  fieldPlantingTaskId: Scalars['ID']['input'];
  generationStatus: UapiPrescriptionGenerationStatus;
  generationStatusReason?: InputMaybe<Scalars['String']['input']>;
  /** If the prescriptionId is changed, shared and approval statuses will be automatically reset. */
  prescriptionId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Seed product price used for prescription generation.
   *
   *   If seed product price is not supplied, the value is not updated.
   *   Seed product price may be null, prescription was generated using yield optimal strategy.
   */
  seedProductPrice?: InputMaybe<UapiUnitPriceInput>;
};

/**
 * Input to update a prescription's program instance.
 * itemStatus is optional to enable/disable prescription's visibility to grower (Status is not updated if not provided)
 */
export type UapiUpdatePrescriptionProgramInstanceInput = {
  itemStatus?: InputMaybe<UapiItemStatus>;
  prescriptionId: Scalars['ID']['input'];
  programInstanceId: Scalars['ID']['input'];
};

/** Input to update a prescription's program status to ACTIVE (enables visibility to grower) */
export type UapiUpdatePrescriptionProgramStatusInput = {
  fieldId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

/** Input type for updating a Program. */
export type UapiUpdateProgramInput = {
  countryCodes: Array<Scalars['CountryCode']['input']>;
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  iconUrl?: InputMaybe<Scalars['URL']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Input type for updating a program instance. */
export type UapiUpdateProgramInstanceInput = {
  challengerSeedBrandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  championSeedBrandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryCode: Scalars['CountryCode']['input'];
  cropIds: Array<Scalars['ID']['input']>;
  displayName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  temporalPeriod: UapiProgramTemporalPeriodInput;
  timeInterval: UapiTimeIntervalInput;
};

/** Input type for updating a program instance stage. */
export type UapiUpdateProgramInstanceStageInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input type for updating an existing protocol. */
export type UapiUpdateProtocolInput = {
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Input type for updating a protocol ruleset association. */
export type UapiUpdateProtocolRulesetInput = {
  id: Scalars['ID']['input'];
  rulesetId: Scalars['ID']['input'];
  rulesetType: UapiRulesetType;
};

/** Input type for updating the seed brands affiliated with an advisor. */
export type UapiUpdateSeedBrandAffiliationsInput = {
  seedBrandIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

/** Input type for updating a seed product favorite. */
export type UapiUpdateSeedProductFavoriteInput = {
  id: Scalars['ID']['input'];
  seedingRate?: InputMaybe<UapiMeasureInput>;
  unitPrice?: InputMaybe<UapiPriceInput>;
};

/** Input type for update SeedProductRecommendationsPreference. */
export type UapiUpdateSeedProductRecommendationsPreferenceInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  excludedProductIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  relativeMaturityHigh?: InputMaybe<UapiMeasureInput>;
  relativeMaturityLow?: InputMaybe<UapiMeasureInput>;
  traitStackSelection?: InputMaybe<Array<UapiTraitStackSelectionInput>>;
};

/** Input to update a TrialBlock. */
export type UapiUpdateTrialBlockInput = {
  id: Scalars['ID']['input'];
  status?: InputMaybe<UapiTrialBlockStatus>;
  statusReasons?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input type to update a Trial. */
export type UapiUpdateTrialInput = {
  id: Scalars['ID']['input'];
  status?: InputMaybe<UapiTrialStatus>;
  statusReasons?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input type for updating a user group assignment. */
export type UapiUpdateUserGroupAssignmentInput = {
  groupId: Scalars['String']['input'];
  itemStatus: UapiItemStatus;
  userId: Scalars['ID']['input'];
};

/** Response type for updateUserGroupAssignment mutation */
export type UapiUpdateUserGroupAssignmentResponse = {
  __typename?: 'UpdateUserGroupAssignmentResponse';
  /** Indicates whether the mutation was successful */
  success: Scalars['Boolean']['output'];
  userGroupAssignment?: Maybe<UapiUserGroupAssignment>;
};

/** Input type to update MFAEnrollment status for an user */
export type UapiUpdateUserMfaEnrollmentStatusInput = {
  mfaEnrollmentStatus: UapiMfaEnrollmentStatus;
  userId: Scalars['ID']['input'];
};

/**
 * Input type for upserting a discount.
 *
 * Note: If an id is not provided (i.e. null) the operation is treated as an insert.
 * Requires one and only one of percentage, price or pricePerUnit to be set.
 */
export type UapiUpsertPlanDiscountInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  percentage?: InputMaybe<UapiMeasureInput>;
  price?: InputMaybe<UapiPriceInput>;
  pricePerUnit?: InputMaybe<UapiPricePerUnitInput>;
  productGroupId: Scalars['ID']['input'];
};

/** This represents a fieldview User, either a grower or any other user types. */
export type UapiUser = UapiNode & UapiParty & {
  __typename?: 'User';
  address: UapiUserAddress;
  advisorSettings?: Maybe<UapiAdvisorSettings>;
  /** The user's crop plan specific preferences. */
  cropPlanPreferences: UapiCropPlanPreferences;
  dataLegitimacy: UapiDataLegitimacy;
  /** User email */
  email: Scalars['String']['output'];
  /** User email verification status */
  emailVerificationStatus: UapiEmailVerificationStatus;
  /** This field tells if user was deactivated */
  enabled: Scalars['Boolean']['output'];
  /** User first name */
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  /** User last name */
  lastName: Scalars['String']['output'];
  legacyId: Scalars['ID']['output'];
  logo?: Maybe<UapiLogo>;
  /** User full name, this is the add of firstName + lastName */
  name: Scalars['String']['output'];
  /**
   * Returns party relationships for the given relationship type.
   *   - Requires PartyRelationshipTypeQuery. The response is an array with no null elements.
   */
  partyRelationships: Array<UapiPartyRelationship>;
  /**
   * UserPreference object that holds the user's preferences related to notifications,
   *   settings, or other customizable options.
   */
  preferences: UapiUserPreference;
  /** The grower program enrollments linked to the user. */
  programEnrollments: Array<UapiGrowerProgramEnrollment>;
  /** The group assignments for the user. */
  userGroupAssignments: Array<UapiUserGroupAssignment>;
};


/** This represents a fieldview User, either a grower or any other user types. */
export type UapiUserPartyRelationshipsArgs = {
  filter?: InputMaybe<UapiPartyRelationshipsFilter>;
  relationshipType: UapiPartyRelationshipTypeQuery;
};


/** This represents a fieldview User, either a grower or any other user types. */
export type UapiUserProgramEnrollmentsArgs = {
  programInstanceIds: Array<Scalars['ID']['input']>;
};


/** This represents a fieldview User, either a grower or any other user types. */
export type UapiUserUserGroupAssignmentsArgs = {
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  userGroupIds: Array<Scalars['String']['input']>;
};

/** Represents a user's address details including country, administrative division, and city. */
export type UapiUserAddress = {
  __typename?: 'UserAddress';
  /** User city */
  city?: Maybe<Scalars['String']['output']>;
  /** User country code */
  countryCode: Scalars['CountryCode']['output'];
  /** User first administrative division code (e.g. state) */
  firstAdministrativeDivisionCode?: Maybe<Scalars['String']['output']>;
};

/** Connection Type for Users. */
export type UapiUserConnection = {
  __typename?: 'UserConnection';
  edges: Array<UapiUserEdge>;
  pageInfo: UapiPageInfo;
};

/** An edge in a connection. */
export type UapiUserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: UapiUser;
};

/** Search filters for queries on users. */
export type UapiUserFilter = {
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  dataLegitimacy?: InputMaybe<UapiDataLegitimacyQuery>;
  itemStatus?: InputMaybe<UapiItemStatusQuery>;
  /** A prefix to search for at the beginning of the first name, last name, username, or email. Must be at least 3 characters. */
  namePrefix?: InputMaybe<Scalars['String']['input']>;
  /** A substring to search for within the first and last name. Must be at least 3 characters. */
  nameSubstring?: InputMaybe<Scalars['String']['input']>;
  updatedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  updatedSince?: InputMaybe<Scalars['DateTime']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** This represents a collection of users who share the same role or set of permissions. */
export type UapiUserGroup = {
  __typename?: 'UserGroup';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy: UapiDataLegitimacy;
  id: Scalars['String']['output'];
  itemStatus: UapiItemStatus;
  /** The organizational role or job function associated with the group */
  role: Scalars['String']['output'];
  /** The party that owns the user group */
  tenant: UapiParty;
};

/** This represents the assignment of a user to a group. */
export type UapiUserGroupAssignment = {
  __typename?: 'UserGroupAssignment';
  auditMetadata: UapiAuditMetadata;
  dataLegitimacy?: Maybe<UapiDataLegitimacy>;
  /** The group to which the user is assigned */
  group: UapiUserGroup;
  id: Scalars['ID']['output'];
  itemStatus: UapiItemStatus;
  /** The user that is assigned to the group */
  user: UapiUser;
};

/** Connection Type for User Group Assignments. */
export type UapiUserGroupAssignmentConnection = {
  __typename?: 'UserGroupAssignmentConnection';
  edges: Array<UapiUserGroupAssignmentEdge>;
  pageInfo: UapiPageInfo;
};

/** An edge in a connection. */
export type UapiUserGroupAssignmentEdge = {
  __typename?: 'UserGroupAssignmentEdge';
  cursor: Scalars['String']['output'];
  node: UapiUserGroupAssignment;
};

/** Search filters for queries on user group assignments. */
export type UapiUserGroupAssignmentFilter = {
  dataLegitimacy?: InputMaybe<UapiDataLegitimacyQuery>;
  groupIds: Array<Scalars['String']['input']>;
  itemStatus?: InputMaybe<UapiItemStatusQuery>;
  updatedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  updatedSince?: InputMaybe<Scalars['DateTime']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Represents a Notification sent to a user. */
export type UapiUserNotification = UapiNode & {
  __typename?: 'UserNotification';
  /** The notification type */
  alertType: UapiAlertType;
  /** The time this notification was created */
  createdAt: Scalars['DateTime']['output'];
  /** Notification data payload */
  data: UapiUserNotificationData;
  /** The identity of this notification */
  id: Scalars['ID']['output'];
  /**
   * The last time this notification was read.
   *   Will be null if if this notification has not been read.
   */
  readTime?: Maybe<Scalars['DateTime']['output']>;
  /** A short message that is intended to be displayed to the user. */
  text: Scalars['String']['output'];
  /** The last time that this notification was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The user this notification is intended for */
  user: UapiUser;
};

/** Represents Notification data variants. */
export type UapiUserNotificationData = UapiDataInboxNotificationData | UapiHailNotificationData | UapiImageryNotificationData | UapiNonSatImageryNotificationData | UapiNonSatImageryRequiresAttentionNotificationData | UapiPrecipNotificationData | UapiSoilFailureNotificationData | UapiSoilGrowerNotificationData | UapiSoilUploaderNotificationData;

/** Sort columns for queries on users. */
export enum UapiUserOrderBy {
  NAME = 'NAME',
  UPDATED_AT = 'UPDATED_AT'
}

/** Input specification for ordering user query results. */
export type UapiUserOrdering = {
  by: UapiUserOrderBy;
  direction?: InputMaybe<UapiOrderByDirection>;
};

/**
 * UserPreference represents the customizable preferences associated with a user in the system.
 * This type allows users to specify their preferred settings, which can enhance their experience and
 * tailor the application to their needs.
 */
export type UapiUserPreference = {
  __typename?: 'UserPreference';
  mfaEnrollmentStatus: UapiMfaEnrollmentStatus;
  /**
   * The name of the template used for units of measure preferences, allowing users to
   *   select their preferred system of measurement (e.g., metric or imperial).
   */
  unitsOfMeasureTemplateName?: Maybe<Scalars['String']['output']>;
};

/** User Aggregation Context Keyset Pattern */
export type UapiUsersAck = {
  __typename?: 'UsersACK';
  users: UapiUserConnection;
};


/** User Aggregation Context Keyset Pattern */
export type UapiUsersAckUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UapiUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Array<UapiUserOrdering>>;
};

/** Field enrollment configuration for VAlora program. */
export type UapiVAloraFieldEnrollmentConfiguration = {
  __typename?: 'VAloraFieldEnrollmentConfiguration';
  enrolledOffer: UapiProgramOfferType;
  nitrogenPrescription: Scalars['Boolean']['output'];
};

/** Input parameters when enrolling a field in the VAlora program. */
export type UapiVAloraFieldEnrollmentDetailsInput = {
  /** The crop planted in previous years. */
  historicalCrops: Array<UapiHistoricalCropYearInput>;
  /** Whether a nitrogen prescription should be generated for the field. */
  nitrogenPrescription: Scalars['Boolean']['input'];
  /** The corn hybrid seed product that will planted. */
  seedProductId: Scalars['ID']['input'];
  /** The planned seed density (in seed/hectare). */
  seedingRate: UapiMeasureInput;
  /** Whether a risk sharing prescription should be generated for the field. */
  shareRisk: Scalars['Boolean']['input'];
  /** The target planting date. */
  targetPlantingDate: Scalars['Date']['input'];
  /** The field historical yield (in kilogram/hectare). */
  targetYield: UapiMeasureInput;
  /** Whether the field will be planted with a variable rate planter. */
  variableRate: Scalars['Boolean']['input'];
};

/**
 * Filter to Specify all enrollmentStatuses to be grouped on and for which grower enrollment.
 * enrollmentStatuses defaults to empty list which returns all enrollmentStatuses.
 */
export type UapiWithOperationFieldsHavingProgramEnrollmentsByEnrollmentStatusFilter = {
  dataLegitimacy?: UapiDataLegitimacyQuery;
  enrollmentStatuses?: Array<UapiFieldProgramEnrollmentStatus>;
  growerProgramEnrollmentId: Scalars['ID']['input'];
  itemStatus?: UapiItemStatusQuery;
};

/** Filters available for retrieving grower program enrollments. */
export type UapiWithUsersHavingProgramEnrollmentsFilter = {
  dataLegitimacy?: UapiDataLegitimacyQuery;
  /** Filter the results by enrollment statuses. */
  enrollmentStatuses?: InputMaybe<Array<UapiGrowerProgramEnrollmentStatusQuery>>;
  itemStatus?: UapiItemStatusQuery;
  /** Filter the results by program instances. */
  programInstanceIds: Array<Scalars['ID']['input']>;
};

/** Zone */
export type UapiZone = {
  area: UapiMeasure;
  geometry: Scalars['GeoJSONGeometry']['output'];
  id: Scalars['ID']['output'];
  isCheckStrip: Scalars['Boolean']['output'];
};

/** Individual zonal feature object with geometric information and additional property information */
export type UapiZoneFeature = {
  __typename?: 'ZoneFeature';
  geometry: Scalars['GeoJSONGeometry']['output'];
  properties: UapiZoneProperties;
  /**
   * The ZoneFeature type corresponds to a GeoJSON type, which is defined using PascalCase naming conventions.
   *   For detailed information about the GeoJSON types, please refer to the IETF RFC 7946 documentation available at:
   *   https://datatracker.ietf.org/doc/html/rfc7946#section-1.4.
   */
  type: Scalars['String']['output'];
};

/** Collection of available yield data for a given field */
export type UapiZoneGenerationAvailableData = {
  __typename?: 'ZoneGenerationAvailableData';
  cciLayers: Array<UapiZoneGenerationCciLayer>;
  id: Scalars['ID']['output'];
  status: UapiItemStatus;
  yieldLayers: Array<UapiZoneGenerationYieldLayer>;
};

/** Defines a connection type for zone generation available data, including edges for pagination and page information */
export type UapiZoneGenerationAvailableDataConnection = {
  __typename?: 'ZoneGenerationAvailableDataConnection';
  edges: Array<UapiZoneGenerationAvailableDataEdge>;
  pageInfo: UapiPageInfo;
};

/** Represents an edge in a connection, allowing for pagination of available data */
export type UapiZoneGenerationAvailableDataEdge = {
  __typename?: 'ZoneGenerationAvailableDataEdge';
  cursor: Scalars['String']['output'];
  node: UapiZoneGenerationAvailableData;
};

/** Object to encapsulate filtering options for zone availability */
export type UapiZoneGenerationAvailableDataFilter = {
  cropIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  seasons?: InputMaybe<Array<UapiSeasonName>>;
  showOnlyUsableLayers?: InputMaybe<Scalars['Boolean']['input']>;
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Representation of a single layer of Climate Crop Index (CCI) data */
export type UapiZoneGenerationCciLayer = {
  __typename?: 'ZoneGenerationCCILayer';
  eventDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageryThumbnailUrl?: Maybe<Scalars['String']['output']>;
  isUsable: Scalars['Boolean']['output'];
  season?: Maybe<UapiSeasonName>;
  year: Scalars['Int']['output'];
};

/** Input information associated with available-data request to determine which CCI layers to use for zone generation */
export type UapiZoneGenerationCciLayerInput = {
  /** Optional list of layers by ID to filter available CCI data (nullable) */
  layers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional list of seasons to filter available CCI data (nullable) */
  seasons?: InputMaybe<Array<UapiSeasonName>>;
  /** Optional list of years to filter available CCI data (nullable) */
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Input object to specify the field on which we want to run the zone generation process */
export type UapiZoneGenerationTarget = {
  id: Scalars['ID']['input'];
  type: UapiZoneGenerationTargetType;
};

/** Options for objects on which we can perform zone generation (support for additional types will be added in later PIs) */
export enum UapiZoneGenerationTargetType {
  FIELD = 'FIELD'
}

/** Representation of a single layer of yield data */
export type UapiZoneGenerationYieldLayer = {
  __typename?: 'ZoneGenerationYieldLayer';
  /** Average yield for the yield data layer. This value may be null if poor data quality prevents a valid average yield computation. */
  averageYield?: Maybe<UapiMeasure>;
  cropId: Scalars['ID']['output'];
  eventDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageryThumbnailUrl?: Maybe<Scalars['String']['output']>;
  isUsable: Scalars['Boolean']['output'];
  season: UapiSeasonName;
  year: Scalars['Int']['output'];
};

/** Input information associated with available-data request to determine which yield layers to use for zone generation */
export type UapiZoneGenerationYieldLayerInput = {
  /** Optional list of cropIds to filter available yield data (nullable) */
  cropIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional list of layers by ID to filter available yield data (nullable) */
  layers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional list of seasons to filter available yield data (nullable) */
  seasons?: InputMaybe<Array<UapiSeasonName>>;
  /** Optional list of years to filter available yield data (nullable) */
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Zone Metadata */
export type UapiZoneMetadata = {
  totalArea: UapiMeasure;
  totalAreaNoCheckStrip: UapiMeasure;
  totalNumZones: Scalars['Int']['output'];
};

/** Choice of Science model to use for zone generation (currently only the Yield and CCI models are available; future models will be added in later PIs) */
export enum UapiZoneModel {
  CCI = 'CCI',
  YIELD = 'YIELD'
}

/** Zone-level properties object */
export type UapiZoneProperties = {
  __typename?: 'ZoneProperties';
  /** Area of the zone */
  area: UapiMeasure;
  /**
   * Optional average CCI when generating zones using CCI layers.
   *   This measure falls between 0 to 1.
   *   Returns null when generating zones with other types of data layers.
   */
  averageCCI?: Maybe<UapiMeasure>;
  /** @deprecated Please use averageCCI instead */
  averageCci?: Maybe<UapiMeasure>;
  /**
   * Optional average of normalized yield of a zone.
   *   This measure is unitless and falls between 0 and 1.
   *   This is available when generating zones using either yield.
   *   Returns null when generating zones with other types of data layers.
   */
  averageNormalizedYield?: Maybe<UapiMeasure>;
  /** @deprecated Use averageNormalizedYield instead */
  averageYield?: Maybe<UapiMeasure>;
  id: Scalars['ID']['output'];
  /** Zone that has insufficient data for clustering */
  isDeadZone: Scalars['Boolean']['output'];
  /**
   * Optional relative productivity of a zone over the whole field.
   *   This measure is in percentage.
   *   This is available when generating zones using either yield or CCI layers.
   *   Returns null when generating zones with other types of data layers.
   */
  relativeProductivity?: Maybe<UapiMeasure>;
  /**
   * Optional average yield per crop when generating zones using yield layers.
   *   Returns null when generating zones with other types of data layers.
   */
  yieldPerCrop?: Maybe<Array<UapiZoneYieldPerCrop>>;
  /** @deprecated Please use relativeProductivity instead */
  yieldProductivity?: Maybe<UapiMeasure>;
};

/** Object representing a full zone-set generated by autozones-orchestrator */
export type UapiZoneSet = {
  __typename?: 'ZoneSet';
  features: Array<UapiZoneFeature>;
  id: Scalars['ID']['output'];
  numZones: Scalars['Int']['output'];
  status: UapiItemStatus;
  /**
   * Properties of a target (e.g., field) after a zone generation process is complete.
   *   It can be null when the process is not done.
   */
  targetProperties?: Maybe<UapiTargetProperties>;
};

/** Zone-level yield per crop */
export type UapiZoneYieldPerCrop = {
  __typename?: 'ZoneYieldPerCrop';
  averageYield: UapiMeasure;
  crop: UapiCrop;
};

export type UapiGetFieldLayersQueryVariables = Exact<{
  fieldId: Scalars['ID']['input'];
  activityType: UapiAgronomicActivityType;
  seasonName: UapiSeasonName;
  cropId: Scalars['ID']['input'];
  seasonYear: Scalars['Int']['input'];
  backendMachineDataSource: UapiBackendMachineDataSource;
}>;


export type UapiGetFieldLayersQuery = { __typename?: 'Query', field?: { __typename?: 'Field', name: string, machineDataMaps?: { __typename?: 'MachineDataMaps', maps: Array<{ __typename?: 'MachineDataMap', name: UapiMachineDataMapName, assets: Array<{ __typename?: 'RasterTileset', thumbnailUrl?: string | null, version?: string | null, tileUrlTemplate: string, source: UapiGeospatialAssetSource, legend: { __typename: 'GeospatialAssetLegend', units?: string | null, items: Array<
              | { __typename: 'CategoricalGeospatialAssetLegendItem', label: string, color: { __typename?: 'RGBA', alpha?: number | null, blue: number, green: number, red: number } }
              | { __typename: 'ContinuousGeospatialAssetLegendItem', min?: number | null, max?: number | null, color: { __typename?: 'RGBA', alpha?: number | null, blue: number, green: number, red: number } }
            > } }> }> } | null } | null };

export type UapiGetHarvestEventAggregatesArdQueryVariables = Exact<{
  fieldUuid: Scalars['ID']['input'];
}>;


export type UapiGetHarvestEventAggregatesArdQuery = { __typename?: 'Query', field?: { __typename?: 'Field', id: string, harvestEventAggregates?: { __typename?: 'HarvestEventAggregates', eventsByCropSeason?: Array<{ __typename?: 'HarvestEventByCropSeason', seasonName: UapiSeasonName, seasonYear: number, legacySeasonTag?: string | null, crop: { __typename?: 'Crop', id: string, name: string }, harvestedArea: { __typename?: 'Measure', u?: string | null, v: number }, nominalWeight?: { __typename?: 'Measure', u?: string | null, v: number } | null, wetMass?: { __typename?: 'Measure', u?: string | null, v: number } | null, moistureMass?: { __typename?: 'Measure', u?: string | null, v: number } | null, dryMass: { __typename?: 'Measure', u?: string | null, v: number }, averageStdYield: { __typename?: 'Measure', u?: string | null, v: number }, averageWetYield?: { __typename?: 'Measure', u?: string | null, v: number } | null, moisturePercent?: { __typename?: 'Measure', u?: string | null, v: number } | null }> | null } | null } | null };

export type UapiGetPlantingEventAggregatesArdQueryVariables = Exact<{
  fieldId: Scalars['ID']['input'];
}>;


export type UapiGetPlantingEventAggregatesArdQuery = { __typename?: 'Query', field?: { __typename?: 'Field', id: string, plantingEventAggregates?: { __typename?: 'PlantingEventAggregates', eventsByCropSeason?: Array<{ __typename?: 'PlantingEventByCropSeason', seasonName: UapiSeasonName, seasonYear: number, firstPlantingLocalDate: string, lastPlantingLocalDate: string, crop: { __typename?: 'Crop', id: string, name: string }, plantedArea: { __typename?: 'Measure', u?: string | null, v: number }, averageSeedingRate?: { __typename?: 'Measure', u?: string | null, v: number } | null, seedProductEvents: Array<{ __typename?: 'SeedProductEvent', plantingLocalDate: string, source: string, seedProduct?: { __typename?: 'SeedProduct', id: string, name: string } | null, plantedArea: { __typename?: 'Measure', u?: string | null, v: number }, averageSeedingRate: { __typename?: 'Measure', u?: string | null, v: number } }> }> | null } | null } | null };


export const GetFieldLayersDocument = `
    query getFieldLayers($fieldId: ID!, $activityType: AgronomicActivityType!, $seasonName: SeasonName!, $cropId: ID!, $seasonYear: Int!, $backendMachineDataSource: BackendMachineDataSource!) {
  field(id: $fieldId) {
    name
    machineDataMaps(
      cropId: $cropId
      seasonName: $seasonName
      seasonYear: $seasonYear
      activityType: $activityType
      backendMachineDataSource: $backendMachineDataSource
    ) {
      maps {
        name
        assets {
          ... on RasterTileset {
            thumbnailUrl
            version
            tileUrlTemplate
            source
            legend {
              __typename
              items {
                ... on CategoricalGeospatialAssetLegendItem {
                  __typename
                  color {
                    alpha
                    blue
                    green
                    red
                  }
                  label
                }
                ... on ContinuousGeospatialAssetLegendItem {
                  __typename
                  min
                  max
                  color {
                    alpha
                    blue
                    green
                    red
                  }
                }
              }
              units
            }
          }
        }
      }
    }
  }
}
    `;
export const GetHarvestEventAggregatesArdDocument = `
    query getHarvestEventAggregatesArd($fieldUuid: ID!) {
  field(id: $fieldUuid) {
    id
    harvestEventAggregates {
      eventsByCropSeason(backendMachineDataSource: COMBINED) {
        crop {
          id
          name
        }
        seasonName
        seasonYear
        legacySeasonTag
        harvestedArea {
          u
          v
        }
        nominalWeight {
          u
          v
        }
        wetMass {
          u
          v
        }
        moistureMass {
          u
          v
        }
        dryMass {
          u
          v
        }
        averageStdYield {
          u
          v
        }
        averageWetYield {
          u
          v
        }
        moisturePercent {
          u
          v
        }
      }
    }
  }
}
    `;
export const GetPlantingEventAggregatesArdDocument = `
    query getPlantingEventAggregatesArd($fieldId: ID!) {
  field(id: $fieldId) {
    id
    plantingEventAggregates {
      eventsByCropSeason(backendMachineDataSource: COMBINED) {
        crop {
          id
          name
        }
        seasonName
        seasonYear
        plantedArea {
          u
          v
        }
        averageSeedingRate {
          u
          v
        }
        firstPlantingLocalDate
        lastPlantingLocalDate
        seedProductEvents {
          seedProduct {
            id
            name
          }
          plantedArea {
            u
            v
          }
          averageSeedingRate {
            u
            v
          }
          plantingLocalDate
          source
        }
      }
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getFieldLayers(variables: UapiGetFieldLayersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<{ data: UapiGetFieldLayersQuery; errors?: GraphQLError[]; extensions?: any; headers: Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<UapiGetFieldLayersQuery>(GetFieldLayersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getFieldLayers', 'query', variables);
    },
    getHarvestEventAggregatesArd(variables: UapiGetHarvestEventAggregatesArdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<{ data: UapiGetHarvestEventAggregatesArdQuery; errors?: GraphQLError[]; extensions?: any; headers: Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<UapiGetHarvestEventAggregatesArdQuery>(GetHarvestEventAggregatesArdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getHarvestEventAggregatesArd', 'query', variables);
    },
    getPlantingEventAggregatesArd(variables: UapiGetPlantingEventAggregatesArdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<{ data: UapiGetPlantingEventAggregatesArdQuery; errors?: GraphQLError[]; extensions?: any; headers: Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<UapiGetPlantingEventAggregatesArdQuery>(GetPlantingEventAggregatesArdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPlantingEventAggregatesArd', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;